import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import {
  HTTPResponse,
  PageDesignConstants,
  RRMMCohortTreatment,
  SideMenuItems,
  ToastMessages,
  ToastMessageType,
} from "../../Helpers/Enums";
import InfoPopUp from "../../Components/InfoPopUp";
import {
  AdverseEvents_Msgs,
  CommonError_Msgs,
  hyperlinkTextAEReporting,
  TTCharacteristics_MSGS,
} from "../../Helpers/HelperText";
import { AppContext } from "../../Contexts/AppContextProvider";
import ErrorField from "../../Components/ErrorField";
import {
  AllowNumericWithDecimal,
  DateDisplayFormat,
  GenerateKey,
  getCohortTreatmentDisplayName,
  GetEarliestDate,
  GetLocalStorageData,
  GetLoggedInUserID,
  GetOrdinal,
  IsAdmin,
  IsDateAfter,
  IsDateValid,
  isStringEmpty,
} from "../../Helpers/Utilities";
import { AdverseEventsService } from "../../WebApiServices/AdverseEvents.service";
import DatePickerComponent from "../../Components/DatePickerComponent";
import dayjs from "dayjs";

const AdverseEvents = () => {
  const navigatePaths = {
    prevPage: "/TreatmentResponseProgression",
    currPage: "/AdverseEvents",
    nextPage: "/AEReporting",
  };

  const pid = GetLocalStorageData("patientId") ?? 0;
  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    registerPageConfig,
    registerSaveFn,
  } = useContext(AppContext);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [
    showHideHyperlinkModalAEReporting,
    setShowHideHyperlinkModalAEReporting,
  ] = useState(false);
  const [Q36CRS, setQ36CRS] = useState(false);
  const [Q39CRS, setQ39CRS] = useState(false);
  const [Q36ICANS, setQ36ICANS] = useState(false);

  const [adverseEventWarningTec, setAdverseEventWarningTec] = useState(false);
  const [adverseEventWarningTal, setAdverseEventWarningTal] = useState(false);
  const [adverseEventWarningElr, setAdverseEventWarningElr] = useState(false);
  const [adverseEventWarningLin, setAdverseEventWarningLin] = useState(false);
  const [adverseEventWarningCarvykti, setAdverseEventWarningCarvykti] =
    useState(false);
  const [adverseEventWarningAbecma, setAdverseEventWarningAbecma] =
    useState(false);
  const [endOfFollowUpDate, setEndOfFollowUpDate] = useState("");
  const [isNewEcrfA, setIsNewEcrfA] = useState(false);
  const [isNewEcrfB, setIsNewEcrfB] = useState(false);

  const [q54_Dependency, setQ54Dependency] = useState(0);
  const q53_crs_row = {
    crsId: null,
    rbl_B: null,
    date_B: null,
    rbl_C: null,

    rbl_resolution: null,
    date_resolution: null,

    resolutionemptyerr: false,
    resolutiondateemptyerr: false,
    resolutiondateinvalid: false,
    resolutiondaterangeerr: false, // Validates: index date ≤ onset date ≤ resolution date ≤ AE end date

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false, //Date before Index
    B_date_after_err: false, //Date after AE End
    B_date_equal_prev_ep_err: false, //Date same as previous episode
    B_date_invalid: false,
    B_date_after_eof: false,
    Q53q36WarningMsg: false,
    Q53q39WarningMsg: false,
    C_empty_err: false,
    ae_ManagementAeWarningTec: false,
  };
  const q54_icans_row = {
    icansId: null,
    rbl_B: null,
    date_B: null,

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false,
    B_date_after_err: false,
    B_date_equal_prev_ep_err: false,
    B_date_invalid: false,
    B_date_after_eof: false,
    Q54q36WarningMsg: false,
    // C_empty_err: false

    //  SEVERITY FIELD
    rblC: null,
    Cemptyerr: false,

    //RESOLUTION FIELDS (for isNewEcrfA only)
    rblresolution: null,
    dateresolution: null,
    resolutionemptyerr: false,
    resolutiondateemptyerr: false,
    resolutiondateinvalid: false,
    resolutiondaterangeerr: false,
  };

  const q55_neutropenia_row = {
    neutropeniaId: null,
    rbl_B: null,
    date_B: null,
    rbl_C: null,
    date_C: null,

    //severity - Update A
    rblD: null,
    Demptyerr: false,

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false,
    B_date_after_err: false,
    B_date_equal_prev_ep_err: false,
    B_date_invalid: false,
    B_date_after_eof: false,

    C_empty_err: false,
    C_date_empty_err: false,
    C_date_before_index_err: false, //Date before Index Date
    C_date_before_onset_err: false, //Date before Onset Date
    C_date_after_err: false, //Date after AE End Date
    C_date_invalid: false,
    C_date_before_eof: false,
  };
  const q56_cytopenia_row = {
    cytopeniaId: null,
    rbl_B: null,
    date_B: null,
    rbl_C: null,
    date_C: null,

    // Severity - Update A
    rblD: null,
    Demptyerr: false,

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false,
    B_date_after_err: false,
    B_date_equal_prev_ep_err: false,
    B_date_invalid: false,
    B_date_after_eof: false,

    C_empty_err: false,
    C_date_empty_err: false,
    C_date_before_index_err: false, //Date before Index Date
    C_date_before_onset_err: false, //Date before Onset Date
    C_date_after_err: false, //Date after AE End Date
    C_date_invalid: false,
    C_date_before_eof: false,
  };
  const q57_infection_row = {
    infectionId: null,
    infectionKey: null,
    rbl_B: null,
    date_B: null,
    chk_C_1: false,
    chk_C_2: false,
    chk_C_3: false,
    rb_C: false,
    chk_D_1: false,
    chk_D_2: false,
    chk_D_3: false,
    chk_D_4: false,
    chk_D_5: false,
    chk_D_6: false,
    chk_D_7: false,
    chk_D_8: false,
    chk_D_9: false,
    chk_D_10: false,
    chk_D_11: false,
    chk_D_12: false,
    chk_D_13: false,
    chk_D_14: false,
    chk_D_15: false,
    txt_D_oth: "",
    rb_D: false,
    rbl_E: null,
    rbl_F: null,

    chk_G_1: false,
    chk_G_2: false,
    chk_G_3: false,
    chk_G_4: false,
    chk_G_5: false,
    rb_G_unk: null,
    txt_G_oth: "",

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false,
    B_date_after_err: false,
    B_date_equal_prev_ep_err: false,
    B_date_invalid: false,
    B_date_after_eof: false,

    C_empty_err: false,
    D_empty_err: false,
    D_txt_empty_err: false,
    E_empty_err: false,
    F_empty_err: false,
    G_empty_err: false,
    G_txt_empty_err: false,
  };
  const q58_weightLoss_row = {
    weightLossId: null,
    rbl_B: null,
    date_B: null,
    rbl_C: null,
    date_C: null,
    rbl_D: null,
    date_D: null,

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false,
    B_date_after_err: false,
    B_date_equal_prev_ep_err: false,
    B_date_invalid: false,
    B_date_after_eof: false,

    C_empty_err: false,
    C_date_empty_err: false,
    C_date_before_index_err: false,
    C_date_before_onset_err: false,
    C_date_after_err: false,
    C_date_invalid: false,

    D_empty_err: false,
    D_date_empty_err: false,
    D_date_before_index_err: false,
    D_date_before_onset_err: false,
    D_date_before_res_err: false,
    D_date_after_err: false,
    D_date_invalid: false,
    D_date_before_eof: false,
  };
  const q59_dysgeusia_row = {
    dysgeusiaId: null,
    rbl_B: null,
    date_B: null,
    rbl_C: null,
    date_C: null,

    chk_CC_1: false,
    chk_CC_1_P: false,
    chk_CC_1_T: false,
    chk_CC_2: false,
    chk_CC_2_P: false,
    chk_CC_2_T: false,
    chk_CC_3: false,
    chk_CC_3_P: false,
    chk_CC_3_T: false,
    chk_CC_4: false,
    chk_CC_4_P: false,
    chk_CC_4_T: false,
    chk_CC_5: false,
    chk_CC_5_P: false,
    chk_CC_5_T: false,
    chk_CC_6: false,
    chk_CC_6_P: false,
    chk_CC_6_T: false,
    chk_CC_7: false,
    chk_CC_7_P: false,
    chk_CC_7_T: false,
    txt_CC_oth: "",
    rb_CC: false,

    rbl_D: null,
    date_D: null,

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false,
    B_date_after_err: false,
    B_date_equal_prev_ep_err: false,
    B_date_invalid: false,
    B_date_after_eof: false,

    CC_1_empty_err: false,
    CC_2_empty_err: false,
    CC_3_empty_err: false,
    CC_4_empty_err: false,
    CC_5_empty_err: false,
    CC_6_empty_err: false,
    CC_7_empty_err: false,
    CC_empty_err: false,
    CC_txt_empty_err: false,

    C_empty_err: false,
    C_date_empty_err: false,
    C_date_before_index_err: false,
    C_date_before_onset_err: false,
    C_date_after_err: false,
    C_date_invalid: false,
    C_date_before_eof: false,

    D_empty_err: false,
    D_date_empty_err: false,
    D_date_before_index_err: false,
    D_date_before_onset_err: false,
    D_date_before_impr_err: false,
    D_date_after_err: false,
    D_date_invalid: false,
    D_date_before_eof: false,
  };
  const q60_nail_row = {
    nailDisorderId: null,
    rbl_B: null,
    date_B: null,
    rbl_C: null,
    date_C: null,
    rbl_D: null,
    date_D: null,

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false,
    B_date_after_err: false,
    B_date_equal_prev_ep_err: false,
    B_date_invalid: false,
    B_date_after_eof: false,

    C_empty_err: false,
    C_date_empty_err: false,
    C_date_before_index_err: false,
    C_date_before_onset_err: false,
    C_date_after_err: false,
    C_date_invalid: false,
    C_date_before_eof: false,

    D_empty_err: false,
    D_date_empty_err: false,
    D_date_before_index_err: false,
    D_date_before_onset_err: false,
    D_date_before_impr_err: false,
    D_date_after_err: false,
    D_date_invalid: false,
    D_date_before_eof: false,
  };
  const q61_skin_row = {
    skinDisorderId: null,
    rbl_B: null,
    date_B: null,
    rbl_C: null,
    date_C: null,
    rbl_D: null,
    date_D: null,

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false,
    B_date_after_err: false,
    B_date_equal_prev_ep_err: false,
    B_date_invalid: false,
    B_date_before_eof: false,

    C_empty_err: false,
    C_date_empty_err: false,
    C_date_before_index_err: false,
    C_date_before_onset_err: false,
    C_date_after_err: false,
    C_date_invalid: false,
    C_date_before_eof: false,

    D_empty_err: false,
    D_date_empty_err: false,
    D_date_before_index_err: false,
    D_date_before_onset_err: false,
    D_date_before_impr_err: false,
    D_date_after_err: false,
    D_date_invalid: false,
    D_date_before_eof: false,
  };
  const q62_spm_row = {
    cohortTreatmentId: null,
    spmId: null,
    rbl_B: null,
    date_B: null,
    q62_rbl_C: null,
    q62_date_C: null,
    q62_severity: null,

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false,
    B_date_after_err: false,
    B_date_equal_prev_ep_err: false,
    B_date_invalid: false,
    B_date_after_eof: false,

    //C
    q62CEmptyError: false,
    q62CDateEmptyError: false,
    q62CDateInvalidError: false,
    q62CDateBeforeIndexError: false,
    q62CDateBeforeOnsetError: false,
    q62CDateAfterAEDateError: false,

    //D
    q62DEmptyError: false,
  };

  const q63_neurotoxicity_row = {
    neurotoxicityId: null,
    rbl_B: null,
    date_B: null,
    rbl_C: null,
    date_C: null,
    rbl_D: null,
    txt_D_oth: "",

    rbl_E: null,
    chk_F_1: false, // outpatient
    chk_F_2: false,
    rb_F: false,
    chk_G_1: false,
    chk_G_2: false,
    chk_G_3: false,
    chk_G_4: false,
    chk_G_5: false,
    rb_G: false,

    B_empty_err: false,
    B_date_empty_err: false,
    B_date_before_err: false,
    B_date_after_err: false,
    B_date_equal_prev_ep_err: false,
    B_date_invalid: false,
    B_date_after_eof: false,

    C_empty_err: false,
    C_date_empty_err: false,
    C_date_before_index_err: false, //Date before Index Date
    C_date_before_onset_err: false, //Date before Onset Date
    C_date_after_err: false, //Date after AE End Date
    C_date_invalid: false,
    C_date_before_eof: false,

    D_empty_err: false,
    D_txt_empty_err: false,

    E_empty_err: false,
    F_empty_err: false,
    G_empty_err: false,

    // Column F - Management Setting (UPDATED)
    chkFInpatient: false,
    chkFEmergencyRoom: false,
    chkFIntensiveCareUnit: false,
    chkFUrgentCareVisit: false,
    chkFOther: false,

    // Column H - Earliest Date of Improvement
    rblH: null,
    dateH: null,

    // Column H validation errors (NEW)
    Hemptyerr: false,
    Hdateemptyerr: false,
    Hdateinvalid: false,
    Hdatebeforeindexerr: false,
    Hdatebeforeonseterr: false,
    Hdatebeforereserr: false,
    Hdateaftererr: false,
    Hdatebeforeeof: false,

    isAutoPopulated: false,
    sourceQ54Date: null,
    sourceQ54IcansId: null,
    sourceQ54Index: null,
  };

  //Q64
  const q64_enterocolitis_row = {
    adverseevententerocolitisid: null,
    patientId: null,
    cohortTreatmentId: null,
    q64_rbl_B: null,
    q64_date_B: null,
    q64_rbl_C: null,
    q64_date_C: null,
    q64_rbl_D: null,
    q64_date_D: null,
    q64_chk_E_1: false,
    q64_chk_E_2: false,
    q64_chk_E_3: false,
    q64_chk_E_4: false,
    q64_chk_E_5: false,
    q64_chk_E_othTxt: "",
    q64_E_unk: false,
    q64_severity: null,

    //B Column
    q64BEmptyError: false,
    q64BDateEmptyError: false,
    q64BDateInvalidError: false,
    q64BDateEqualPrevError: false,
    q64BDateBeforeIndexDateError: false,
    q64BDateAfterCDateError: false,
    q64BDateAfterResolutionDateError: false,
    q64BDateAfterAEDateError: false,

    //C Column
    q64CEmptyError: false,
    q64CDateEmptyError: false,
    q64CDateInvalidError: false,
    q64CDateBeforeError: false,
    q64CDateAfterResolutionDateError: false,
    q64CDateAfterAEDateError: false,

    //D Column
    q64DEmptyError: false,
    q64DDateEmptyError: false,
    q64DDateInvalidError: false,
    q64DDateBeforeError: false,
    q64DDateAfterAEDateError: false,

    //E Column
    q64EEmptyError: false,
    q64EOtherTxtEmptyError: false,

    //F
    q64FEmptyError: false,
  };

  //Q65
  const q65_lymphopenia_row = {
    adverseeventlymphopeniaid: null,
    patientId: null,
    cohortTreatmentId: null,
    q65_rbl_B: null,
    q65_date_B: null,
    q65_rbl_C: null,
    q65_date_C: null,
    q65_severity: null,

    //B Column
    q65BEmptyError: false,
    q65BDateEmptyError: false,
    q65BDateInvalidError: false,
    q65BDateEqualPrevError: false,
    q65BDateBeforeIndexDateError: false,
    q65BDateAfterAEDateError: false,

    //C Column
    q65CEmptyError: false,
    q65CDateEmptyError: false,
    q65CDateInvalidError: false,
    q65CDateBeforeError: false,
    q65CDateAfterAEDateError: false,

    //D Column
    q65DEmptyError: false,
  };

  //Q57.1.B
  const q571B_immunoglobin_row = {
    adverseeventimmunoglobinid: null,
    patientId: null,
    cohortTreatmentId: null,
    subsequentLOTStartDate: null,
    q571B_rbl_B: null,
    q571B_date_B: null,
    q571B_rbl_C: null,
    q571B_unit_C: null,
    q571B_episode_D: null,

    //B Column
    q571BEmptyError: false,
    q571BDateEmptyError: false,
    q571BDateInvalidError: false,
    q571BDateEqualPrevError: false,
    q571BDateBeforeIndexDateError: false,
    q571BDateAfterDateError: false,

    //C Column
    q571CEmptyError: false,
    q571CUnitEmptyError: false,
    q571CUnitInvalidError: false,

    //D Column
    q571DEmptyError: false,
  };

  const [q65QLymphopheniaSelectionList, setQ65LymphopheniaSelectionList] =
    useState([]);

  const [q571BWarnings, setQ571BWarnings] = useState({});

  const [subsequentLOTDateList, setSubsequentLOTDateList] = useState([]);

  const [q65Warnings, setQ65Warnings] = useState({});

  const AERow = {
    cohortTreatmentId: null,
    cohortTreatmentName: "[Bispecifics/CAR-T]",
    superScriptText: "",
    cohortIndexDate: "[Bispecifics/CAR-T index date]",
    aeEndDate: "[AE end date]",

    q53_crs_list: [q53_crs_row], //Remove
    q54_icans_list: [q54_icans_row], //Remove
    q55_neutropenia_list: [q55_neutropenia_row], //Remove
    q56_cytopenia_list: [q56_cytopenia_row], //Remove
    q57_infection_list: [q57_infection_row], //Remove
    q58_weightLoss_list: [q58_weightLoss_row], //Remove
    q59_dysgeusia_list: [q59_dysgeusia_row], //Remove
    q60_nail_list: [q60_nail_row], //Remove
    q61_skin_list: [q61_skin_row], //Remove
    q62_spm_list: [q62_spm_row], //Secondary primary malignancy  //Remove
    q63_neurotoxicity_list: [q63_neurotoxicity_row], //Remove
    q64_enterocolitis_list: [q64_enterocolitis_row],
    q65_lymphopenia_list: [q65_lymphopenia_row],
    q571B_immunoglobin_list: [q571B_immunoglobin_row],
    infectionEpisodeList: [],
  };
  const [aeDetails, setAEDetails] = useState([AERow]);

  useEffect(() => {
    registerPageConfig({
      activePageId: SideMenuItems.AdverseEvents,
      navigatePaths,
    });
  }, [navigatePaths]);

  useLayoutEffect(() => {
    registerSaveFn(SavePage);
  });

  const resetImmunoglobinRow = (row) => ({
    ...row,
    q571B_rbl_B: null,
    q571B_date_B: null,
    q571B_rbl_C: null,
    q571B_unit_C: null,
    q571B_episode_D: null,
    q571BEmptyError: false,
    q571BDateEmptyError: false,
    q571BDateInvalidError: false,
    q571BDateEqualPrevError: false,
    q571BDateBeforeIndexDateError: false,
    q571BDateAfterDateError: false,
    q571CEmptyError: false,
    q571CUnitEmptyError: false,
    q571CUnitInvalidError: false,
    q571DEmptyError: false,
  });

  const rebuildInfectionEpisodesAndMappings = (parentObj, innerArr, q53) => {
    const validEpisodes = innerArr
      .map((item, index) => ({ item, index }))
      .filter(({ item }) => item.rbl_B != null && item.rbl_B !== 1);

    const infectionEpisodeList = validEpisodes.map(({ item }, epIdx) => {
      const onsetText = !isStringEmpty(item.date_B) ? item.date_B : "Unknown";

      return {
        infectionKey: item.infectionKey || GenerateKey(),
        episodeLabel: `Episode ${epIdx + 1} (onset date: ${onsetText})`,
      };
    });

    let q571BList = [...(parentObj.q571B_immunoglobin_list || [])];

    if (!infectionEpisodeList.length) {
      const baseRow = q571BList[0] || {};

      q571BList = [resetImmunoglobinRow(baseRow)];
    } else {
      q571BList = q571BList.map((item) => {
        const existsInQ57 = innerArr?.some(
          (ep) => ep.infectionKey === item.q571B_episode_D && ep.rbl_B !== 1,
        );

        return existsInQ57
          ? item
          : { ...item, q571B_episode_D: null, q571DEmptyError: false };
      });
    }

    return {
      ...parentObj,
      q57_infection_list: innerArr,
      infectionEpisodeList,
      q571B_immunoglobin_list: q571BList,
      ...(q53 !== undefined && { q53_crs_list: q53 }),
    };
  };

  const HandleRepeaterFieldChange = (e) => {
    const { name, id, value } = e.target;
    const value_int = Number(value);

    const lastUnderscoreIndex = name.lastIndexOf("_");
    const parentIndex = name.substring(lastUnderscoreIndex + 1);

    let updatedArray = [...aeDetails];
    let Q53 = [...(updatedArray[parentIndex]?.q53_crs_list ?? [])];
    let Q54 = [...(updatedArray[parentIndex]?.q54_icans_list ?? [])];
    let Q55 = [...(updatedArray[parentIndex]?.q55_neutropenia_list ?? [])];
    let Q56 = [...(updatedArray[parentIndex]?.q56_cytopenia_list ?? [])];
    let Q57 = [...(updatedArray[parentIndex]?.q57_infection_list ?? [])];
    let Q58 = [...(updatedArray[parentIndex]?.q58_weightLoss_list ?? [])];
    let Q59 = [...(updatedArray[parentIndex]?.q59_dysgeusia_list ?? [])];
    let Q60 = [...(updatedArray[parentIndex]?.q60_nail_list ?? [])];
    let Q61 = [...(updatedArray[parentIndex]?.q61_skin_list ?? [])];
    let Q62 = [...(updatedArray[parentIndex]?.q62_spm_list ?? [])];
    let Q63 = [...(updatedArray[parentIndex]?.q63_neurotoxicity_list ?? [])];
    let Q64 = [...(updatedArray[parentIndex]?.q64_enterocolitis_list ?? [])];
    let Q65 = [...(updatedArray[parentIndex]?.q65_lymphopenia_list ?? [])];

    switch (name) {
      //Q53  rbl_B
      case "q53_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q53_crs_list];

          let rbl_C = innerArr[id].rbl_C;
          let C_empty_err = innerArr[id].C_empty_err;

          //Delete rows if "The patient did not experience CRS" is selected and reset column C of current row
          if (value_int === 1) {
            rbl_C = null;
            C_empty_err = false;

            // RESET RESOLUTION FIELDS
            innerArr[id].rbl_resolution = null;
            innerArr[id].date_resolution = null;
            innerArr[id].resolutionemptyerr = false;
            innerArr[id].resolutiondateemptyerr = false;
            innerArr[id].resolutiondateinvalid = false;
            innerArr[id].resolutiondaterangeerr = false;

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          // if(value_int==1 &&
          //   Q54.length>1 && Q54[id].rbl_B == 1 &&
          //   Q55.length>1 && Q55[id].rbl_B == 1 &&
          //   Q56.length>1 && Q56[id].rbl_B == 1 &&
          //   Q57.length>1 && Q57[id].rbl_B == 1
          //   ){
          //     innerArr[id].ae_ManagementAeWarningTec=true;
          //   }

          // Update the specific item in the inner array
          innerArr[id] = {
            ...innerArr[id],
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
            rbl_C,
            C_empty_err,
            Q53q36WarningMsg: value_int == 1 && Q36CRS == true ? true : false,
            Q53q39WarningMsg: value_int == 1 && Q39CRS == true ? true : false,
          };

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (innerArr[id]) {
            innerArr[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.TECVAYLI
                ? adverseEventWarningTec &&
                  value_int == 1 &&
                  Q54[id]?.rbl_B == 1 &&
                  Q55[id]?.rbl_B == 1 &&
                  Q56[id]?.rbl_B == 1 &&
                  Q57[id]?.rbl_B == 1 &&
                  (isNewEcrfB ? Q65[id]?.q65_rbl_B === 1 : true)
                : cohortid == RRMMCohortTreatment.TALVEY
                  ? adverseEventWarningTal &&
                    value_int == 1 &&
                    Q54[id]?.rbl_B == 1 &&
                    Q55[id]?.rbl_B == 1 &&
                    Q57[id]?.rbl_B == 1 &&
                    Q58[id]?.rbl_B == 1 &&
                    Q59[id]?.rbl_B == 1 &&
                    Q60[id]?.rbl_B == 1 &&
                    Q61[id]?.rbl_B == 1 &&
                    (isNewEcrfB ? Q65[id]?.q65_rbl_B === 1 : true)
                  : cohortid == RRMMCohortTreatment.ELREXFIO
                    ? adverseEventWarningElr &&
                      value_int == 1 &&
                      Q54[id]?.rbl_B == 1 &&
                      Q55[id]?.rbl_B == 1 &&
                      Q56[id]?.rbl_B == 1 &&
                      Q57[id]?.rbl_B == 1 &&
                      (isNewEcrfB ? Q65[id]?.q65_rbl_B === 1 : true)
                    : cohortid == RRMMCohortTreatment.Linvoseltamab
                      ? adverseEventWarningLin &&
                        value_int == 1 &&
                        Q54[id]?.rbl_B == 1 &&
                        Q55[id]?.rbl_B == 1 &&
                        Q56[id]?.rbl_B == 1 &&
                        Q57[id]?.rbl_B == 1 &&
                        (isNewEcrfB ? Q65[id]?.q65_rbl_B === 1 : true)
                      : cohortid == RRMMCohortTreatment.CARVYKTI ||
                          cohortid == RRMMCohortTreatment.ABECMA
                        ? (adverseEventWarningCarvykti ||
                            adverseEventWarningAbecma) &&
                          value_int == 1 &&
                          Q54[id]?.rbl_B == 1 &&
                          Q55[id]?.rbl_B == 1 &&
                          Q56[id]?.rbl_B == 1 &&
                          Q62[id]?.rbl_B == 1 &&
                          Q63[id]?.rbl_B == 1 &&
                          (isNewEcrfA ? Q64[id]?.q64_rbl_B === 1 : true) &&
                          (isNewEcrfB ? Q65[id]?.q65_rbl_B === 1 : true)
                        : false;
          }
          // Assign the updated inner array back to the outer array
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q53_crs_list: innerArr,
          };
        }
        break;
      case "q53_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q53_crs_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: value_int,
            C_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q53_crs_list: innerArr,
          };
        }
        break;

      case `q53rblresolution_${id}_${parentIndex}`:
        let innerArr = [...updatedArray[parentIndex].q53_crs_list];
        innerArr[id] = {
          ...innerArr[id],
          rbl_resolution: value_int,
          date_resolution: null,
          resolutionemptyerr: false,
          resolutiondateemptyerr: false,
          resolutiondateinvalid: false,
          resolutiondaterangeerr: false,
        };
        updatedArray[parentIndex] = {
          ...updatedArray[parentIndex],
          q53_crs_list: innerArr,
        };
        break;

      //Q54
      case "q54_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q54_icans_list];
          // let rbl_C = innerArr[id].rbl_C;
          // let C_empty_err = innerArr[id].C_empty_err;

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
            // rbl_C,
            // C_empty_err,
            Q54q36WarningMsg: value_int == 1 && Q36ICANS == true ? true : false,
          };

          //Delete rows if "The patient did not experience ICANS" is selected
          if (value_int === 1) {
            //  rbl_C = null;
            // C_empty_err = false;

            //RESET RESOLUTION FIELDS
            innerArr[id].rblresolution = null;
            innerArr[id].dateresolution = null;
            innerArr[id].resolutionemptyerr = false;
            innerArr[id].resolutiondateemptyerr = false;
            innerArr[id].resolutiondateinvalid = false;
            innerArr[id].resolutiondaterangeerr = false;
            innerArr[id].rblC = null;
            innerArr[id].Cemptyerr = false;

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          let q53 = [...updatedArray[parentIndex].q53_crs_list];

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.TECVAYLI
                ? adverseEventWarningTec &&
                  value_int == 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B == 1 &&
                  Q55.length &&
                  Q55[id]?.rbl_B == 1 &&
                  Q56.length &&
                  Q56[id]?.rbl_B == 1 &&
                  Q57.length &&
                  Q57[id]?.rbl_B == 1
                : cohortid == RRMMCohortTreatment.TALVEY
                  ? adverseEventWarningTal &&
                    value_int == 1 &&
                    Q53.length &&
                    Q53[id]?.rbl_B == 1 &&
                    Q55.length &&
                    Q55[id]?.rbl_B == 1 &&
                    Q57.length &&
                    Q57[id]?.rbl_B == 1 &&
                    Q58.length &&
                    Q58[id]?.rbl_B == 1 &&
                    Q59.length &&
                    Q59[id]?.rbl_B == 1 &&
                    Q60.length &&
                    Q60[id]?.rbl_B == 1 &&
                    Q61.length &&
                    Q61[id]?.rbl_B == 1
                  : cohortid == RRMMCohortTreatment.ELREXFIO ||
                      cohortid == RRMMCohortTreatment.Linvoseltamab
                    ? (adverseEventWarningElr || adverseEventWarningLin) &&
                      value_int == 1 &&
                      Q53.length &&
                      Q53[id]?.rbl_B == 1 &&
                      Q55.length &&
                      Q55[id]?.rbl_B == 1 &&
                      Q56.length &&
                      Q56[id]?.rbl_B == 1 &&
                      Q57.length &&
                      Q57[id]?.rbl_B == 1
                    : cohortid == RRMMCohortTreatment.CARVYKTI ||
                        cohortid == RRMMCohortTreatment.ABECMA
                      ? (adverseEventWarningCarvykti ||
                          adverseEventWarningAbecma) &&
                        value_int == 1 &&
                        Q53.length &&
                        Q53[id]?.rbl_B == 1 &&
                        Q55.length &&
                        Q55[id]?.rbl_B == 1 &&
                        Q56.length &&
                        Q56[id]?.rbl_B == 1 &&
                        Q62.length &&
                        Q62[id]?.rbl_B == 1 &&
                        Q63.length &&
                        Q63[id]?.rbl_B === 1 &&
                        (isNewEcrfA
                          ? Q64.length && Q64[id]?.q64_rbl_B === 1
                          : true)
                      : false;
          }

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q54_icans_list: innerArr,
            q53_crs_list: q53,
          };
          updatedArray = AutoPopulateQ63FromQ54(parentIndex, updatedArray);
        }
        break;

      //  SEVERITY CASE
      case `q54rblC_${id}_${parentIndex}`:
        {
          const parentItem = updatedArray[parentIndex];
          const innerArr = [...parentItem.q54_icans_list];
          innerArr[id] = {
            ...innerArr[id],
            rblC: value_int,
            Cemptyerr: false,
          };
          updatedArray[parentIndex] = {
            ...parentItem,
            q54_icans_list: innerArr,
          };
          updatedArray = AutoPopulateQ63FromQ54(parentIndex, updatedArray);
        }
        break;

      //RESOLUTION RADIO CASE
      case `q54rblresolution_${id}_${parentIndex}`: {
        const parentItem = updatedArray[parentIndex];
        const innerArr2 = [...parentItem.q54_icans_list];

        innerArr2[id] = {
          ...innerArr2[id],
          rblresolution: value_int,
          dateresolution: null,
          resolutionemptyerr: false,
          resolutiondateemptyerr: false,
          resolutiondateinvalid: false,
          resolutiondaterangeerr: false,
        };

        updatedArray[parentIndex] = {
          ...parentItem,
          q54_icans_list: innerArr2,
        };

        updatedArray = AutoPopulateQ63FromQ54(parentIndex, updatedArray);
        break;
      }

      //Q55
      case "q55_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q55_neutropenia_list];
          let row = innerArr[id];

          //Delete rows if "The patient did not experience neutropenia" is selected and reset column C of current row
          if (value_int === 1) {
            row = {
              ...row,
              rbl_C: null,
              date_C: null,
              C_empty_err: false,
              C_date_empty_err: false,
              C_date_before_index_err: false,
              C_date_before_onset_err: false,
              C_date_after_err: false,
              C_date_invalid: false,
              C_date_before_eof: false,

              rblD: null,
              Demptyerr: false,
            };

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          innerArr[id] = {
            ...row,
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
            ae_ManagementAeWarningTec:
              value_int != 1 ? false : innerArr[id].ae_ManagementAeWarningTec,
          };

          let q53 = [...updatedArray[parentIndex].q53_crs_list];

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.TECVAYLI
                ? adverseEventWarningTec &&
                  value_int == 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B == 1 &&
                  Q54.length &&
                  Q54[id]?.rbl_B == 1 &&
                  Q56.length &&
                  Q56[id]?.rbl_B == 1 &&
                  Q57.length &&
                  Q57[id]?.rbl_B == 1
                : cohortid === RRMMCohortTreatment.TALVEY
                  ? adverseEventWarningTal &&
                    value_int === 1 &&
                    Q53.length &&
                    Q53[id]?.rbl_B === 1 &&
                    Q54.length &&
                    Q54[id]?.rbl_B === 1 &&
                    Q55.length &&
                    Q55[id]?.rbl_B === 1 &&
                    Q57.length &&
                    Q57[id]?.rbl_B === 1 &&
                    Q58.length &&
                    Q58[id]?.rbl_B === 1 &&
                    Q59.length &&
                    Q59[id]?.rbl_B === 1 &&
                    Q60.length &&
                    Q60[id]?.rbl_B === 1 &&
                    Q61.length &&
                    Q61[id]?.rbl_B === 1
                  : cohortid == RRMMCohortTreatment.ELREXFIO ||
                      cohortid == RRMMCohortTreatment.Linvoseltamab
                    ? (adverseEventWarningElr || adverseEventWarningLin) &&
                      value_int == 1 &&
                      Q53.length &&
                      Q53[id]?.rbl_B == 1 &&
                      Q54.length &&
                      Q54[id]?.rbl_B == 1 &&
                      Q56.length &&
                      Q56[id]?.rbl_B == 1 &&
                      Q57.length &&
                      Q57[id]?.rbl_B == 1
                    : cohortid == RRMMCohortTreatment.CARVYKTI ||
                        cohortid == RRMMCohortTreatment.ABECMA
                      ? (adverseEventWarningCarvykti ||
                          adverseEventWarningAbecma) &&
                        value_int == 1 &&
                        Q53.length &&
                        Q53[id]?.rbl_B == 1 &&
                        Q54.length &&
                        Q54[id]?.rbl_B == 1 &&
                        Q56.length &&
                        Q56[id]?.rbl_B == 1 &&
                        Q62.length &&
                        Q62[id]?.rbl_B == 1 &&
                        Q63.length &&
                        Q63[id]?.rbl_B == 1 &&
                        (isNewEcrfA
                          ? Q64.length && Q64[id]?.q64_rbl_B === 1
                          : true)
                      : false;
          }
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q55_neutropenia_list: innerArr,
            q53_crs_list: q53,
          };
        }
        break;
      case "q55_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q55_neutropenia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: value_int,
            date_C: null,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q55_neutropenia_list: innerArr,
          };
        }
        break;

      // SEVERITY CASE FOR Q55
      case `q55rblD_${id}_${parentIndex}`:
        {
          let innerArr = [...updatedArray[parentIndex].q55_neutropenia_list];
          innerArr[id] = {
            ...innerArr[id],
            rblD: value_int,
            Demptyerr: false,
          };
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q55_neutropenia_list: innerArr,
          };
        }
        break;

      //Q56
      case "q56_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q56_cytopenia_list];
          let row = innerArr[id];

          //Delete rows if "The patient did not experience cytopenia" is selected and reset column C of current row
          if (value_int === 1) {
            row = {
              ...row,
              rbl_C: null,
              date_C: null,
              C_empty_err: false,
              C_date_empty_err: false,
              C_date_before_index_err: false,
              C_date_before_onset_err: false,
              C_date_after_err: false,
              C_date_invalid: false,
              C_date_before_eof: false,

              //Severity
              rblD: null,
              Demptyerr: false,
            };

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          innerArr[id] = {
            ...row,
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
            ae_ManagementAeWarningTec:
              value_int != 1 ? false : innerArr[id].ae_ManagementAeWarningTec,
          };

          let q53 = [...updatedArray[parentIndex].q53_crs_list];

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.TECVAYLI
                ? adverseEventWarningTec &&
                  value_int == 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B == 1 &&
                  Q54.length &&
                  Q54[id]?.rbl_B == 1 &&
                  Q55.length &&
                  Q55[id]?.rbl_B == 1 &&
                  Q57.length &&
                  Q57[id]?.rbl_B == 1
                : // cohortid == RRMMCohortTreatment.TALVEY ?
                  // (adverseEventWarningTal && value_int == 1 &&
                  //   (Q53.length  && Q53[id]?.rbl_B == 1) &&
                  //   (Q57.length  && Q57[id]?.rbl_B == 1) &&
                  //   (Q58.length  && Q58[id]?.rbl_B == 1) &&
                  //   (Q59.length  && Q59[id]?.rbl_B == 1) &&
                  //   (Q60.length  && Q60[id]?.rbl_B == 1) &&
                  //   (Q61.length  && Q61[id]?.rbl_B == 1)
                  //   ):
                  cohortid == RRMMCohortTreatment.ELREXFIO ||
                    cohortid == RRMMCohortTreatment.Linvoseltamab
                  ? (adverseEventWarningElr || adverseEventWarningLin) &&
                    value_int == 1 &&
                    Q53.length &&
                    Q53[id]?.rbl_B == 1 &&
                    Q54.length &&
                    Q54[id]?.rbl_B == 1 &&
                    Q55.length &&
                    Q55[id]?.rbl_B == 1 &&
                    Q57.length &&
                    Q57[id]?.rbl_B == 1
                  : cohortid == RRMMCohortTreatment.CARVYKTI ||
                      cohortid == RRMMCohortTreatment.ABECMA
                    ? (adverseEventWarningCarvykti ||
                        adverseEventWarningAbecma) &&
                      value_int == 1 &&
                      Q53.length &&
                      Q53[id]?.rbl_B == 1 &&
                      Q54.length &&
                      Q54[id]?.rbl_B == 1 &&
                      Q55.length &&
                      Q55[id]?.rbl_B == 1 &&
                      Q62.length &&
                      Q62[id]?.rbl_B == 1 &&
                      Q63.length &&
                      Q63[id]?.rbl_B == 1 &&
                      (isNewEcrfA
                        ? Q64.length && Q64[id]?.q64_rbl_B === 1
                        : true)
                    : false;
          }
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q56_cytopenia_list: innerArr,
            q53_crs_list: q53,
          };
        }
        break;
      case "q56_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q56_cytopenia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: value_int,
            date_C: null,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q56_cytopenia_list: innerArr,
          };
        }
        break;

      // ADD SEVERITY CASE FOR Q56
      case `q56rblD_${id}_${parentIndex}`:
        {
          let innerArr = [...updatedArray[parentIndex].q56_cytopenia_list];
          innerArr[id] = {
            ...innerArr[id],
            rblD: value_int,
            Demptyerr: false,
          };
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q56_cytopenia_list: innerArr,
          };
        }
        break;

      //Q57
      case "q57_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];
          let row = innerArr[id];

          //Delete rows if "The patient did not experience neurotoxicity" is selected and reset column C, D of current row
          if (value_int === 1) {
            row = {
              ...row,
              chk_C_1: false,
              chk_C_2: false,
              chk_C_3: false,
              rb_C: false,
              C_empty_err: false,
              chk_D_1: false,
              chk_D_2: false,
              chk_D_3: false,
              chk_D_4: false,
              chk_D_5: false,
              chk_D_6: false,
              chk_D_7: false,
              chk_D_8: false,
              chk_D_9: false,
              chk_D_10: false,
              chk_D_11: false,
              chk_D_12: false,
              chk_D_13: false,
              chk_D_14: false,
              chk_D_15: false,
              txt_D_oth: "",
              rb_D: false,
              D_empty_err: false,
              D_txt_empty_err: false,
              rbl_E: null,
              E_empty_err: false,
              rbl_F: null,
              F_empty_err: false,
              chk_G_1: false,
              chk_G_2: false,
              chk_G_3: false,
              chk_G_4: false,
              chk_G_5: false,
              rb_G_unk: null,
              txt_G_oth: "",
              G_empty_err: false,
              G_txt_empty_err: false,
            };

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          innerArr[id] = {
            ...row,
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          let q53 = [...updatedArray[parentIndex].q53_crs_list];

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.TECVAYLI
                ? adverseEventWarningTec &&
                  value_int == 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B == 1 &&
                  Q54.length &&
                  Q54[id]?.rbl_B == 1 &&
                  Q56.length &&
                  Q56[id]?.rbl_B == 1 &&
                  Q55.length &&
                  Q55[id]?.rbl_B == 1
                : cohortid == RRMMCohortTreatment.TALVEY
                  ? adverseEventWarningTal &&
                    value_int == 1 &&
                    Q53.length &&
                    Q53[id]?.rbl_B == 1 &&
                    Q54.length &&
                    Q54[id]?.rbl_B == 1 &&
                    Q58.length &&
                    Q58[id]?.rbl_B == 1 &&
                    Q59.length &&
                    Q59[id]?.rbl_B == 1 &&
                    Q60.length &&
                    Q60[id]?.rbl_B == 1 &&
                    Q61.length &&
                    Q61[id]?.rbl_B == 1
                  : cohortid == RRMMCohortTreatment.ELREXFIO ||
                      cohortid == RRMMCohortTreatment.Linvoseltamab
                    ? (adverseEventWarningElr || adverseEventWarningLin) &&
                      value_int == 1 &&
                      Q53.length &&
                      Q53[id]?.rbl_B == 1 &&
                      Q54.length &&
                      Q54[id]?.rbl_B == 1 &&
                      Q56.length &&
                      Q56[id]?.rbl_B == 1 &&
                      Q55.length &&
                      Q55[id]?.rbl_B == 1
                    : cohortid == RRMMCohortTreatment.CARVYKTI ||
                        cohortid == RRMMCohortTreatment.ABECMA
                      ? (adverseEventWarningCarvykti ||
                          adverseEventWarningAbecma) &&
                        value_int == 1 &&
                        Q53.length &&
                        Q53[id]?.rbl_B == 1 &&
                        Q54.length &&
                        Q54[id]?.rbl_B == 1 &&
                        Q56.length &&
                        Q56[id]?.rbl_B == 1 &&
                        Q62.length &&
                        Q62[id]?.rbl_B == 1 &&
                        Q63.length &&
                        Q63[id]?.rbl_B == 1 &&
                        (isNewEcrfA
                          ? Q64.length && Q64[id]?.q64_rbl_B === 1
                          : true)
                      : false;
          }

          if (isNewEcrfB) {
            updatedArray[parentIndex] = rebuildInfectionEpisodesAndMappings(
              updatedArray[parentIndex],
              innerArr,
              q53,
            );

            const computedWarnings = validateQ571BWarnings(updatedArray);
            setQ571BWarnings(computedWarnings);
          } else {
            updatedArray[parentIndex] = {
              ...updatedArray[parentIndex],
              q57_infection_list: innerArr,
              q53_crs_list: q53,
            };
          }
        }
        break;
      case "q57_chk_C_1_" + id + "_" + parentIndex:
      case "q57_chk_C_2_" + id + "_" + parentIndex:
      case "q57_chk_C_3_" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];
          // Extract the Check box state name
          const parts = name.split("_");
          const ctrlId = "chk_C_" + parts[3];

          innerArr[id] = {
            ...innerArr[id],

            [ctrlId]: !innerArr[id][ctrlId],
            rb_C: false,
            C_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q57_infection_list: innerArr,
          };
        }
        break;
      case "q57_rb_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];

          innerArr[id] = {
            ...innerArr[id],

            rb_C: true,
            chk_C_1: false,
            chk_C_2: false,
            chk_C_3: false,
            C_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q57_infection_list: innerArr,
          };
        }
        break;
      case "q57_chk_D_1_" + id + "_" + parentIndex:
      case "q57_chk_D_2_" + id + "_" + parentIndex:
      case "q57_chk_D_3_" + id + "_" + parentIndex:
      case "q57_chk_D_4_" + id + "_" + parentIndex:
      case "q57_chk_D_5_" + id + "_" + parentIndex:
      case "q57_chk_D_6_" + id + "_" + parentIndex:
      case "q57_chk_D_7_" + id + "_" + parentIndex:
      case "q57_chk_D_8_" + id + "_" + parentIndex:
      case "q57_chk_D_9_" + id + "_" + parentIndex:
      case "q57_chk_D_10_" + id + "_" + parentIndex:
      case "q57_chk_D_11_" + id + "_" + parentIndex:
      case "q57_chk_D_12_" + id + "_" + parentIndex:
      case "q57_chk_D_13_" + id + "_" + parentIndex:
      case "q57_chk_D_14_" + id + "_" + parentIndex:
      case "q57_chk_D_15_" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];
          // Extract the Check box state name
          const parts = name.split("_");
          const ctrlId = "chk_D_" + parts[3];

          innerArr[id] = {
            ...innerArr[id],

            [ctrlId]: !innerArr[id][ctrlId],
            txt_D_oth: ctrlId === "chk_D_15" ? "" : innerArr[id].txt_D_oth,
            rb_D: false,
            D_empty_err: false,
            D_txt_empty_err: false, // ctrlId === "chk_D_15" ? false : innerArr[id].D_txt_empty_err
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q57_infection_list: innerArr,
          };
        }
        break;
      case "q57_txt_D_oth" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];

          innerArr[id] = {
            ...innerArr[id],
            txt_D_oth: value,
            chk_D_15: true,
            D_empty_err: false,
            D_txt_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q57_infection_list: innerArr,
          };
        }
        break;
      case "q57_rb_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];

          innerArr[id] = {
            ...innerArr[id],

            rb_D: true,
            chk_D_1: false,
            chk_D_2: false,
            chk_D_3: false,
            chk_D_4: false,
            chk_D_5: false,
            chk_D_6: false,
            chk_D_7: false,
            chk_D_8: false,
            chk_D_9: false,
            chk_D_10: false,
            chk_D_11: false,
            chk_D_12: false,
            chk_D_13: false,
            chk_D_14: false,
            chk_D_15: false,
            txt_D_oth: "",
            D_empty_err: false,
            D_txt_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q57_infection_list: innerArr,
          };
        }
        break;
      case "q57_rbl_E" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_E: value_int,
            E_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q57_infection_list: innerArr,
          };
        }
        break;
      case "q57_rbl_F" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_F: value_int,
            F_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q57_infection_list: innerArr,
          };
        }
        break;

      case "q57_chk_G_1_" + id + "_" + parentIndex:
      case "q57_chk_G_2_" + id + "_" + parentIndex:
      case "q57_chk_G_3_" + id + "_" + parentIndex:
      case "q57_chk_G_4_" + id + "_" + parentIndex:
      case "q57_chk_G_5_" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];
          // Extract the Check box state name
          const parts = name.split("_");
          const ctrlId = "chk_G_" + parts[3];

          innerArr[id] = {
            ...innerArr[id],

            [ctrlId]: !innerArr[id][ctrlId],
            txt_G_oth: ctrlId === "chk_G_5" ? "" : innerArr[id].txt_G_oth,
            rb_G_unk: false,
            G_empty_err: false,
            G_txt_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q57_infection_list: innerArr,
          };
        }
        break;
      case "q57_txt_G_oth" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];

          innerArr[id] = {
            ...innerArr[id],
            txt_G_oth: value,
            chk_G_5: true,
            G_empty_err: false,
            G_txt_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q57_infection_list: innerArr,
          };
        }
        break;
      case "q57_rb_G_unk" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];

          innerArr[id] = {
            ...innerArr[id],

            rb_G_unk: true,
            chk_G_1: false,
            chk_G_2: false,
            chk_G_3: false,
            chk_G_4: false,
            chk_G_5: false,
            txt_G_oth: "",
            G_empty_err: false,
            G_txt_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q57_infection_list: innerArr,
          };
        }
        break;

      //Q58
      case "q58_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q58_weightLoss_list];
          let row = innerArr[id];

          //Delete rows if "The patient did not experience weight loss" is selected and reset column C n D of current row
          if (value_int === 1) {
            row = {
              ...row,
              rbl_C: null,
              date_C: null,
              C_empty_err: false,
              C_date_empty_err: false,
              C_date_before_index_err: false,
              C_date_before_onset_err: false,
              C_date_after_err: false,
              C_date_invalid: false,
              C_date_before_eof: false,
              rbl_D: null,
              date_D: null,
              D_empty_err: false,
              D_date_empty_err: false,
              D_date_before_index_err: false,
              D_date_before_onset_err: false,
              D_date_before_res_err: false,
              D_date_after_err: false,
              D_date_invalid: false,
              D_date_before_eof: false,
            };

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          let q53 = [...updatedArray[parentIndex].q53_crs_list];
          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.TALVEY
                ? adverseEventWarningTal &&
                  value_int == 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B == 1 &&
                  Q54.length &&
                  Q54[id]?.rbl_B == 1 &&
                  Q57.length &&
                  Q57[id]?.rbl_B == 1 &&
                  Q59.length &&
                  Q59[id]?.rbl_B == 1 &&
                  Q60.length &&
                  Q60[id]?.rbl_B == 1 &&
                  Q61.length &&
                  Q61[id]?.rbl_B == 1
                : false;
          }
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q58_weightLoss_list: innerArr,
            q53_crs_list: q53,
          };
        }
        break;
      case "q58_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q58_weightLoss_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: value_int,
            date_C: null,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q58_weightLoss_list: innerArr,
          };
        }
        break;
      case "q58_rbl_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q58_weightLoss_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_D: value_int,
            date_D: null,
            D_empty_err: false,
            D_date_empty_err: false,
            D_date_before_index_err: false,
            D_date_before_onset_err: false,
            D_date_before_res_err: false,
            D_date_after_err: false,
            D_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q58_weightLoss_list: innerArr,
          };
        }
        break;
      //Q59
      case "q59_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q59_dysgeusia_list];
          let row = innerArr[id];

          //Delete rows if "The patient did not experience dysgeusia" is selected and reset column C, D of current row
          if (value_int === 1) {
            row = {
              ...row,
              chk_CC_1: false,
              chk_CC_1_P: false,
              chk_CC_1_T: false,
              chk_CC_2: false,
              chk_CC_2_P: false,
              chk_CC_2_T: false,
              chk_CC_3: false,
              chk_CC_3_P: false,
              chk_CC_3_T: false,
              chk_CC_4: false,
              chk_CC_4_P: false,
              chk_CC_4_T: false,
              chk_CC_5: false,
              chk_CC_5_P: false,
              chk_CC_5_T: false,
              chk_CC_6: false,
              chk_CC_6_P: false,
              chk_CC_6_T: false,
              chk_CC_7: false,
              chk_CC_7_P: false,
              chk_CC_7_T: false,
              txt_CC_oth: "",
              rb_CC: false,
              CC_1_empty_err: false,
              CC_2_empty_err: false,
              CC_3_empty_err: false,
              CC_4_empty_err: false,
              CC_5_empty_err: false,
              CC_6_empty_err: false,
              CC_7_empty_err: false,
              CC_empty_err: false,
              CC_txt_empty_err: false,

              rbl_C: null,
              date_C: null,
              C_empty_err: false,
              C_date_empty_err: false,
              C_date_before_index_err: false,
              C_date_before_onset_err: false,
              C_date_after_err: false,
              C_date_invalid: false,
              C_date_before_eof: false,
              rbl_D: null,
              date_D: null,
              D_empty_err: false,
              D_date_empty_err: false,
              D_date_before_index_err: false,
              D_date_before_onset_err: false,
              D_date_before_impr_err: false,
              D_date_after_err: false,
              D_date_invalid: false,
              D_date_before_eof: false,
            };

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          innerArr[id] = {
            ...row,
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          let q53 = [...updatedArray[parentIndex].q53_crs_list];

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.TALVEY
                ? adverseEventWarningTal &&
                  value_int == 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B == 1 &&
                  Q54.length &&
                  Q54[id]?.rbl_B == 1 &&
                  Q58.length &&
                  Q58[id]?.rbl_B == 1 &&
                  Q57.length &&
                  Q57[id]?.rbl_B == 1 &&
                  Q60.length &&
                  Q60[id]?.rbl_B == 1 &&
                  Q61.length &&
                  Q61[id]?.rbl_B == 1
                : false;
          }
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q59_dysgeusia_list: innerArr,
            q53_crs_list: q53,
          };
        }
        break;
      case "q59_chk_CC_1_" + id + "_" + parentIndex:
      case "q59_chk_CC_2_" + id + "_" + parentIndex:
      case "q59_chk_CC_3_" + id + "_" + parentIndex:
      case "q59_chk_CC_4_" + id + "_" + parentIndex:
      case "q59_chk_CC_5_" + id + "_" + parentIndex:
      case "q59_chk_CC_6_" + id + "_" + parentIndex:
      case "q59_chk_CC_7_" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q59_dysgeusia_list];
          // Extract the Check box state name
          const parts = name.split("_");
          const ctrlId = "chk_CC_" + parts[3];

          innerArr[id] = {
            ...innerArr[id],

            [ctrlId]: !innerArr[id][ctrlId],
            [ctrlId + "_P"]: false,
            [ctrlId + "_T"]: false,

            txt_CC_oth: ctrlId === "chk_CC_7" ? "" : innerArr[id].txt_CC_oth,
            rb_CC: false,
            CC_empty_err: false,
            CC_txt_empty_err: false, //ctrlId === "chk_CC_7" ? false : innerArr[id].CC_txt_empty_err,
            ["CC_" + parts[3] + "_empty_err"]: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q59_dysgeusia_list: innerArr,
          };
        }
        break;
      case "q59_txt_CC_oth" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q59_dysgeusia_list];

          innerArr[id] = {
            ...innerArr[id],
            txt_CC_oth: value,
            chk_CC_7: true,
            CC_empty_err: false,
            CC_txt_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q59_dysgeusia_list: innerArr,
          };
        }
        break;
      case "q59_rb_CC" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q59_dysgeusia_list];

          innerArr[id] = {
            ...innerArr[id],

            rb_CC: true,
            chk_CC_1: false,
            chk_CC_1_P: false,
            chk_CC_1_T: false,
            chk_CC_2: false,
            chk_CC_2_P: false,
            chk_CC_2_T: false,
            chk_CC_3: false,
            chk_CC_3_P: false,
            chk_CC_3_T: false,
            chk_CC_4: false,
            chk_CC_4_P: false,
            chk_CC_4_T: false,
            chk_CC_5: false,
            chk_CC_5_P: false,
            chk_CC_5_T: false,
            chk_CC_6: false,
            chk_CC_6_P: false,
            chk_CC_6_T: false,
            chk_CC_7: false,
            chk_CC_7_P: false,
            chk_CC_7_T: false,
            txt_CC_oth: "",

            CC_1_empty_err: false,
            CC_2_empty_err: false,
            CC_3_empty_err: false,
            CC_4_empty_err: false,
            CC_5_empty_err: false,
            CC_6_empty_err: false,
            CC_7_empty_err: false,
            CC_empty_err: false,
            CC_txt_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q59_dysgeusia_list: innerArr,
          };
        }
        break;

      case "q59_chk_CC_1_P_" + id + "_" + parentIndex:
      case "q59_chk_CC_2_P_" + id + "_" + parentIndex:
      case "q59_chk_CC_3_P_" + id + "_" + parentIndex:
      case "q59_chk_CC_4_P_" + id + "_" + parentIndex:
      case "q59_chk_CC_5_P_" + id + "_" + parentIndex:
      case "q59_chk_CC_6_P_" + id + "_" + parentIndex:
      case "q59_chk_CC_7_P_" + id + "_" + parentIndex:
      case "q59_chk_CC_1_T_" + id + "_" + parentIndex:
      case "q59_chk_CC_2_T_" + id + "_" + parentIndex:
      case "q59_chk_CC_3_T_" + id + "_" + parentIndex:
      case "q59_chk_CC_4_T_" + id + "_" + parentIndex:
      case "q59_chk_CC_5_T_" + id + "_" + parentIndex:
      case "q59_chk_CC_6_T_" + id + "_" + parentIndex:
      case "q59_chk_CC_7_T_" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q59_dysgeusia_list];
          // Extract the Check box state name
          const parts = name.split("_");
          const ctrlId = "chk_CC_" + parts[3] + "_" + parts[4];

          innerArr[id] = {
            ...innerArr[id],

            [ctrlId]: !innerArr[id][ctrlId],
            ["CC_" + parts[3] + "_empty_err"]: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q59_dysgeusia_list: innerArr,
          };
        }
        break;

      case "q59_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q59_dysgeusia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: value_int,
            date_C: null,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q59_dysgeusia_list: innerArr,
          };
        }
        break;
      case "q59_rbl_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q59_dysgeusia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_D: value_int,
            date_D: null,
            D_empty_err: false,
            D_date_empty_err: false,
            D_date_before_index_err: false,
            D_date_before_onset_err: false,
            D_date_before_impr_err: false,
            D_date_after_err: false,
            D_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q59_dysgeusia_list: innerArr,
          };
        }
        break;
      //60
      case "q60_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q60_nail_list];
          let row = innerArr[id];

          //Delete rows if "The patient did not experience nail disorder" is selected and reset column C, D of current row
          if (value_int === 1) {
            row = {
              ...row,
              rbl_C: null,
              date_C: null,
              C_empty_err: false,
              C_date_empty_err: false,
              C_date_before_index_err: false,
              C_date_before_onset_err: false,
              C_date_after_err: false,
              C_date_invalid: false,
              C_date_before_eof: false,

              rbl_D: null,
              date_D: null,
              D_empty_err: false,
              D_date_empty_err: false,
              D_date_before_index_err: false,
              D_date_before_onset_err: false,
              D_date_before_impr_err: false,
              D_date_after_err: false,
              D_date_invalid: false,
              D_date_before_eof: false,
            };

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          innerArr[id] = {
            ...row,
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          let q53 = [...updatedArray[parentIndex].q53_crs_list];

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.TALVEY
                ? adverseEventWarningTal &&
                  value_int == 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B == 1 &&
                  Q54.length &&
                  Q54[id]?.rbl_B == 1 &&
                  Q58.length &&
                  Q58[id]?.rbl_B == 1 &&
                  Q57.length &&
                  Q57[id]?.rbl_B == 1 &&
                  Q59.length &&
                  Q59[id]?.rbl_B == 1 &&
                  Q61.length &&
                  Q61[id]?.rbl_B == 1
                : false;
          }
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q60_nail_list: innerArr,
            q53_crs_list: q53,
          };
        }
        break;
      case "q60_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q60_nail_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: value_int,
            date_C: null,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q60_nail_list: innerArr,
          };
        }
        break;
      case "q60_rbl_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q60_nail_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_D: value_int,
            date_D: null,
            D_empty_err: false,
            D_date_empty_err: false,
            D_date_before_index_err: false,
            D_date_before_onset_err: false,
            D_date_before_impr_err: false,
            D_date_after_err: false,
            D_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q60_nail_list: innerArr,
          };
        }
        break;
      //61
      case "q61_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q61_skin_list];
          let row = innerArr[id];

          //Delete rows if "The patient did not experience skin disorder" is selected and reset column C, D of current row
          if (value_int === 1) {
            row = {
              ...row,
              rbl_C: null,
              date_C: null,
              C_empty_err: false,
              C_date_empty_err: false,
              C_date_before_index_err: false,
              C_date_before_onset_err: false,
              C_date_after_err: false,
              C_date_invalid: false,
              C_date_before_eof: false,

              rbl_D: null,
              date_D: null,
              D_empty_err: false,
              D_date_empty_err: false,
              D_date_before_index_err: false,
              D_date_before_onset_err: false,
              D_date_before_impr_err: false,
              D_date_after_err: false,
              D_date_invalid: false,
              D_date_before_eof: false,
            };
            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          innerArr[id] = {
            ...row,
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_before_eof: false,
          };

          let q53 = [...updatedArray[parentIndex].q53_crs_list];

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.TALVEY
                ? adverseEventWarningTal &&
                  value_int == 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B == 1 &&
                  Q54.length &&
                  Q54[id]?.rbl_B == 1 &&
                  Q58.length &&
                  Q58[id]?.rbl_B == 1 &&
                  Q57.length &&
                  Q57[id]?.rbl_B == 1 &&
                  Q59.length &&
                  Q59[id]?.rbl_B == 1 &&
                  Q60.length &&
                  Q60[id]?.rbl_B == 1
                : false;
          }
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q61_skin_list: innerArr,
            q53_crs_list: q53,
          };
        }
        break;
      case "q61_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q61_skin_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: value_int,
            date_C: null,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q61_skin_list: innerArr,
          };
        }
        break;
      case "q61_rbl_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q61_skin_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_D: value_int,
            date_D: null,
            D_empty_err: false,
            D_date_empty_err: false,
            D_date_before_index_err: false,
            D_date_before_onset_err: false,
            D_date_before_impr_err: false,
            D_date_after_err: false,
            D_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q61_skin_list: innerArr,
          };
        }
        break;
      //Q62
      case "q62_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q62_spm_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
            q62_rbl_C: null,
            q62_date_C: null,
            q62_severity: null,
            q62CEmptyError: false,
            q62CDateEmptyError: false,
            q62CDateInvalidError: false,
            q62CDateBeforeIndexError: false,
            q62CDateBeforeOnsetError: false,
            q62CDateAfterAEDateError: false,
            q62DEmptyError: false,
          };

          //Delete rows if "The patient did not experience ICANS" is selected
          if (value_int === 1) {
            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          let q53 = [...updatedArray[parentIndex].q53_crs_list];

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.CARVYKTI ||
              cohortid == RRMMCohortTreatment.ABECMA
                ? (adverseEventWarningCarvykti || adverseEventWarningAbecma) &&
                  value_int == 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B == 1 &&
                  Q54.length &&
                  Q54[id]?.rbl_B == 1 &&
                  Q56.length &&
                  Q56[id]?.rbl_B == 1 &&
                  Q55.length &&
                  Q55[id]?.rbl_B == 1 &&
                  Q63.length &&
                  Q63[id]?.rbl_B == 1 &&
                  (isNewEcrfA ? Q64.length && Q64[id]?.q64_rbl_B === 1 : true)
                : false;
          }
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q62_spm_list: innerArr,
            q53_crs_list: q53,
          };
        }
        break;
      case "q62_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q62_spm_list];

          innerArr[id] = {
            ...innerArr[id],
            q62_rbl_C: value_int,
            q62_date_C: null,
            q62CEmptyError: false,
            q62CDateEmptyError: false,
            q62CDateInvalidError: false,
            q62CDateBeforeIndexError: false,
            q62CDateBeforeOnsetError: false,
            q62CDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q62_spm_list: innerArr,
          };
        }
        break;

      case "q62_severity" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q62_spm_list];

          innerArr[id] = {
            ...innerArr[id],
            q62_severity: value_int,
            q62DEmptyError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q62_spm_list: innerArr,
          };
        }
        break;

      //63
      case "q63_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];
          let row = innerArr[id];

          //Delete rows if "The patient did not experience neurotoxicity" is selected and reset column C, D of current row
          if (value_int === 1) {
            row = {
              ...row,
              rbl_C: null,
              date_C: null,
              C_empty_err: false,
              C_date_empty_err: false,
              C_date_before_index_err: false,
              C_date_before_onset_err: false,
              C_date_after_err: false,
              C_date_invalid: false,
              C_date_before_eof: false,
              rbl_D: null,
              D_empty_err: false,
              rbl_E: null,
              E_empty_err: false,
              chk_F_1: false,
              chk_F_2: false,
              rb_F: false,
              F_empty_err: false,
              chk_G_1: false,
              chk_G_2: false,
              chk_G_3: false,
              chk_G_4: false,
              chk_G_5: false,
              rb_G: false,
              G_empty_err: false,

              chkFInpatient: false,
              chkFEmergencyRoom: false,
              chkFIntensiveCareUnit: false,
              chkFUrgentCareVisit: false,
              chkFOther: false,

              rblH: null,
              dateH: null,
              Hemptyerr: false,
              Hdateemptyerr: false,
              Hdateinvalid: false,
              Hdatebeforeindexerr: false,
              Hdatebeforeonseterr: false,
              Hdatebeforereserr: false,
              Hdateaftererr: false,
              Hdatebeforeeof: false,
            };

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              // Filter out manual rows only, keep auto-populated rows
              const rowsToKeep = innerArr.slice(0, deleteStartIndex);
              const rowsAfter = innerArr.slice(deleteStartIndex);

              const autoPopulatedRows = rowsAfter.filter(
                (r) => r.isAutoPopulated === true && r.rbl_D === 2,
              );

              innerArr = [...rowsToKeep, ...autoPopulatedRows];

              // innerArr.splice(
              //   deleteStartIndex,
              //   innerArr.length - deleteStartIndex,
              // );
            }
          }

          innerArr[id] = {
            ...row,
            rbl_B: value_int,
            date_B: null,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          let q53 = [...updatedArray[parentIndex].q53_crs_list];

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid == RRMMCohortTreatment.CARVYKTI ||
              cohortid == RRMMCohortTreatment.ABECMA
                ? (adverseEventWarningCarvykti || adverseEventWarningAbecma) &&
                  value_int == 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B == 1 &&
                  Q54.length &&
                  Q54[id]?.rbl_B == 1 &&
                  Q56.length &&
                  Q56[id]?.rbl_B == 1 &&
                  Q55.length &&
                  Q55[id]?.rbl_B == 1 &&
                  Q62.length &&
                  Q62[id]?.rbl_B == 1 &&
                  (isNewEcrfA ? Q64.length && Q64[id]?.q64_rbl_B === 1 : true)
                : false;
          }

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
            q53_crs_list: q53,
          };
        }
        break;
      case "q63_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: value_int,
            date_C: null,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };
        }
        break;
      case "q63_rbl_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_D: value_int,
            D_empty_err: false,

            ...(value_int !== 7 && {
              txt_D_oth: "",
              D_txt_empty_err: false,
            }),
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };
        }
        break;
      // Q63 - Column D Text Input (Other, please specify)
      case "q63_txt_D_oth" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];

          innerArr[id] = {
            ...innerArr[id],
            txt_D_oth: value,
            rbl_D: 7,
            D_empty_err: false,
            D_txt_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };

          setAEDetails(updatedArray);
        }
        break;

      case "q63_rbl_E" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_E: value_int,
            E_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };
        }
        break;

      case "q63_chk_F_1_" + id + "_" + parentIndex:
      case "q63_chk_F_2_" + id + "_" + parentIndex:
      case "q63chkFInpatient_" + id + "_" + parentIndex:
      case "q63chkFEmergencyRoom_" + id + "_" + parentIndex:
      case "q63chkFIntensiveCareUnit_" + id + "_" + parentIndex:
      case "q63chkFUrgentCareVisit_" + id + "_" + parentIndex:
      case "q63chkFOther_" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];
          // Extract the Check box state name
          const parts = name.split("_");
          //const ctrlId = "chk_F_" + parts[3];
          //const ctrlId = parts[0].replace("q63", "");

          let ctrlId;
          // Check if it's the old naming pattern (Outpatient)
          if (name.startsWith("q63_chk_F_")) {
            const parts = name.split("_");
            ctrlId = "chk_F_" + parts[3]; // Results in "chk_F_1"
          } else {
            // New naming pattern (chkFInpatient, chkFEmergencyRoom, etc.)
            ctrlId = name.split("_")[0].replace("q63", ""); // Removes "q63" prefix
          }

          innerArr[id] = {
            ...innerArr[id],

            [ctrlId]: !innerArr[id][ctrlId],
            rb_F: false,
            F_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };
        }
        break;
      case "q63_rb_F" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];

          innerArr[id] = {
            ...innerArr[id],

            rb_F: true,
            chk_F_1: false,
            chk_F_2: false,
            F_empty_err: false,

            chkFInpatient: false,
            chkFEmergencyRoom: false,
            chkFIntensiveCareUnit: false,
            chkFUrgentCareVisit: false,
            chkFOther: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };
        }
        break;
      case "q63_chk_G_1_" + id + "_" + parentIndex:
      case "q63_chk_G_2_" + id + "_" + parentIndex:
      case "q63_chk_G_3_" + id + "_" + parentIndex:
      case "q63_chk_G_4_" + id + "_" + parentIndex:
      case "q63_chk_G_5_" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];
          // Extract the Check box state name
          const parts = name.split("_");
          const ctrlId = "chk_G_" + parts[3];

          innerArr[id] = {
            ...innerArr[id],

            [ctrlId]: !innerArr[id][ctrlId],
            rb_G: false,
            G_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };
        }
        break;
      case "q63_rb_G" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];

          innerArr[id] = {
            ...innerArr[id],

            rb_G: true,
            chk_G_1: false,
            chk_G_2: false,
            chk_G_3: false,
            chk_G_4: false,
            chk_G_5: false,
            G_empty_err: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };
        }
        break;

      // Q63 - Column H (Improvement) - NEW
      case `q63rblH_${id}_${parentIndex}`:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];
          innerArr[id] = {
            ...innerArr[id],
            rblH: value_int,
            dateH: null,
            Hemptyerr: false,
            Hdateemptyerr: false,
            Hdateinvalid: false,
            Hdatebeforeindexerr: false,
            Hdatebeforeonseterr: false,
            Hdatebeforereserr: false,
            Hdateaftererr: false,
            Hdatebeforeeof: false,
          };
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };
        }
        break;

      //Q64
      case "q64_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q64_enterocolitis_list];
          let row = innerArr[id];

          //Delete rows if No Event occurred is selected and reset column C, D of current row
          if (value_int === 1) {
            row = {
              ...row,
              q64_rbl_C: null,
              q64_date_C: null,
              q64_rbl_D: null,
              q64_date_D: null,
              q64_chk_E_1: false,
              q64_chk_E_2: false,
              q64_chk_E_3: false,
              q64_chk_E_4: false,
              q64_chk_E_5: false,
              q64_chk_E_othTxt: "",
              q64_E_unk: false,
              q64_severity: null,
              //C Column
              q64CEmptyError: false,
              q64CDateEmptyError: false,
              q64CDateInvalidError: false,
              q64CDateBeforeError: false,
              q64CDateAfterResolutionDateError: false,
              q64CDateAfterAEDateError: false,

              //D Column
              q64DEmptyError: false,
              q64DDateEmptyError: false,
              q64DDateBeforeError: false,
              q64DDateInvalidError: false,
              q64DDateAfterAEDateError: false,

              //E Column
              q64EEmptyError: false,
              q64EOtherTxtEmptyError: false,

              //F
              q64FEmptyError: false,
            };

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          innerArr[id] = {
            ...row,
            q64_rbl_B: value_int,
            q64_date_B: null,
            q64BEmptyError: false,
            q64BDateEmptyError: false,
            q64BDateBeforeError: false,
            q64BDateInvalidError: false,
            q64BDateEqualPrevError: false,
            q64BDateBeforeIndexDateError: false,
            q64BDateAfterCDateError: false,
            q64BDateAfterResolutionDateError: false,
            q64BDateAfterAEDateError: false,
          };

          let q53 = [...updatedArray[parentIndex].q53_crs_list];

          let cohortid = updatedArray[parentIndex].cohortTreatmentId ?? null;
          if (q53[id]) {
            q53[id].ae_ManagementAeWarningTec =
              cohortid === RRMMCohortTreatment.CARVYKTI ||
              cohortid === RRMMCohortTreatment.ABECMA
                ? (adverseEventWarningCarvykti || adverseEventWarningAbecma) &&
                  value_int === 1 &&
                  Q53.length &&
                  Q53[id]?.rbl_B === 1 &&
                  Q54.length &&
                  Q54[id]?.rbl_B === 1 &&
                  Q56.length &&
                  Q56[id]?.rbl_B === 1 &&
                  Q55.length &&
                  Q55[id]?.rbl_B === 1 &&
                  Q62.length &&
                  Q62[id]?.rbl_B === 1 &&
                  Q63.length &&
                  Q63[id]?.rbl_B === 1
                : false;
          }

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q64_enterocolitis_list: innerArr,
            q53_crs_list: q53,
          };
        }
        break;
      case "q64_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q64_enterocolitis_list];

          innerArr[id] = {
            ...innerArr[id],
            q64_rbl_C: value_int,
            q64_date_C: null,
            q64CEmptyError: false,
            q64CDateEmptyError: false,
            q64CDateInvalidError: false,
            q64CDateBeforeError: false,
            q64CDateAfterResolutionDateError: false,
            q64CDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q64_enterocolitis_list: innerArr,
          };
        }
        break;
      case "q64_rbl_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q64_enterocolitis_list];

          innerArr[id] = {
            ...innerArr[id],
            q64_rbl_D: value_int,
            q64_date_D: null,
            q64DEmptyError: false,
            q64DDateEmptyError: false,
            q64DDateBeforeError: false,
            q64DDateInvalidError: false,
            q64DDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q64_enterocolitis_list: innerArr,
          };
        }
        break;

      case "q64_chk_E_1_" + id + "_" + parentIndex:
      case "q64_chk_E_2_" + id + "_" + parentIndex:
      case "q64_chk_E_3_" + id + "_" + parentIndex:
      case "q64_chk_E_4_" + id + "_" + parentIndex:
      case "q64_chk_E_5_" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q64_enterocolitis_list];
          const parts = name.split("_");

          const checkboxName = `q64_chk_E_${parts[3]}`;
          const isOther = checkboxName === "q64_chk_E_5";

          innerArr[id] = {
            ...innerArr[id],
            [checkboxName]: !(innerArr[id]?.[checkboxName] ?? false),
            q64EEmptyError: false,
            q64_E_unk: false,

            ...(isOther && {
              q64EOtherTxtEmptyError: false,
              q64_chk_E_othTxt: "",
            }),
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q64_enterocolitis_list: innerArr,
          };
        }
        break;
      case "q64_E_unk" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q64_enterocolitis_list];

          innerArr[id] = {
            ...innerArr[id],
            q64_E_unk: true,
            q64_chk_E_1: false,
            q64_chk_E_2: false,
            q64_chk_E_3: false,
            q64_chk_E_4: false,
            q64_chk_E_5: false,
            q64EEmptyError: false,
            q64EOtherTxtEmptyError: false,
            q64_chk_E_othTxt: "",
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q64_enterocolitis_list: innerArr,
          };
        }
        break;

      case "q64_chk_E_othTxt" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q64_enterocolitis_list];

          innerArr[id] = {
            ...innerArr[id],
            q64_chk_E_othTxt: value ?? "",
            q64_chk_E_5: true,
            q64EEmptyError: false,
            q64EOtherTxtEmptyError: false,
            q64_E_unk: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q64_enterocolitis_list: innerArr,
          };
        }
        break;

      case "q64_severity" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q64_enterocolitis_list];

          innerArr[id] = {
            ...innerArr[id],

            q64_severity: value_int,
            q64FEmptyError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q64_enterocolitis_list: innerArr,
          };
        }
        break;

      //Q65
      case "q65_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q65_lymphopenia_list];
          let row = innerArr[id];

          //Delete rows if No Event occurred is selected and reset column C, D of current row
          if (value_int === 1) {
            row = {
              ...row,
              q65_rbl_B: null,
              q65_date_B: null,
              q65_rbl_C: null,
              q65_date_C: null,
              q65_severity: null,

              //B Column
              q65BEmptyError: false,
              q65BDateEmptyError: false,
              q65BDateInvalidError: false,
              q65BDateEqualPrevError: false,
              q65BDateBeforeIndexDateError: false,
              q65BDateAfterAEDateError: false,

              //C Column
              q65CEmptyError: false,
              q65CDateEmptyError: false,
              q65CDateInvalidError: false,
              q65CDateBeforeError: false,
              q65CDateAfterAEDateError: false,

              //D Column
              q65DEmptyError: false,
            };

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          innerArr[id] = {
            ...row,
            q65_rbl_B: value_int,
            q65_date_B: null,
            q65BEmptyError: false,
            q65BDateEmptyError: false,
            q65BDateInvalidError: false,
            q65BDateEqualPrevError: false,
            q65BDateBeforeIndexDateError: false,
            q65BDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q65_lymphopenia_list: innerArr,
          };

          if (isNewEcrfB) {
            const computedWarnings = validateQ65Warnings(
              updatedArray,
              q65QLymphopheniaSelectionList,
            );

            setQ65Warnings(computedWarnings);
          }
        }

        break;
      case "q65_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q65_lymphopenia_list];

          innerArr[id] = {
            ...innerArr[id],
            q65_rbl_C: value_int,
            q65_date_C: null,
            q65CEmptyError: false,
            q65CDateEmptyError: false,
            q65CDateInvalidError: false,
            q65CDateBeforeError: false,
            q65CDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q65_lymphopenia_list: innerArr,
          };
        }
        break;

      case "q65_severity" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q65_lymphopenia_list];

          innerArr[id] = {
            ...innerArr[id],

            q65_severity: value_int,
            q65DEmptyError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q65_lymphopenia_list: innerArr,
          };
        }
        break;

      //Q57.1.B
      case "q571B_rbl_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q571B_immunoglobin_list];
          let row = innerArr[id];

          if (value_int === 1) {
            row = {
              ...row,
              q571B_rbl_B: null,
              q571B_date_B: null,
              q571B_rbl_C: null,
              q571B_unit_C: null,
              q571B_episode_D: null,

              //B Column
              q571BEmptyError: false,
              q571BDateEmptyError: false,
              q571BDateInvalidError: false,
              q571BDateEqualPrevError: false,
              q571BDateBeforeIndexDateError: false,
              q571BDateAfterDateError: false,

              //C Column
              q571CEmptyError: false,
              q571CUnitEmptyError: false,
              q571CUnitInvalidError: false,

              //D Column
              q571DEmptyError: false,
            };

            const deleteStartIndex = Number(id) + 1;
            if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
              innerArr.splice(
                deleteStartIndex,
                innerArr.length - deleteStartIndex,
              );
            }
          }

          innerArr[id] = {
            ...row,
            q571B_rbl_B: value_int,
            q571B_date_B: null,
            q571BEmptyError: false,
            q571BDateEmptyError: false,
            q571BDateInvalidError: false,
            q571BDateEqualPrevError: false,
            q571BDateBeforeIndexDateError: false,
            q571BDateAfterDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q571B_immunoglobin_list: innerArr,
          };

          if (isNewEcrfB) {
            const computedWarnings = validateQ571BWarnings(updatedArray);

            setQ571BWarnings(computedWarnings);
          }
        }
        break;

      case "q571B_rbl_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q571B_immunoglobin_list];

          innerArr[id] = {
            ...innerArr[id],
            q571B_rbl_C: value_int,
            q571B_unit_C: null,
            q571CEmptyError: false,
            q571CUnitEmptyError: false,
            q571CUnitInvalidError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q571B_immunoglobin_list: innerArr,
          };
        }
        break;

      case "q571B_episode_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q571B_immunoglobin_list];

          innerArr[id] = {
            ...innerArr[id],
            q571B_episode_D: value,
            q571DEmptyError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q571B_immunoglobin_list: innerArr,
          };
        }
        break;

      default:
        break;
    }

    setAEDetails(updatedArray);
  };

  const HandleRepeaterDateChange = (name, date, id) => {
    const lastUnderscoreIndex = name.lastIndexOf("_");
    const parentIndex = name.substring(lastUnderscoreIndex + 1);

    let updatedArray = [...aeDetails];
    switch (name) {
      case "q53_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q53_crs_list];

          // Update the specific item in the inner array
          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          // Assign the updated inner array back to the outer array
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q53_crs_list: innerArr,
          };
        }
        break;

      // q53 date of resolution
      case `q53dateresolution_${id}_${parentIndex}`:
        let innerArr2 = [...updatedArray[parentIndex].q53_crs_list];
        innerArr2[id] = {
          ...innerArr2[id],
          rbl_resolution: 2, // Set to "Event resolved on"
          date_resolution: date,
          resolutionemptyerr: false,
          resolutiondateemptyerr: false,
          resolutiondateinvalid: false,
          resolutiondaterangeerr: false,
        };
        updatedArray[parentIndex] = {
          ...updatedArray[parentIndex],
          q53_crs_list: innerArr2,
        };
        break;

      case "q54_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q54_icans_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q54_icans_list: innerArr,
          };
          updatedArray = AutoPopulateQ63FromQ54(parentIndex, updatedArray);
        }
        break;

      //q54 CASE FOR RESOLUTION DATE
      case `q54dateresolution_${id}_${parentIndex}`:
        {
          let innerArr2 = [...updatedArray[parentIndex].q54_icans_list];
          innerArr2[id] = {
            ...innerArr2[id],
            rblresolution: 2, // Set to "Event resolved on"
            dateresolution: date,
            resolutionemptyerr: false,
            resolutiondateemptyerr: false,
            resolutiondateinvalid: false,
            resolutiondaterangeerr: false,
          };
          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q54_icans_list: innerArr2,
          };
          updatedArray = AutoPopulateQ63FromQ54(parentIndex, updatedArray);
        }
        break;

      case "q55_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q55_neutropenia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q55_neutropenia_list: innerArr,
          };
        }
        break;
      case "q55_date_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q55_neutropenia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: 2,
            date_C: date,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
            C_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q55_neutropenia_list: innerArr,
          };
        }
        break;
      case "q56_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q56_cytopenia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q56_cytopenia_list: innerArr,
          };
        }
        break;
      case "q56_date_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q56_cytopenia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: 2,
            date_C: date,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
            C_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q56_cytopenia_list: innerArr,
          };
        }
        break;
      case "q57_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q57_infection_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          if (isNewEcrfB) {
            updatedArray[parentIndex] = rebuildInfectionEpisodesAndMappings(
              updatedArray[parentIndex],
              innerArr,
              updatedArray[parentIndex].q53_crs_list,
            );

            const computedWarnings = validateQ571BWarnings(updatedArray);
            setQ571BWarnings(computedWarnings);
          } else {
            updatedArray[parentIndex] = {
              ...updatedArray[parentIndex],
              q57_infection_list: innerArr,
            };
          }
        }
        break;
      case "q58_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q58_weightLoss_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q58_weightLoss_list: innerArr,
          };
        }
        break;
      case "q58_date_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q58_weightLoss_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: 2,
            date_C: date,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
            C_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q58_weightLoss_list: innerArr,
          };
        }
        break;
      case "q58_date_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q58_weightLoss_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_D: 2,
            date_D: date,
            D_empty_err: false,
            D_date_empty_err: false,
            D_date_before_index_err: false,
            D_date_before_onset_err: false,
            D_date_before_res_err: false,
            D_date_after_err: false,
            D_date_invalid: false,
            D_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q58_weightLoss_list: innerArr,
          };
        }
        break;
      case "q59_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q59_dysgeusia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q59_dysgeusia_list: innerArr,
          };
        }
        break;
      case "q59_date_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q59_dysgeusia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: 2,
            date_C: date,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
            C_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q59_dysgeusia_list: innerArr,
          };
        }
        break;
      case "q59_date_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q59_dysgeusia_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_D: 2,
            date_D: date,
            D_empty_err: false,
            D_date_empty_err: false,
            D_date_before_index_err: false,
            D_date_before_onset_err: false,
            D_date_before_impr_err: false,
            D_date_after_err: false,
            D_date_invalid: false,
            D_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q59_dysgeusia_list: innerArr,
          };
        }
        break;
      case "q60_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q60_nail_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q60_nail_list: innerArr,
          };
        }
        break;
      case "q60_date_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q60_nail_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: 2,
            date_C: date,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
            C_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q60_nail_list: innerArr,
          };
        }
        break;
      case "q60_date_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q60_nail_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_D: 2,
            date_D: date,
            D_empty_err: false,
            D_date_empty_err: false,
            D_date_before_index_err: false,
            D_date_before_onset_err: false,
            D_date_before_impr_err: false,
            D_date_after_err: false,
            D_date_invalid: false,
            D_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q60_nail_list: innerArr,
          };
        }
        break;
      case "q61_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q61_skin_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q61_skin_list: innerArr,
          };
        }
        break;
      case "q61_date_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q61_skin_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: 2,
            date_C: date,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
            C_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q61_skin_list: innerArr,
          };
        }
        break;
      case "q61_date_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q61_skin_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_D: 2,
            date_D: date,
            D_empty_err: false,
            D_date_empty_err: false,
            D_date_before_index_err: false,
            D_date_before_onset_err: false,
            D_date_before_impr_err: false,
            D_date_after_err: false,
            D_date_invalid: false,
            D_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q61_skin_list: innerArr,
          };
        }
        break;
      case "q62_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q62_spm_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q62_spm_list: innerArr,
          };
        }
        break;

      case "q62_date_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q62_spm_list];

          innerArr[id] = {
            ...innerArr[id],
            q62_rbl_C: 2,
            q62_date_C: date,
            q62CEmptyError: false,
            q62CDateEmptyError: false,
            q62CDateInvalidError: false,
            q62CDateBeforeIndexError: false,
            q62CDateBeforeOnsetError: false,
            q62CDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q62_spm_list: innerArr,
          };
        }
        break;
      case "q63_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_B: 2,
            date_B: date,
            B_empty_err: false,
            B_date_empty_err: false,
            B_date_before_err: false,
            B_date_after_err: false,
            B_date_equal_prev_ep_err: false,
            B_date_invalid: false,
            B_date_after_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };
        }
        break;
      case "q63_date_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];

          innerArr[id] = {
            ...innerArr[id],
            rbl_C: 2,
            date_C: date,
            C_empty_err: false,
            C_date_empty_err: false,
            C_date_before_index_err: false,
            C_date_before_onset_err: false,
            C_date_after_err: false,
            C_date_invalid: false,
            C_date_before_eof: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q63_neurotoxicity_list: innerArr,
          };
        }
        break;

      // Q63 date of improvement (Column H) - NEW
      case `q63dateH_${id}_${parentIndex}`:
        let innerArr = [...updatedArray[parentIndex].q63_neurotoxicity_list];
        innerArr[id] = {
          ...innerArr[id],
          rblH: 2, // Set to "Improvement occurred on date"
          dateH: date,
          Hemptyerr: false,
          Hdateemptyerr: false,
          Hdateinvalid: false,
          Hdatebeforeindexerr: false,
          Hdatebeforeonseterr: false,
          Hdatebeforereserr: false,
          Hdateaftererr: false,
          Hdatebeforeeof: false,
        };
        updatedArray[parentIndex] = {
          ...updatedArray[parentIndex],
          q63_neurotoxicity_list: innerArr,
        };
        break;

      //Q64
      case "q64_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q64_enterocolitis_list];

          innerArr[id] = {
            ...innerArr[id],
            q64_rbl_B: 2,
            q64_date_B: date,
            q64BEmptyError: false,
            q64BDateEmptyError: false,
            q64BDateBeforeError: false,
            q64BDateInvalidError: false,
            q64BDateEqualPrevError: false,
            q64BDateBeforeIndexDateError: false,
            q64BDateAfterCDateError: false,
            q64BDateAfterResolutionDateError: false,
            q64BDateAfterAEDateError: false,
            q64CDateBeforeError: false,
            q64CDateAfterResolutionDateError: false,
            q64CDateAfterAEDateError: false,
            q64DDateBeforeError: false,
            q64DDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q64_enterocolitis_list: innerArr,
          };
        }
        break;
      case "q64_date_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q64_enterocolitis_list];

          innerArr[id] = {
            ...innerArr[id],
            q64_rbl_C: 2,
            q64_date_C: date,
            q64CEmptyError: false,
            q64CDateEmptyError: false,
            q64CDateBeforeError: false,
            q64CDateInvalidError: false,
            q64CDateAfterResolutionDateError: false,
            q64CDateAfterAEDateError: false,
            q64BDateBeforeError: false,
            q64BDateBeforeIndexDateError: false,
            q64BDateAfterCDateError: false,
            q64BDateAfterResolutionDateError: false,
            q64BDateAfterAEDateError: false,
            q64DDateBeforeError: false,
            q64DDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q64_enterocolitis_list: innerArr,
          };
        }
        break;

      case "q64_date_D" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q64_enterocolitis_list];

          innerArr[id] = {
            ...innerArr[id],
            q64_rbl_D: 2,
            q64_date_D: date,
            q64DEmptyError: false,
            q64DDateEmptyError: false,
            q64DDateBeforeError: false,
            q64DDateInvalidError: false,
            q64DDateAfterAEDateError: false,
            q64BDateBeforeError: false,
            q64BDateBeforeIndexDateError: false,
            q64BDateAfterCDateError: false,
            q64BDateAfterResolutionDateError: false,
            q64BDateAfterAEDateError: false,
            q64CDateBeforeError: false,
            q64CDateAfterResolutionDateError: false,
            q64CDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q64_enterocolitis_list: innerArr,
          };
        }
        break;

      //Q65
      case "q65_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q65_lymphopenia_list];

          innerArr[id] = {
            ...innerArr[id],
            q65_rbl_B: 2,
            q65_date_B: date,
            q65BEmptyError: false,
            q65BDateEmptyError: false,
            q65BDateInvalidError: false,
            q65BDateEqualPrevError: false,
            q65BDateBeforeIndexDateError: false,
            q65BDateAfterAEDateError: false,
            q65CDateBeforeError: false,
            q65CDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q65_lymphopenia_list: innerArr,
          };

          if (isNewEcrfB) {
            const computedWarnings = validateQ65Warnings(
              updatedArray,
              q65QLymphopheniaSelectionList,
            );

            setQ65Warnings(computedWarnings);
          }
        }
        break;
      case "q65_date_C" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q65_lymphopenia_list];

          innerArr[id] = {
            ...innerArr[id],
            q65_rbl_C: 2,
            q65_date_C: date,
            q64CEmptyError: false,
            q65CEmptyError: false,
            q65CDateEmptyError: false,
            q65CDateInvalidError: false,
            q65CDateBeforeError: false,
            q65CDateAfterAEDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q65_lymphopenia_list: innerArr,
          };
        }
        break;

      //Q57.1.B
      case "q571B_date_B" + id + "_" + parentIndex:
        {
          let innerArr = [...updatedArray[parentIndex].q571B_immunoglobin_list];

          innerArr[id] = {
            ...innerArr[id],
            q571B_rbl_B: 2,
            q571B_date_B: date,
            q571BEmptyError: false,
            q571BDateEmptyError: false,
            q571BDateInvalidError: false,
            q571BDateEqualPrevError: false,
            q571BDateBeforeIndexDateError: false,
            q571BDateAfterDateError: false,
          };

          updatedArray[parentIndex] = {
            ...updatedArray[parentIndex],
            q571B_immunoglobin_list: innerArr,
          };
          if (isNewEcrfB) {
            const computedWarnings = validateQ571BWarnings(updatedArray);
            setQ571BWarnings(computedWarnings);
          }
        }
        break;

      default:
        break;
    }
    setAEDetails(updatedArray);
  };

  const HandleRepeaterUnitFieldChange = (e, radioValue) => {
    try {
      const { name, value } = e.target;

      const parts = name.replace("q571B_unit_C", "").split("_");
      const childIdx = Number(parts[0]);
      const parentIdx = Number(parts[1]);

      setAEDetails((prev) => {
        const newArr = [...prev];
        const parent = { ...newArr[parentIdx] };

        const list = [...(parent.q571B_immunoglobin_list || [])];
        const childRow = { ...list[childIdx] };

        childRow.q571B_unit_C = value;

        if (value !== "") {
          childRow.q571B_rbl_C = radioValue;
        }

        // Reset errors
        childRow.q571CEmptyError = false;
        childRow.q571CUnitEmptyError = false;
        childRow.q571CUnitInvalidError = false;

        list[childIdx] = childRow;
        parent.q571B_immunoglobin_list = list;
        newArr[parentIdx] = parent;

        return newArr;
      });
    } catch (e) {}
  };

  //Adding Deleting rows
  const DeleteQ53Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];
    const q53Array = [...aeDetails[cohortIndex].q53_crs_list];
    q53Array.splice(childIdx, 1);
    finalArray[cohortIndex].q53_crs_list = q53Array;

    setAEDetails(finalArray);
  };
  const AddQ53Row = (cohortIndex) => {
    //outer array index
    let newArray = [...aeDetails];
    // newArray[cohortIndex].q53_crs_list = [...newArray[cohortIndex].q53_crs_list, q53_crs_row];

    newArray[cohortIndex] = {
      ...newArray[cohortIndex],
      q53_crs_list: [...newArray[cohortIndex].q53_crs_list, q53_crs_row],
    };
    setAEDetails(newArray);
  };

  const DeleteQ54Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];
    const q54Array = [...aeDetails[cohortIndex].q54_icans_list];
    q54Array.splice(childIdx, 1);
    finalArray[cohortIndex].q54_icans_list = q54Array;

    const deletedRow = q54Array[childIdx];
    const deletedIcansId = deletedRow?.icansId;

    // Remove from Q54
    q54Array.splice(childIdx, 1);
    finalArray[cohortIndex].q54_icans_list = q54Array;

    if (deletedIcansId) {
      let q63Array = [...finalArray[cohortIndex].q63_neurotoxicity_list];

      // Find and remove Q63 row with matching sourceQ54IcansId
      q63Array = q63Array.filter((q63Row) => {
        // Keep manual rows and non-ICANS rows
        if (!q63Row.isAutoPopulated || q63Row.rbl_D !== 2) {
          return true;
        }
        // Remove auto-populated ICANS row if it matches the deleted Q54 row
        return q63Row.sourceQ54IcansId !== deletedIcansId;
      });

      finalArray[cohortIndex].q63_neurotoxicity_list = q63Array;
    }

    setAEDetails(finalArray);
  };

  const AddQ54Row = (cohortIndex) => {
    let newArray = [...aeDetails];

    newArray[cohortIndex] = {
      ...newArray[cohortIndex],
      q54_icans_list: [...newArray[cohortIndex].q54_icans_list, q54_icans_row],
    };
    setAEDetails(newArray);
  };
  const DeleteQ55Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];
    const q55Array = [...aeDetails[cohortIndex].q55_neutropenia_list];
    q55Array.splice(childIdx, 1);
    finalArray[cohortIndex].q55_neutropenia_list = q55Array;

    setAEDetails(finalArray);
  };
  const AddQ55Row = (cohortIndex) => {
    let newArray = [...aeDetails];

    newArray[cohortIndex] = {
      ...newArray[cohortIndex],
      q55_neutropenia_list: [
        ...newArray[cohortIndex].q55_neutropenia_list,
        q55_neutropenia_row,
      ],
    };
    setAEDetails(newArray);
  };
  const DeleteQ56Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];
    const q56Array = [...aeDetails[cohortIndex].q56_cytopenia_list];
    q56Array.splice(childIdx, 1);
    finalArray[cohortIndex].q56_cytopenia_list = q56Array;

    setAEDetails(finalArray);
  };
  const AddQ56Row = (cohortIndex) => {
    let newArray = [...aeDetails];

    newArray[cohortIndex] = {
      ...newArray[cohortIndex],
      q56_cytopenia_list: [
        ...newArray[cohortIndex].q56_cytopenia_list,
        q56_cytopenia_row,
      ],
    };
    setAEDetails(newArray);
  };

  const DeleteQ57Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];

    const cohort = finalArray[cohortIndex];

    const q57Array = [...cohort.q57_infection_list];
    const removedRow = q57Array[childIdx];
    const infectionKey = removedRow?.infectionKey;

    const isLinkedToQ571B = cohort.q571B_immunoglobin_list.some(
      (item) => item.q571B_episode_D === infectionKey,
    );

    const isLinkedToEpisodeList = cohort.infectionEpisodeList.some(
      (item) => item.infectionKey === infectionKey,
    );

    const shouldRevalidate =
      !!infectionKey && (isLinkedToQ571B || isLinkedToEpisodeList);

    // remove infection row
    q57Array.splice(childIdx, 1);

    // Update Q57.1.B (Immunoglobin)
    const updatedQ571BList = infectionKey
      ? cohort.q571B_immunoglobin_list.map((item) =>
          item.q571B_episode_D === infectionKey
            ? { ...item, q571B_episode_D: null, q571DEmptyError: false }
            : item,
        )
      : cohort.q571B_immunoglobin_list;

    // Sync InfectionEpisodeList
    const updatedEpisodeList = infectionKey
      ? cohort.infectionEpisodeList.filter(
          (item) => item.infectionKey !== infectionKey,
        )
      : cohort.infectionEpisodeList;

    finalArray[cohortIndex] = {
      ...cohort,
      q57_infection_list: q57Array,
      q571B_immunoglobin_list: updatedQ571BList,
      infectionEpisodeList: updatedEpisodeList,
    };

    setAEDetails(finalArray);

    if (shouldRevalidate) {
      setQ571BWarnings(validateQ571BWarnings(finalArray));
    }
  };

  const AddQ57Row = (cohortIndex) => {
    let newArray = [...aeDetails];

    const newRow = {
      ...q57_infection_row,
      infectionKey: GenerateKey(),
    };

    newArray[cohortIndex] = {
      ...newArray[cohortIndex],
      q57_infection_list: [...newArray[cohortIndex].q57_infection_list, newRow],
    };
    setAEDetails(newArray);
  };
  const DeleteQ58Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];
    const q58Array = [...aeDetails[cohortIndex].q58_weightLoss_list];
    q58Array.splice(childIdx, 1);
    finalArray[cohortIndex].q58_weightLoss_list = q58Array;

    setAEDetails(finalArray);
  };
  const AddQ58Row = (cohortIndex) => {
    let newArray = [...aeDetails];

    newArray[cohortIndex] = {
      ...newArray[cohortIndex],
      q58_weightLoss_list: [
        ...newArray[cohortIndex].q58_weightLoss_list,
        q58_weightLoss_row,
      ],
    };
    setAEDetails(newArray);
  };
  const DeleteQ59Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];
    const q59Array = [...aeDetails[cohortIndex].q59_dysgeusia_list];
    q59Array.splice(childIdx, 1);
    finalArray[cohortIndex].q59_dysgeusia_list = q59Array;

    setAEDetails(finalArray);
  };
  const AddQ59Row = (cohortIndex) => {
    let newArray = [...aeDetails];

    newArray[cohortIndex] = {
      ...newArray[cohortIndex],
      q59_dysgeusia_list: [
        ...newArray[cohortIndex].q59_dysgeusia_list,
        q59_dysgeusia_row,
      ],
    };
    setAEDetails(newArray);
  };
  const DeleteQ60Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];
    const q60Array = [...aeDetails[cohortIndex].q60_nail_list];
    q60Array.splice(childIdx, 1);
    finalArray[cohortIndex].q60_nail_list = q60Array;

    setAEDetails(finalArray);
  };
  const AddQ60Row = (cohortIndex) => {
    let newArray = [...aeDetails];

    newArray[cohortIndex] = {
      ...newArray[cohortIndex],
      q60_nail_list: [...newArray[cohortIndex].q60_nail_list, q60_nail_row],
    };
    setAEDetails(newArray);
  };
  const DeleteQ61Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];
    const q61Array = [...aeDetails[cohortIndex].q61_skin_list];
    q61Array.splice(childIdx, 1);
    finalArray[cohortIndex].q61_skin_list = q61Array;

    setAEDetails(finalArray);
  };
  const AddQ61Row = (cohortIndex) => {
    let newArray = [...aeDetails];

    newArray[cohortIndex] = {
      ...newArray[cohortIndex],
      q61_skin_list: [...newArray[cohortIndex].q61_skin_list, q61_skin_row],
    };
    setAEDetails(newArray);
  };
  const DeleteQ62Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];
    const q62Array = [...aeDetails[cohortIndex].q62_spm_list];
    q62Array.splice(childIdx, 1);
    finalArray[cohortIndex].q62_spm_list = q62Array;

    setAEDetails(finalArray);
  };

  const AddQ62Row = (cohortIndex, cohortTreatmentId) => {
    if (cohortIndex === null || cohortIndex === undefined) return;

    setAEDetails((prev) =>
      prev.map((item, idx) =>
        idx !== cohortIndex
          ? item
          : {
              ...item,
              q62_spm_list: [
                ...(item.q62_spm_list ?? []),
                {
                  ...q62_spm_row,
                  cohortTreatmentId,
                },
              ],
            },
      ),
    );
  };

  const DeleteQ63Row = (cohortIndex, childIdx) => {
    const finalArray = [...aeDetails];
    const q63Array = [...aeDetails[cohortIndex].q63_neurotoxicity_list];
    q63Array.splice(childIdx, 1);
    finalArray[cohortIndex].q63_neurotoxicity_list = q63Array;

    setAEDetails(finalArray);
  };
  const AddQ63Row = (cohortIndex) => {
    let newArray = [...aeDetails];

    newArray[cohortIndex] = {
      ...newArray[cohortIndex],
      q63_neurotoxicity_list: [
        ...newArray[cohortIndex].q63_neurotoxicity_list,
        q63_neurotoxicity_row,
      ],
    };
    setAEDetails(newArray);
  };

  const AddQ64Row = (cohortIndex, cohortTreatmentId) => {
    if (cohortIndex === null || cohortIndex === undefined) return;

    setAEDetails((prev) =>
      prev.map((item, idx) =>
        idx !== cohortIndex
          ? item
          : {
              ...item,
              q64_enterocolitis_list: [
                ...(item.q64_enterocolitis_list ?? []),
                {
                  ...q64_enterocolitis_row,
                  patientId: pid,
                  cohortTreatmentId,
                },
              ],
            },
      ),
    );
  };

  const DeleteQ64Row = (cohortIndex, childIdx) => {
    setAEDetails((prev) =>
      prev.map((item, idx) =>
        idx !== cohortIndex
          ? item
          : {
              ...item,
              q64_enterocolitis_list: item.q64_enterocolitis_list.filter(
                (_, i) => i !== childIdx,
              ),
            },
      ),
    );
  };

  const AddQ65Row = (cohortIndex, cohortTreatmentId) => {
    if (cohortIndex === null || cohortIndex === undefined) return;

    setAEDetails((prev) =>
      prev.map((item, idx) =>
        idx !== cohortIndex
          ? item
          : {
              ...item,
              q65_lymphopenia_list: [
                ...(item.q65_lymphopenia_list ?? []),
                {
                  ...q65_lymphopenia_row,
                  patientId: pid,
                  cohortTreatmentId,
                },
              ],
            },
      ),
    );
  };

  const DeleteQ571BRow = (cohortIndex, childIdx) => {
    setAEDetails((prev) => {
      const updatedArr = prev.map((item, idx) =>
        idx !== cohortIndex
          ? item
          : {
              ...item,
              q571B_immunoglobin_list: item.q571B_immunoglobin_list.filter(
                (_, i) => i !== childIdx,
              ),
            },
      );

      const qQ571BWarnings = validateQ571BWarnings(updatedArr);
      setQ571BWarnings(qQ571BWarnings);

      return updatedArr;
    });
  };

  const AddQ571BRow = (cohortIndex, cohortTreatmentId) => {
    if (cohortIndex === null || cohortIndex === undefined) return;

    setAEDetails((prev) =>
      prev.map((item, idx) =>
        idx !== cohortIndex
          ? item
          : {
              ...item,
              q571B_immunoglobin_list: [
                ...(item.q571B_immunoglobin_list ?? []),
                {
                  ...q571B_immunoglobin_row,
                  patientId: pid,
                  cohortTreatmentId,
                  subsequentLOTStartDate:
                    subsequentLOTDateList?.find(
                      (x) => x.cohortTreatmentId === cohortTreatmentId,
                    )?.subsequentLOTStartDate ?? null,
                },
              ],
            },
      ),
    );
  };

  const DeleteQ65Row = (cohortIndex, childIdx) => {
    setAEDetails((prev) =>
      prev.map((item, idx) =>
        idx !== cohortIndex
          ? item
          : {
              ...item,
              q65_lymphopenia_list: item.q65_lymphopenia_list.filter(
                (_, i) => i !== childIdx,
              ),
            },
      ),
    );
  };

  useEffect(() => {
    async function FetchData() {
      if (!isNaN(pid) && Number(pid) !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  async function LoadData() {
    try {
      if (pid > 0) {
        const response = await AdverseEventsService.GetAdverseEventsData(pid);
        if (response?.status !== HTTPResponse.OK) {
          if (response?.status === HTTPResponse.Unauthorized)
            HandleSessionTimeout();
          else if (response?.status === HTTPResponse.BadRequest)
            throw response.error;
        } else {
          const storedData = GetLocalStorageData("CohortTreatment");

          if (storedData) {
            const cohortTreatmentModelListt = JSON.parse(storedData);
            const rrmmTmtList = cohortTreatmentModelListt.filter(
              (c) => c.isEligible == true && !c.ndmm,
            );
            if (rrmmTmtList && rrmmTmtList.length > 0) {
              let list = [];
              const aeDateList = response?.data?.aE_DateList;
              const isNewEcrfB = response?.data?.isNewEcrfB ?? false;

              setQ36CRS(response?.data?.q36HospitalizationCRS);
              setQ39CRS(response?.data?.q39HospitalizationCRS);
              // setQ36ICANS(response?.data?.q36HospitalizationCRS);
              setQ36ICANS(response?.data?.q36HospitalizationICANS);
              setEndOfFollowUpDate(response?.data?.endOfFollowUpDate);
              setIsNewEcrfA(response?.data?.isNewEcrfA ?? false);
              setIsNewEcrfB(isNewEcrfB);
              setAdverseEventWarningTec(response?.data?.q33AdverseSelectedTec);
              setAdverseEventWarningTal(response?.data?.q33AdverseSelectedTal);
              setAdverseEventWarningElr(response?.data?.q33AdverseSelectedElr);
              setAdverseEventWarningLin(response?.data?.q33AdverseSelectedLin);
              setAdverseEventWarningCarvykti(
                response?.data?.q33AdverseSelectedCarvykti,
              );
              setAdverseEventWarningAbecma(
                response?.data?.q33AdverseSelectedAbecma,
              );
              const subsequentLOTList =
                response?.data?.cohortSubsequentLOTDateList ?? [];

              setSubsequentLOTDateList(subsequentLOTList);

              list = rrmmTmtList.map((ct) => {
                const cohortTreatmentId = ct.cohortTreatmentID;
                const cohortTreatmentName = ct.cohortTreatmentName;
                const superScriptText = ct.cohortTreatmentNameSuperscript;
                const cohortIndexDate = ct.earliestCohortIndexDate;
                let aeEndDate = "[AE end date]";

                if (aeDateList?.length > 0) {
                  aeEndDate =
                    aeDateList?.find(
                      (a) => a.cohortTreatmentId === ct.cohortTreatmentID,
                    )?.aeEndDate ?? "[AE end date]";
                }

                const isTECVAYLI =
                  ct.cohortTreatmentID === RRMMCohortTreatment.TECVAYLI;
                const isTALVEY =
                  ct.cohortTreatmentID === RRMMCohortTreatment.TALVEY;
                const isELREXFIO =
                  ct.cohortTreatmentID === RRMMCohortTreatment.ELREXFIO;
                const isLinvoseltamab =
                  ct.cohortTreatmentID === RRMMCohortTreatment.Linvoseltamab;
                const isCARVYKTI =
                  ct.cohortTreatmentID === RRMMCohortTreatment.CARVYKTI;
                const isABECMA =
                  ct.cohortTreatmentID === RRMMCohortTreatment.ABECMA;

                //Check if data is present for a cohort tmt
                const dbRow = response?.data?.adverseEventsData?.find(
                  (a) => a.cohortTreatmentId === ct.cohortTreatmentID,
                );
                let infectionEpisodeList = [];

                let q53_crs_list = [q53_crs_row]; //[]; //show for all cohorts
                let q54_icans_list = [q54_icans_row]; //show for all cohorts
                let q55_neutropenia_list =
                  isTECVAYLI ||
                  isTALVEY ||
                  isELREXFIO ||
                  isLinvoseltamab ||
                  isCARVYKTI ||
                  isABECMA
                    ? [q55_neutropenia_row]
                    : null; //“Tec”, “Elran”, “Linvo”, “Cilta-cel” or “Ide-cel”
                let q56_cytopenia_list =
                  isTECVAYLI ||
                  isTALVEY ||
                  isELREXFIO ||
                  isLinvoseltamab ||
                  isCARVYKTI ||
                  isABECMA
                    ? [q56_cytopenia_row]
                    : null; // “Tec”, “Elran”, “Linvo”, “Cilta-cel” or “Ide-cel”

                let q57_infection_list =
                  isTECVAYLI || isTALVEY || isELREXFIO || isLinvoseltamab
                    ? [
                        {
                          ...q57_infection_row,
                          infectionKey: GenerateKey(),
                        },
                      ]
                    : null; //“Tec”, “Tal”, “Elran”, or “Linvo”
                let q58_weightLoss_list = isTALVEY
                  ? [q58_weightLoss_row]
                  : null; //“Tal”
                let q59_dysgeusia_list = isTALVEY ? [q59_dysgeusia_row] : null; //“Tal”
                let q60_nail_list = isTALVEY ? [q60_nail_row] : null; //“Tal”
                let q61_skin_list = isTALVEY ? [q61_skin_row] : null; //“Tal”
                let q62_spm_list =
                  isCARVYKTI || isABECMA ? [q62_spm_row] : null; //“Cilta-cel” or “Ide-cel”
                let q63_neurotoxicity_list =
                  isCARVYKTI || isABECMA ? [q63_neurotoxicity_row] : null; //“Cilta-cel” or “Ide-cel”
                let q64_enterocolitis_list =
                  isCARVYKTI || isABECMA
                    ? [
                        {
                          ...q64_enterocolitis_row,
                          patientId: pid,
                          cohortTreatmentId: ct.cohortTreatmentID,
                        },
                      ]
                    : null; //“Cilta-cel” or “Ide-cel”
                let q65_lymphopenia_list = [
                  {
                    ...q65_lymphopenia_row,
                    patientId: pid,
                    cohortTreatmentId: ct.cohortTreatmentID,
                  },
                ]; //show for all cohorts

                let q571B_immunoglobin_list = [
                  {
                    ...q571B_immunoglobin_row,
                    patientId: pid,
                    cohortTreatmentId: ct.cohortTreatmentID,
                    subsequentLOTStartDate:
                      subsequentLOTList?.find(
                        (x) => x.cohortTreatmentId === ct.cohortTreatmentID,
                      )?.subsequentLOTStartDate ?? null,
                  },
                ]; //“Tec”, “Tal”, “Elran”, or “Linvo”

                if (dbRow) {
                  infectionEpisodeList = dbRow.infectionEpisodeList ?? [];

                  if (dbRow.aE_CRSList && dbRow.aE_CRSList.length > 0) {
                    q53_crs_list = dbRow.aE_CRSList.map((b) => ({
                      ...q53_crs_row,
                      crsId: b.aE_CRSId,
                      rbl_B: b.crsNotExperienced
                        ? 1
                        : b.csrDateUnk
                          ? 99
                          : !isStringEmpty(b.csrDate)
                            ? 2
                            : null,
                      date_B: b.csrDate,
                      rbl_C: b.severity,

                      rbl_resolution: b.crsresolution,
                      date_resolution: b.crsresolutiondate,

                      Q53q36WarningMsg:
                        Q36CRS == true && b.crsNotExperienced === true,
                      Q53q39WarningMsg:
                        Q39CRS == true && b.crsNotExperienced === true,
                    }));
                  }
                  if (dbRow.aE_IcansList && dbRow.aE_IcansList.length > 0) {
                    q54_icans_list = dbRow.aE_IcansList.map((b) => ({
                      ...q54_icans_row,
                      icansId: b.aE_ICANSId,
                      rbl_B: b.icansNotExperienced
                        ? 1
                        : b.icansOccuredDateUnk
                          ? 99
                          : !isStringEmpty(b.icansOccuredDate)
                            ? 2
                            : null,
                      date_B: b.icansOccuredDate,

                      rblC: b.severity,
                      rblresolution: b.icansresolution,
                      dateresolution: b.icansresolutiondate,

                      Q54q36WarningMsg:
                        Q36ICANS == true && b.icansNotExperienced === true,
                    }));
                  }
                  if (
                    dbRow.aE_NeutropeniumList &&
                    dbRow.aE_NeutropeniumList.length > 0
                  ) {
                    q55_neutropenia_list = dbRow.aE_NeutropeniumList.map(
                      (b) => ({
                        ...q55_neutropenia_row,
                        neutropeniaId: b.aE_NeutropeniaId,
                        rbl_B: b.neutropeniaNotExperienced
                          ? 1
                          : b.neutropeniaOnsetDateUnk
                            ? 99
                            : !isStringEmpty(b.neutropeniaOnsetDate)
                              ? 2
                              : null,
                        date_B: b.neutropeniaOnsetDate,
                        rbl_C: b.neutropeniaNotResolved
                          ? 1
                          : b.neutropeniaResolutionDateUnk
                            ? 3
                            : b.neutropeniaResolvedUnk
                              ? 99
                              : !isStringEmpty(b.neutropeniaResolutionDate)
                                ? 2
                                : null,
                        date_C: b.neutropeniaResolutionDate,

                        rblD: b.severity,
                      }),
                    );
                  }
                  if (
                    dbRow.aE_CytopeniumList &&
                    dbRow.aE_CytopeniumList.length > 0
                  ) {
                    q56_cytopenia_list = dbRow.aE_CytopeniumList.map((b) => ({
                      ...q56_cytopenia_row,
                      cytopeniaId: b.aE_CytopeniaId,
                      rbl_B: b.cytopeniaNotExperienced
                        ? 1
                        : b.cytopeniaOnsetDateUnk
                          ? 99
                          : !isStringEmpty(b.cytopeniaOnsetDate)
                            ? 2
                            : null,
                      date_B: b.cytopeniaOnsetDate,
                      rbl_C: b.cytopeniaNotResolved
                        ? 1
                        : b.cytopeniaResolutionDateUnk
                          ? 3
                          : b.cytopeniaResolvedUnk
                            ? 99
                            : !isStringEmpty(b.cytopeniaResolutionDate)
                              ? 2
                              : null,
                      date_C: b.cytopeniaResolutionDate,
                      rblD: b.severity,
                    }));
                  }
                  if (
                    dbRow.aE_InfectionList &&
                    dbRow.aE_InfectionList.length > 0
                  ) {
                    q57_infection_list = dbRow.aE_InfectionList.map((b) => ({
                      ...q57_infection_row,
                      infectionId: b.aE_InfectionId,
                      infectionKey: b.infectionKey,
                      rbl_B: b.infectionNotExperienced
                        ? 1
                        : b.infectionOccuredDateUnk
                          ? 99
                          : !isStringEmpty(b.infectionOccuredDate)
                            ? 2
                            : null,
                      date_B: b.infectionOccuredDate,
                      chk_C_1: b.infectionTypeBacterial,
                      chk_C_2: b.infectionTypeViral,
                      chk_C_3: b.infectionTypeFungal,
                      rb_C: b.infectionTypeUnk,
                      chk_D_1: b.infectionOrganismAdenovirus,
                      chk_D_2: b.infectionOrganismCandida,
                      chk_D_3: b.infectionOrganismCovid19,
                      chk_D_4: b.infectionOrganismCytomegalovirus,
                      chk_D_5: b.infectionOrganismEscherichia,
                      chk_D_6: b.infectionOrganismHelicobacter,
                      chk_D_7: b.infectionOrganismHepatitis,
                      chk_D_8: b.infectionOrganismHerpes,
                      chk_D_9: b.infectionOrganismInfluenza,
                      chk_D_10: b.infectionOrganismPjp,
                      chk_D_11: b.infectionOrganismProgressive,
                      chk_D_12: b.infectionOrganismRsv,
                      chk_D_13: b.infectionOrganismStreptococcus,
                      chk_D_14: b.infectionOrganismVaricella,
                      chk_D_15: b.infectionOrganismOth,
                      txt_D_oth: b.infectionOrganismOthTxt || "",
                      rb_D: b.infectionOrganismUnk,
                      rbl_E: b.severity,
                      rbl_F: b.ledErVisit,
                      chk_G_1: b.managementSettingOutpatient,
                      chk_G_2: b.managementSettingInpatient,
                      chk_G_3: b.managementSettingEmergencyroom,
                      chk_G_4: b.managementSettingIntensivecareunit,
                      chk_G_5: b.managementSettingOth,
                      rb_G_unk: b.managementSettingUnk,
                      txt_G_oth: b.managementSettingOthTxt || "",
                    }));
                  }
                  if (
                    dbRow.aE_WeightLossList &&
                    dbRow.aE_WeightLossList.length > 0
                  ) {
                    q58_weightLoss_list = dbRow.aE_WeightLossList.map((b) => ({
                      ...q58_weightLoss_row,
                      weightLossId: b.aE_WeightLossId,
                      rbl_B: b.noWeightLoss
                        ? 1
                        : b.weightLossOnsetDateUnk
                          ? 99
                          : !isStringEmpty(b.weightLossOnsetDate)
                            ? 2
                            : null,
                      date_B: b.weightLossOnsetDate,
                      rbl_C: b.weightLossNotResolve
                        ? 1
                        : b.resolutionDateUnknown
                          ? 3
                          : b.weightLossResolveUnknown
                            ? 99
                            : !isStringEmpty(b.weightLossResolutionDate)
                              ? 2
                              : null,
                      date_C: b.weightLossResolutionDate,
                      rbl_D: b.weightNotStabilize
                        ? 1
                        : b.stabilizationDateUnknown
                          ? 3
                          : b.weightStabilizeUnknown
                            ? 99
                            : !isStringEmpty(b.weightStabilizationDate)
                              ? 2
                              : null,
                      date_D: b.weightStabilizationDate,
                    }));
                  }
                  if (
                    dbRow.aE_DysgeusiumList &&
                    dbRow.aE_DysgeusiumList.length > 0
                  ) {
                    q59_dysgeusia_list = dbRow.aE_DysgeusiumList.map((b) => ({
                      ...q59_dysgeusia_row,
                      dysgeusiaId: b.aE_DysgeusiaId,
                      rbl_B: b.dysgeusiaNotexperienced
                        ? 1
                        : b.dysgeusiaOnsetDateUnk
                          ? 99
                          : !isStringEmpty(b.dysgeusiaOnsetOcurredDate)
                            ? 2
                            : null,
                      date_B: b.dysgeusiaOnsetOcurredDate,

                      chk_CC_1: b.interventionDexamethasoneMouthwash,
                      chk_CC_1_P: b.dexamethasoneMouthwashProphylactic,
                      chk_CC_1_T: b.dexamethasoneMouthwashTherapeutic,
                      chk_CC_2: b.interventionNystatinMouthwash,
                      chk_CC_2_P: b.nystatinMouthwashProphylactic,
                      chk_CC_2_T: b.nystatinMouthwashTherapeutic,
                      chk_CC_3: b.interventionSalineMouthwash,
                      chk_CC_3_P: b.salineMouthwashProphylactic,
                      chk_CC_3_T: b.salineMouthwashTherapeutic,
                      chk_CC_4: b.interventionBioteneMouthwash,
                      chk_CC_4_P: b.bioteneMouthwashProphylactic,
                      chk_CC_4_T: b.bioteneMouthwashTherapeutic,
                      chk_CC_5: b.interventionZincMouthwash,
                      chk_CC_5_P: b.zincMouthwashProphylactic,
                      chk_CC_5_T: b.zincMouthwashTherapeutic,
                      chk_CC_6: b.interventionVitaminbMouthwash,
                      chk_CC_6_P: b.vitaminbMouthwashProphylactic,
                      chk_CC_6_T: b.vitaminbMouthwashTherapeutic,
                      chk_CC_7: b.interventionOtherMouthwash,
                      txt_CC_oth: b.interventionOthertextMouthwash,
                      chk_CC_7_P: b.otherMouthwashProphylactic,
                      chk_CC_7_T: b.otherMouthwashTherapeutic,
                      rb_CC: b.interventionUnknown,

                      rbl_C: b.noImprovement
                        ? 1
                        : b.improvementDateUnk
                          ? 3
                          : b.improvementUnk
                            ? 99
                            : !isStringEmpty(b.improvementDate)
                              ? 2
                              : null,
                      date_C: b.improvementDate,
                      rbl_D: b.dysgeusiaNotResolved
                        ? 1
                        : b.resolutionOccuredDateUnk
                          ? 3
                          : b.dysgeusiaResolvedUnk
                            ? 99
                            : !isStringEmpty(b.resolutionOccuredDate)
                              ? 2
                              : null,
                      date_D: b.resolutionOccuredDate,
                    }));
                  }
                  if (
                    dbRow.aE_NaildisorderList &&
                    dbRow.aE_NaildisorderList.length > 0
                  ) {
                    q60_nail_list = dbRow.aE_NaildisorderList.map((b) => ({
                      ...q60_nail_row,
                      nailDisorderId: b.aE_NailDisorderId,
                      rbl_B: b.naildisorderNotexperienced
                        ? 1
                        : b.naildisorderOnsetDateUnk
                          ? 99
                          : !isStringEmpty(b.naildisorderOnsetOcurredDate)
                            ? 2
                            : null,
                      date_B: b.naildisorderOnsetOcurredDate,
                      rbl_C: b.noImprovement
                        ? 1
                        : b.improvementDateUnk
                          ? 3
                          : b.improvementUnk
                            ? 99
                            : !isStringEmpty(b.improvementDate)
                              ? 2
                              : null,
                      date_C: b.improvementDate,

                      rbl_D: b.naildisorderNotResolved
                        ? 1
                        : b.naildisorderOccuredDateUnk
                          ? 3
                          : b.naildisorderResolvedUnk
                            ? 99
                            : !isStringEmpty(b.naildisorderOccuredDate)
                              ? 2
                              : null,
                      date_D: b.naildisorderOccuredDate,
                    }));
                  }
                  if (
                    dbRow.aE_SkinDisorderList &&
                    dbRow.aE_SkinDisorderList.length > 0
                  ) {
                    q61_skin_list = dbRow.aE_SkinDisorderList.map((b) => ({
                      ...q61_skin_row,
                      skinDisorderId: b.aE_SkinDisorderId,
                      rbl_B: b.skindisorderNotexperienced
                        ? 1
                        : b.skindisorderOnsetDateUnk
                          ? 99
                          : !isStringEmpty(b.skindisorderOnsetOcurredDate)
                            ? 2
                            : null,
                      date_B: b.skindisorderOnsetOcurredDate,
                      rbl_C: b.noImprovement
                        ? 1
                        : b.improvementDateUnk
                          ? 3
                          : b.improvementUnk
                            ? 99
                            : !isStringEmpty(b.improvementDate)
                              ? 2
                              : null,
                      date_C: b.improvementDate,

                      rbl_D: b.skindisorderNotResolved
                        ? 1
                        : b.skindisorderOccuredDateUnk
                          ? 3
                          : b.skindisorderResolvedUnk
                            ? 99
                            : !isStringEmpty(b.skindisorderOccuredDate)
                              ? 2
                              : null,
                      date_D: b.skindisorderOccuredDate,
                    }));
                  }

                  if (dbRow.aE_SecondaryPrimaryMalignancyList?.length > 0) {
                    q62_spm_list = dbRow.aE_SecondaryPrimaryMalignancyList.map(
                      (b) => ({
                        ...q62_spm_row,
                        cohortTreatmentId: b.cohortTreatmentId,
                        spmId: b.aE_SecondaryPrimaryMalignancyId,
                        rbl_B: b.secondMalignancyNotReceived
                          ? 1
                          : b.secondMalignancyOccuredDateUnk
                            ? 99
                            : !isStringEmpty(b.secondMalignancyOccuredDate)
                              ? 2
                              : null,
                        date_B: b.secondMalignancyOccuredDate,
                        q62_rbl_C: b.secondMalignancyResolution ?? null,
                        q62_date_C: b.secondMalignancyResolutionDate ?? "",
                        q62_severity: b.severity ?? null,
                      }),
                    );
                  }
                  if (
                    dbRow.aE_NeurotoxicityList &&
                    dbRow.aE_NeurotoxicityList.length > 0
                  ) {
                    q63_neurotoxicity_list = dbRow.aE_NeurotoxicityList.map(
                      (b) => ({
                        ...q63_neurotoxicity_row,
                        neurotoxicityId: b.aE_NeurotoxicityId,
                        rbl_B: b.neurotoxicityNotExperienced
                          ? 1
                          : b.neurotoxicityOnsetOccuredDateUnk
                            ? 99
                            : !isStringEmpty(b.neurotoxicityOnsetOccuredDate)
                              ? 2
                              : null,
                        date_B: b.neurotoxicityOnsetOccuredDate,
                        rbl_C: b.neurotoxicityNotResolved
                          ? 1
                          : b.resolutionOccuredDateUnk
                            ? 3
                            : b.neurotoxicityResolvedUnk
                              ? 99
                              : !isStringEmpty(b.resolutionOccuredDate)
                                ? 2
                                : null,
                        date_C: b.resolutionOccuredDate,
                        rbl_D: b.neurotoxicitySubtype,
                        txt_D_oth: b.neurotoxicitySubtypeOth || "",
                        rbl_E: b.severity,
                        chk_F_1: b.managementSettingOutpatient,
                        chk_F_2: b.managementSettingHospital,
                        rb_F: b.managementSettingUnk,
                        chk_G_1: b.interventionsCorticosteroids,
                        chk_G_2: b.interventionsAnakinra,
                        chk_G_3: b.interventionsTocilizumab,
                        chk_G_4: b.interventionsSiltuximab,
                        chk_G_5: b.interventionsOth,
                        rb_G: b.interventionsUnk,

                        chkFInpatient: b.managementSettingInpatient,
                        chkFEmergencyRoom: b.managementSettingEmergencyroom,
                        chkFIntensiveCareUnit:
                          b.managementSettingIntensivecareunit,
                        chkFUrgentCareVisit: b.managementSettingUrgentcarevisit,
                        chkFOther: b.managementSettingOth,

                        rblH: b.improvement,
                        dateH: b.improvementdate,

                        isAutoPopulated: b.isDependent || false,
                        sourceQ54IcansId: b.sourceQ54IcansId,
                      }),
                    );
                  }

                  if (dbRow.aE_EnterocolitisList?.length > 0) {
                    q64_enterocolitis_list = dbRow.aE_EnterocolitisList.map(
                      (b) => ({
                        ...q64_enterocolitis_row,
                        adverseevententerocolitisid:
                          b.adverseevententerocolitisid,
                        patientId: b.patientId,
                        cohortTreatmentId: b.cohortTreatmentId,
                        q64_rbl_B: b.enterocolitisOnsetEventOccurred ?? null,
                        q64_date_B: b.enterocolitisEventOccurredDate ?? "",
                        q64_rbl_C: b.enterocolitisImprovement ?? null,
                        q64_date_C: b.enterocolitisImprovementDate ?? "",
                        q64_rbl_D: b.enterocolitisEventResolution,
                        q64_date_D: b.resolutionEventResolutionDate ?? "",
                        q64_chk_E_1:
                          b.enterocolitisInterventionsSupportiveCare ?? false,
                        q64_chk_E_2:
                          b.enterocolitisInterventionsAntibiotics ?? false,
                        q64_chk_E_3:
                          b.enterocolitisInterventionsSurgery ?? false,
                        q64_chk_E_4: b.enterocolitisInterventionsGcsf ?? false,
                        q64_chk_E_5: b.enterocolitisInterventionsOth ?? false,
                        q64_chk_E_othTxt:
                          b.enterocolitisInterventionsOthTxt ?? "",
                        q64_E_unk: b.enterocolitisInterventionsUnk ?? false,
                        q64_severity: b.severity,
                      }),
                    );
                  }

                  if (dbRow.aE_LymphopeniaList?.length > 0 && isNewEcrfB) {
                    q65_lymphopenia_list = dbRow.aE_LymphopeniaList.map(
                      (b) => ({
                        ...q65_lymphopenia_row,
                        adverseeventlymphopeniaid: b.adverseeventlymphopeniaid,
                        patientId: b.patientId,
                        cohortTreatmentId: b.cohortTreatmentId,
                        q65_rbl_B: b.lymphopeniaOnsetEventOccurred ?? null,
                        q65_date_B: b.lymphopeniaEventOccurredDate ?? "",
                        q65_rbl_C: b.lymphopeniaEventResolution,
                        q65_date_C: b.lymphopeniaResolutionDate ?? "",
                        q65_severity: b.severity,
                      }),
                    );
                  }

                  if (dbRow.aE_ImmunoglobinList?.length > 0 && isNewEcrfB) {
                    q571B_immunoglobin_list = dbRow.aE_ImmunoglobinList.map(
                      (b) => ({
                        ...q571B_immunoglobin_row,
                        adverseeventimmunoglobinid:
                          b.adverseeventimmunoglobinid,
                        patientId: b.patientId,
                        cohortTreatmentId: b.cohortTreatmentId,
                        q571B_rbl_B: b.immunoglobinNotAssessed ?? null,
                        q571B_date_B: b.immunoglobinAssessmentDate ?? "",
                        q571B_rbl_C: b.immunoglobinDosage,
                        q571B_unit_C: b.immunoglobinDosageUnit,
                        q571B_episode_D: b.infectionKey,
                        subsequentLOTStartDate:
                          subsequentLOTList?.find(
                            (x) => x.cohortTreatmentId === ct.cohortTreatmentID,
                          )?.subsequentLOTStartDate ?? null,
                      }),
                    );
                  }

                  return {
                    ...AERow,
                    cohortTreatmentId,
                    cohortTreatmentName,
                    superScriptText,
                    cohortIndexDate,
                    aeEndDate,
                    q53_crs_list,
                    q54_icans_list,
                    q55_neutropenia_list,
                    q56_cytopenia_list,
                    q57_infection_list,
                    q58_weightLoss_list,
                    q59_dysgeusia_list,
                    q60_nail_list,
                    q61_skin_list,
                    q62_spm_list,
                    q63_neurotoxicity_list,
                    q64_enterocolitis_list,
                    q65_lymphopenia_list,
                    q571B_immunoglobin_list,
                    infectionEpisodeList,
                  };
                } else {
                  return {
                    ...AERow,
                    cohortTreatmentId,
                    cohortTreatmentName,
                    superScriptText,
                    cohortIndexDate,
                    aeEndDate,

                    q53_crs_list,
                    q54_icans_list,
                    q55_neutropenia_list,
                    q56_cytopenia_list,
                    q57_infection_list,
                    q58_weightLoss_list,
                    q59_dysgeusia_list,
                    q60_nail_list,
                    q61_skin_list,
                    q62_spm_list,
                    q63_neurotoxicity_list,
                    q64_enterocolitis_list,
                    q65_lymphopenia_list,
                    q571B_immunoglobin_list,
                    infectionEpisodeList,
                  };
                }
              });

              const q65SelectionList =
                response?.data?.q65CohortLymphopeniaSelections || [];

              setQ65LymphopheniaSelectionList(q65SelectionList);

              if (isNewEcrfB) {
                const q65Warnings = validateQ65Warnings(list, q65SelectionList);
                setQ65Warnings(q65Warnings);

                const qQ571BWarnings = validateQ571BWarnings(list);
                setQ571BWarnings(qQ571BWarnings);
              }

              // Recalculate warning flags for every cohort AFTER building the data
              const finalList = list.map((ae) =>
                computeAEWarnings(response?.data, ae),
              );

              setAEDetails(finalList);
            }
          }
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  }

  const validateQ65Warnings = (aelist, q65SelectionList) => {
    const warnings = {};
    if (aelist?.length > 0) {
      aelist.forEach((ae) => {
        const cohortTreatmentId = ae.cohortTreatmentId;

        const selection = q65SelectionList?.find(
          (x) => x.cohortTreatmentId === cohortTreatmentId,
        );

        const isQ26Selected = selection?.q26Selected ?? false;
        const isQ38Selected = selection?.q38Selected ?? false;
        const isQ43Selected = selection?.q43Selected ?? false;

        const lymphopeniaList = ae.q65_lymphopenia_list || [];

        const hasEvents = lymphopeniaList.some(
          (e) => e.q65_rbl_B === 2 || e.q65_rbl_B === 99,
        );

        warnings[cohortTreatmentId] = {
          q26Discontinuation: isQ26Selected && !hasEvents,
          q38DoseChange: isQ38Selected && !hasEvents,
          q43SteroidUse: isQ43Selected && !hasEvents,
        };
      });
    }

    return warnings;
  };

  const validateQ571BWarnings = (aelist) => {
    const warnings = {};

    if (aelist?.length > 0) {
      aelist.forEach((ae) => {
        const cohortTreatmentId = ae.cohortTreatmentId;
        const q571BList = ae.q571B_immunoglobin_list ?? [];
        const q57List = ae.q57_infection_list ?? [];

        let rowWarning = false;

        q571BList.forEach((item) => {
          const assessmentDate = item.q571B_date_B
            ? new Date(item.q571B_date_B)
            : null;

          const infectionEpisode = q57List?.find(
            (ep) => ep.infectionKey === item.q571B_episode_D,
          );

          const onsetDate = infectionEpisode?.date_B
            ? new Date(infectionEpisode.date_B)
            : null;

          if (assessmentDate && onsetDate && assessmentDate < onsetDate) {
            rowWarning = true;
          }
        });

        warnings[cohortTreatmentId] = {
          q571BDateWarning: rowWarning,
        };
      });
    }

    return warnings;
  };

  function computeAEWarnings(responseData, ae) {
    const cohortId = ae.cohortTreatmentId;

    const isTEC = cohortId === RRMMCohortTreatment.TECVAYLI;
    const isTAL = cohortId === RRMMCohortTreatment.TALVEY;
    const isELR = cohortId === RRMMCohortTreatment.ELREXFIO;
    const isLIN = cohortId === RRMMCohortTreatment.Linvoseltamab;
    const isCAR = cohortId === RRMMCohortTreatment.CARVYKTI;
    const isABE = cohortId === RRMMCohortTreatment.ABECMA;

    const Q53 = ae.q53_crs_list;
    const Q54 = ae.q54_icans_list;
    const Q55 = ae.q55_neutropenia_list;
    const Q56 = ae.q56_cytopenia_list;
    const Q57 = ae.q57_infection_list;
    const Q58 = ae.q58_weightLoss_list;
    const Q59 = ae.q59_dysgeusia_list;
    const Q60 = ae.q60_nail_list;
    const Q61 = ae.q61_skin_list;
    const Q62 = ae.q62_spm_list;
    const Q63 = ae.q63_neurotoxicity_list;
    const Q64 = ae.q64_enterocolitis_list;

    const newQ53 = Q53.map((row, i) => {
      const val53 = row?.rbl_B ?? null; // 1/2/99/null

      let warn = false;

      // ------------ TECVAYLI ------------
      if (isTEC) {
        warn =
          responseData.q33AdverseSelectedTec &&
          Q53[i]?.rbl_B == 1 &&
          Q54[i]?.rbl_B == 1 &&
          Q55[i]?.rbl_B == 1 &&
          Q56[i]?.rbl_B == 1 &&
          Q57[i]?.rbl_B == 1;
      }

      // ------------ TALVEY ------------
      if (isTAL) {
        warn =
          responseData.q33AdverseSelectedTal &&
          Q53[i]?.rbl_B == 1 &&
          Q54[i]?.rbl_B == 1 &&
          Q57[i]?.rbl_B == 1 &&
          Q58[i]?.rbl_B == 1 &&
          Q59[i]?.rbl_B == 1 &&
          Q60[i]?.rbl_B == 1 &&
          Q61[i]?.rbl_B == 1;
      }

      // ------------ ELREXFIO ---------
      if (isELR) {
        warn =
          responseData.q33AdverseSelectedElr &&
          Q53[i]?.rbl_B == 1 &&
          Q54[i]?.rbl_B == 1 &&
          Q55[i]?.rbl_B == 1 &&
          Q56[i]?.rbl_B == 1 &&
          Q57[i]?.rbl_B == 1;
      }

      // ------------ LINVAL ---------
      if (isLIN) {
        warn =
          responseData.q33AdverseSelectedLin &&
          Q53[i]?.rbl_B == 1 &&
          Q54[i]?.rbl_B == 1 &&
          Q55[i]?.rbl_B == 1 &&
          Q56[i]?.rbl_B == 1 &&
          Q57[i]?.rbl_B == 1;
      }

      // ------------ CARVYKTI / ABECMA ----------
      if (isCAR || isABE) {
        warn =
          (responseData.q33AdverseSelectedCarvykti ||
            responseData.q33AdverseSelectedAbecma) &&
          Q53[i]?.rbl_B == 1 &&
          Q54[i]?.rbl_B == 1 &&
          Q55[i]?.rbl_B == 1 &&
          Q56[i]?.rbl_B == 1 &&
          Q62[i]?.rbl_B == 1 &&
          Q63[i]?.rbl_B == 1 &&
          (isNewEcrfA ? Q64[i]?.q64_rbl_B === 1 : true);
      }

      return {
        ...row,
        ae_ManagementAeWarningTec: warn,
      };
    });

    return {
      ...ae,
      q53_crs_list: newQ53,
    };
  }

  const SavePage = async (validate) => {
    try {
      ToggleLoader(true);
      let isValid = validate ? Validate() : true;

      if (isValid) {
        setShowTopErrMsg(false);

        let payload = {
          AdverseEventsData: [],
          PatientId: pid,
          UserId: GetLoggedInUserID(),
          IsValidated: validate,
          IsAdmin: IsAdmin(),
        };
        if (aeDetails && aeDetails.length > 0) {
          payload.AdverseEventsData = aeDetails.map((a) => {
            let AE_CRSList = [];
            let AE_IcansList = [];
            let AE_NeutropeniumList = [];
            let AE_CytopeniumList = [];
            let AE_InfectionList = [];
            let AE_WeightLossList = [];
            let AE_DysgeusiumList = [];
            let AE_NaildisorderList = [];
            let AE_SkinDisorderList = [];
            let AE_SecondaryPrimaryMalignancyList = [];
            let AE_NeurotoxicityList = [];
            let AE_EnterocolitisList = [];
            let AE_LymphopeniaList = [];
            let AE_ImmunoglobinList = [];

            //ADD CONDITIONALS ALSO incase Q is not shown for certain cohorts not reuired
            if (a.q53_crs_list && a.q53_crs_list.length > 0) {
              AE_CRSList = a.q53_crs_list.map((b) => ({
                AE_CRSId: b.crsId || 0,
                CrsNotExperienced: b.rbl_B === 1,
                CsrDate: b.date_B != "Invalid Date" ? b.date_B : "",
                CsrDateUnk: b.rbl_B === 99,
                Severity: b.rbl_C,
                Crsresolution: b.rbl_resolution,
                Crsresolutiondate: b.date_resolution,
              }));
            }
            if (a.q54_icans_list && a.q54_icans_list.length > 0) {
              AE_IcansList = a.q54_icans_list.map((b) => ({
                AE_ICANSId: b.icansId || 0,
                IcansNotExperienced: b.rbl_B === 1,
                IcansOccuredDate: b.date_B != "Invalid Date" ? b.date_B : "",
                IcansOccuredDateUnk: b.rbl_B === 99,

                Severity: b.rblC,
                Icansresolution: b.rblresolution,
                Icansresolutiondate:
                  b.dateresolution !== "Invalid Date" ? b.dateresolution : "",
              }));
            }

            if (a.q55_neutropenia_list && a.q55_neutropenia_list.length > 0) {
              AE_NeutropeniumList = a.q55_neutropenia_list.map((b) => ({
                AE_NeutropeniaId: b.neutropeniaId || 0,
                NeutropeniaNotExperienced: b.rbl_B === 1,
                NeutropeniaOnsetDate:
                  b.date_B != "Invalid Date" ? b.date_B : "",
                NeutropeniaOnsetDateUnk: b.rbl_B === 99,
                NeutropeniaNotResolved: b.rbl_C === 1,
                NeutropeniaResolutionDate:
                  b.date_C != "Invalid Date" ? b.date_C : "",
                NeutropeniaResolutionDateUnk: b.rbl_C === 3,
                NeutropeniaResolvedUnk: b.rbl_C === 99,
                Severity: b.rblD,
              }));
            }
            if (a.q56_cytopenia_list && a.q56_cytopenia_list.length > 0) {
              AE_CytopeniumList = a.q56_cytopenia_list.map((b) => ({
                AE_CytopeniaId: b.cytopeniaId || 0,
                CytopeniaNotExperienced: b.rbl_B === 1,
                CytopeniaOnsetDate: b.date_B != "Invalid Date" ? b.date_B : "",
                CytopeniaOnsetDateUnk: b.rbl_B === 99,
                CytopeniaNotResolved: b.rbl_C === 1,
                CytopeniaResolutionDate:
                  b.date_C != "Invalid Date" ? b.date_C : "",
                CytopeniaResolutionDateUnk: b.rbl_C === 3,
                CytopeniaResolvedUnk: b.rbl_C === 99,
                Severity: b.rblD,
              }));
            }
            if (a.q57_infection_list && a.q57_infection_list.length > 0) {
              AE_InfectionList = a.q57_infection_list.map((b) => ({
                AE_InfectionId: b.infectionId || 0,
                InfectionKey: b.infectionKey,

                InfectionNotExperienced: b.rbl_B === 1,
                InfectionOccuredDate:
                  b.date_B != "Invalid Date" ? b.date_B : "",
                InfectionOccuredDateUnk: b.rbl_B === 99,

                InfectionTypeBacterial: b.chk_C_1,
                InfectionTypeViral: b.chk_C_2,
                InfectionTypeFungal: b.chk_C_3,
                InfectionTypeUnk: b.rb_C,

                InfectionOrganismAdenovirus: b.chk_D_1,
                InfectionOrganismCandida: b.chk_D_2,
                InfectionOrganismCovid19: b.chk_D_3,
                InfectionOrganismCytomegalovirus: b.chk_D_4,
                InfectionOrganismEscherichia: b.chk_D_5,
                InfectionOrganismHelicobacter: b.chk_D_6,
                InfectionOrganismHepatitis: b.chk_D_7,
                InfectionOrganismHerpes: b.chk_D_8,
                InfectionOrganismInfluenza: b.chk_D_9,
                InfectionOrganismPjp: b.chk_D_10,
                InfectionOrganismProgressive: b.chk_D_11,
                InfectionOrganismRsv: b.chk_D_12,
                InfectionOrganismStreptococcus: b.chk_D_13,
                InfectionOrganismVaricella: b.chk_D_14,
                InfectionOrganismOth: b.chk_D_15,
                InfectionOrganismOthTxt: b.txt_D_oth,
                InfectionOrganismUnk: b.rb_D,

                Severity: b.rbl_E,

                LedErVisit: b.rbl_F,

                ManagementSettingInpatient: b.chk_G_1,
                ManagementSettingOutpatient: b.chk_G_2,
                ManagementSettingEmergencyroom: b.chk_G_3,
                ManagementSettingIntensivecareunit: b.chk_G_4,
                ManagementSettingOth: b.chk_G_5,
                ManagementSettingOthTxt: b.txt_G_oth,
                ManagementSettingUnk: b.rb_G_unk,
              }));
            }

            if (a.q571B_immunoglobin_list?.length > 0 && isNewEcrfB) {
              AE_ImmunoglobinList = a.q571B_immunoglobin_list.map((b) => ({
                Adverseeventimmunoglobinid: b.adverseeventimmunoglobinid || 0,
                Patientid: b.patientId,
                CohortTreatmentId: b.cohortTreatmentId,

                //B
                ImmunoglobinNotAssessed: b.q571B_rbl_B,
                ImmunoglobinAssessmentDate:
                  b.q571B_date_B !== "Invalid Date" ? b.q571B_date_B : "",

                //C
                ImmunoglobinDosage: b.q571B_rbl_C,
                ImmunoglobinDosageUnit: b.q571B_unit_C,

                //D
                InfectionKey: b.q571B_episode_D,
              }));
            }

            if (a.q58_weightLoss_list && a.q58_weightLoss_list.length > 0) {
              AE_WeightLossList = a.q58_weightLoss_list.map((b) => ({
                AE_WeightLossId: b.weightLossId || 0,
                NoWeightLoss: b.rbl_B === 1,
                WeightLossOnsetDate: b.date_B != "Invalid Date" ? b.date_B : "",
                WeightLossOnsetDateUnk: b.rbl_B === 99,
                WeightLossNotResolve: b.rbl_C === 1,
                WeightLossResolutionDate:
                  b.date_C != "Invalid Date" ? b.date_C : "",
                ResolutionDateUnknown: b.rbl_C === 3,
                WeightLossResolveUnknown: b.rbl_C === 99,
                WeightNotStabilize: b.rbl_D === 1,
                WeightStabilizationDate:
                  b.date_D != "Invalid Date" ? b.date_D : "",
                StabilizationDateUnknown: b.rbl_D === 3,
                WeightStabilizeUnknown: b.rbl_D === 99,
              }));
            }
            if (a.q59_dysgeusia_list && a.q59_dysgeusia_list.length > 0) {
              AE_DysgeusiumList = a.q59_dysgeusia_list.map((b) => ({
                AE_DysgeusiaId: b.dysgeusiaId || 0,
                DysgeusiaNotexperienced: b.rbl_B === 1,
                DysgeusiaOnsetOcurredDate:
                  b.date_B != "Invalid Date" ? b.date_B : "",
                DysgeusiaOnsetDateUnk: b.rbl_B === 99,
                InterventionDexamethasoneMouthwash: b.chk_CC_1,
                DexamethasoneMouthwashProphylactic: b.chk_CC_1_P,
                DexamethasoneMouthwashTherapeutic: b.chk_CC_1_T,
                InterventionNystatinMouthwash: b.chk_CC_2,
                NystatinMouthwashProphylactic: b.chk_CC_2_P,
                NystatinMouthwashTherapeutic: b.chk_CC_2_T,
                InterventionSalineMouthwash: b.chk_CC_3,
                SalineMouthwashProphylactic: b.chk_CC_3_P,
                SalineMouthwashTherapeutic: b.chk_CC_3_T,
                InterventionBioteneMouthwash: b.chk_CC_4,
                BioteneMouthwashProphylactic: b.chk_CC_4_P,
                BioteneMouthwashTherapeutic: b.chk_CC_4_T,
                InterventionZincMouthwash: b.chk_CC_5,
                ZincMouthwashProphylactic: b.chk_CC_5_P,
                ZincMouthwashTherapeutic: b.chk_CC_5_T,
                InterventionVitaminbMouthwash: b.chk_CC_6,
                VitaminbMouthwashProphylactic: b.chk_CC_6_P,
                VitaminbMouthwashTherapeutic: b.chk_CC_6_T,
                InterventionOtherMouthwash: b.chk_CC_7,
                InterventionOthertextMouthwash: b.txt_CC_oth,
                OtherMouthwashProphylactic: b.chk_CC_7_P,
                OtherMouthwashTherapeutic: b.chk_CC_7_T,
                InterventionUnknown: b.rb_CC,
                NoImprovement: b.rbl_C === 1,
                ImprovementDate: b.date_C != "Invalid Date" ? b.date_C : "",
                ImprovementDateUnk: b.rbl_C === 3,
                ImprovementUnk: b.rbl_C === 99,
                DysgeusiaNotResolved: b.rbl_D === 1,
                ResolutionOccuredDate:
                  b.date_D != "Invalid Date" ? b.date_D : "",
                ResolutionOccuredDateUnk: b.rbl_D === 3,
                DysgeusiaResolvedUnk: b.rbl_D === 99,
              }));
            }
            if (a.q60_nail_list && a.q60_nail_list.length > 0) {
              AE_NaildisorderList = a.q60_nail_list.map((b) => ({
                AE_NailDisorderId: b.nailDisorderId || 0,
                NaildisorderNotexperienced: b.rbl_B === 1,
                NaildisorderOnsetOcurredDate:
                  b.date_B != "Invalid Date" ? b.date_B : "",
                NaildisorderOnsetDateUnk: b.rbl_B === 99,
                NoImprovement: b.rbl_C === 1,
                ImprovementDate: b.date_C != "Invalid Date" ? b.date_C : "",
                ImprovementDateUnk: b.rbl_C === 3,
                ImprovementUnk: b.rbl_C === 99,
                NaildisorderNotResolved: b.rbl_D === 1,
                NaildisorderOccuredDate:
                  b.date_D != "Invalid Date" ? b.date_D : "",
                NaildisorderOccuredDateUnk: b.rbl_D === 3,
                NaildisorderResolvedUnk: b.rbl_D === 99,
              }));
            }
            if (a.q61_skin_list && a.q61_skin_list.length > 0) {
              AE_SkinDisorderList = a.q61_skin_list.map((b) => ({
                AE_SkinDisorderId: b.skinDisorderId || 0,
                SkindisorderNotexperienced: b.rbl_B === 1,
                SkindisorderOnsetOcurredDate:
                  b.date_B != "Invalid Date" ? b.date_B : "",
                SkindisorderOnsetDateUnk: b.rbl_B === 99,
                NoImprovement: b.rbl_C === 1,
                ImprovementDate: b.date_C != "Invalid Date" ? b.date_C : "",
                ImprovementDateUnk: b.rbl_C === 3,
                ImprovementUnk: b.rbl_C === 99,
                SkindisorderNotResolved: b.rbl_D === 1,
                SkindisorderOccuredDate:
                  b.date_D != "Invalid Date" ? b.date_D : "",
                SkindisorderOccuredDateUnk: b.rbl_D === 3,
                SkindisorderResolvedUnk: b.rbl_D === 99,
              }));
            }

            if (a.q62_spm_list && a.q62_spm_list.length > 0) {
              AE_SecondaryPrimaryMalignancyList = a.q62_spm_list.map((b) => ({
                AE_SecondaryPrimaryMalignancyId: b.spmId || 0,
                SecondMalignancyNotReceived: b.rbl_B === 1,
                SecondMalignancyOccuredDate:
                  b.date_B !== "Invalid Date" ? b.date_B : "",
                SecondMalignancyOccuredDateUnk: b.rbl_B === 99,
                SecondMalignancyResolution: b.q62_rbl_C,
                SecondMalignancyResolutionDate:
                  b.q62_date_C !== "Invalid Date" ? b.q62_date_C : "",
                Severity: b.q62_severity,
              }));
            }

            if (
              a.q63_neurotoxicity_list &&
              a.q63_neurotoxicity_list.length > 0
            ) {
              AE_NeurotoxicityList = a.q63_neurotoxicity_list.map((b) => ({
                AE_NeurotoxicityId: b.neurotoxicityId || 0,
                NeurotoxicityNotExperienced: b.rbl_B === 1,
                NeurotoxicityOnsetOccuredDate:
                  b.date_B != "Invalid Date" ? b.date_B : "",
                NeurotoxicityOnsetOccuredDateUnk: b.rbl_B === 99,
                NeurotoxicityNotResolved: b.rbl_C === 1,
                ResolutionOccuredDate:
                  b.date_C != "Invalid Date" ? b.date_C : "",
                ResolutionOccuredDateUnk: b.rbl_C === 3,
                NeurotoxicityResolvedUnk: b.rbl_C === 99,
                NeurotoxicitySubtype: b.rbl_D,
                NeurotoxicitySubtypeOth: b.txt_D_oth,
                Severity: b.rbl_E,
                ManagementSettingOutpatient: b.chk_F_1,
                ManagementSettingHospital: b.chk_F_2,
                ManagementSettingUnk: b.rb_F,
                InterventionsCorticosteroids: b.chk_G_1,
                InterventionsAnakinra: b.chk_G_2,
                InterventionsTocilizumab: b.chk_G_3,
                InterventionsSiltuximab: b.chk_G_4,
                InterventionsOth: b.chk_G_5,
                InterventionsUnk: b.rb_G,

                ManagementSettingInpatient: b.chkFInpatient,
                ManagementSettingEmergencyroom: b.chkFEmergencyRoom,
                ManagementSettingIntensivecareunit: b.chkFIntensiveCareUnit,
                ManagementSettingUrgentcarevisit: b.chkFUrgentCareVisit,
                ManagementSettingOth: b.chkFOther,

                Improvement: b.rblH,
                Improvementdate: b.dateH !== "Invalid Date" ? b.dateH : "",

                IsDependent: b.isAutoPopulated || false,
                SourceQ54IcansId: b.sourceQ54IcansId,
              }));
            }

            if (a.q64_enterocolitis_list?.length > 0 && isNewEcrfA) {
              AE_EnterocolitisList = a.q64_enterocolitis_list.map((b) => ({
                Adverseevententerocolitisid: b.adverseevententerocolitisid || 0,
                PatientId: b.patientId,
                CohortTreatmentId: b.cohortTreatmentId,

                //B
                EnterocolitisOnsetEventOccurred: b.q64_rbl_B,
                EnterocolitisEventOccurredDate:
                  b.q64_date_B !== "Invalid Date" ? b.q64_date_B : "",

                //C
                EnterocolitisImprovement: b.q64_rbl_C,
                EnterocolitisImprovementDate:
                  b.q64_date_C !== "Invalid Date" ? b.q64_date_C : "",

                //D
                EnterocolitisEventResolution: b.q64_rbl_D,
                ResolutionEventResolutionDate:
                  b.q64_date_D !== "Invalid Date" ? b.q64_date_D : "",

                //E
                EnterocolitisInterventionsSupportiveCare: b.q64_chk_E_1,
                EnterocolitisInterventionsAntibiotics: b.q64_chk_E_2,
                EnterocolitisInterventionsSurgery: b.q64_chk_E_3,
                EnterocolitisInterventionsGcsf: b.q64_chk_E_4,
                EnterocolitisInterventionsOth: b.q64_chk_E_5,
                EnterocolitisInterventionsOthTxt: b.q64_chk_E_othTxt,
                EnterocolitisInterventionsUnk: b.q64_E_unk ?? false,

                //F
                Severity: b.q64_severity,
              }));
            }

            if (a.q65_lymphopenia_list?.length > 0 && isNewEcrfB) {
              AE_LymphopeniaList = a.q65_lymphopenia_list.map((b) => ({
                Adverseeventlymphopeniaid: b.adverseeventlymphopeniaid || 0,
                PatientId: b.patientId,
                CohortTreatmentId: b.cohortTreatmentId,

                //B
                LymphopeniaOnsetEventOccurred: b.q65_rbl_B,
                LymphopeniaEventOccurredDate:
                  b.q65_date_B !== "Invalid Date" ? b.q65_date_B : "",

                //C
                LymphopeniaEventResolution: b.q65_rbl_C,
                LymphopeniaResolutionDate:
                  b.q65_date_C !== "Invalid Date" ? b.q65_date_C : "",

                //D
                Severity: b.q65_severity,
              }));
            }

            return {
              CohortTreatmentId: a.cohortTreatmentId,
              AE_CRSList,
              AE_IcansList,
              AE_NeutropeniumList,
              AE_CytopeniumList,
              AE_InfectionList,
              AE_WeightLossList,
              AE_DysgeusiumList,
              AE_NaildisorderList,
              AE_SkinDisorderList,
              AE_SecondaryPrimaryMalignancyList,
              AE_NeurotoxicityList,
              AE_EnterocolitisList,
              AE_LymphopeniaList,
              AE_ImmunoglobinList,
            };
          });
        }
        if (pid > 0) {
          const response =
            await AdverseEventsService.SaveAdverseEventsData(payload);
          ToggleLoader(false);
          if (response.status !== HTTPResponse.OK) {
            if (response?.status === HTTPResponse.Unauthorized) {
              HandleSessionTimeout();
            } else throw response.error;
          } else {
            ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
            await LoadData();
          }
        }
        return true;
      } else {
        ToggleLoader(false);
        setShowTopErrMsg(true);
        return false;
      }
    } catch (error) {
      console.log(error);

      ToggleLoader(false);
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };
  const Validate = () => {
    let isValid = true;

    //Check if onset date is before index date
    function IsOnsetBeforeIndex(onsetDt, indexDt) {
      if (!isStringEmpty(onsetDt) && !isStringEmpty(indexDt)) {
        return IsDateAfter(indexDt, onsetDt);
      }
      return false;
    }
    //Check if onset date is after AE end date
    function IsDateAfterFunction(onsetDt, aeEndDt) {
      if (!isStringEmpty(onsetDt) && !isStringEmpty(aeEndDt)) {
        return IsDateAfter(onsetDt, aeEndDt);
      }
      return false;
    }

    if (aeDetails && aeDetails.length > 0) {
      const updatedArr = aeDetails.map((p) => {
        let innerArrQ53 = null;
        let innerArrQ54 = null;
        let innerArrQ55 = null;
        let innerArrQ56 = null;
        let innerArrQ57 = null;
        let innerArrQ58 = null;
        let innerArrQ59 = null;
        let innerArrQ60 = null;
        let innerArrQ61 = null;
        let innerArrQ62 = null;
        let innerArrQ63 = null;
        let innerArrQ64 = null;
        let innerArrQ65 = null;
        let innerArrQ571B = null;

        if (p.q53_crs_list && p.q53_crs_list.length > 0) {
          innerArrQ53 = p.q53_crs_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_before_eof = false;

            // RESOLUTION VALIDATION
            let resolutionemptyerr = false;
            let resolutiondateemptyerr = false;
            let resolutiondateinvalid = false;
            let resolutiondaterangeerr = false;

            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_before_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }

            if (cIndex > 0 && c.date_B) {
              // Filter out the current index and get only the previous rows that have a date
              const previousDates = p.q53_crs_list
                .slice(0, cIndex) // Exclude the current index by slicing up to it
                .filter(
                  (_, idx) => idx !== cIndex && p.q53_crs_list[idx].date_B,
                ) // Ensure that previous indices have a date
                .map((crs) => crs.date_B); // Map to get the dates

              // // Get the most recent previous date if any
              // if (previousDates.length > 0) {
              //   const mostRecentPrevDate = previousDates[previousDates.length - 1];

              //   // Check if the current date is less than or equal to the most recent previous date
              //   if (IsDateEqual(mostRecentPrevDate, c.date_B)) {
              //     B_date_equal_prev_ep_err = true;
              //   }
              // }
              // Check if the current date is equal to any of the previous dates
              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }

            const C_empty_err =
              c.rbl_B != null && c.rbl_B !== 1 && c.rbl_C == null;
            if (isNewEcrfA && c.rbl_B !== null && c.rbl_B !== 1) {
              // Check if radio button is selected
              resolutionemptyerr = c.rbl_resolution === null;

              if (c.rbl_resolution != null && c.rbl_resolution === 2) {
                // Check if date is selected when "Event resolved on" is chosen
                if (
                  isStringEmpty(c.date_resolution) ||
                  c.date_resolution === null
                ) {
                  resolutiondateemptyerr = true;
                } else if (!IsDateValid(c.date_resolution)) {
                  resolutiondateinvalid = true;
                } else {
                  // Validate: index date ≤ onset date ≤ resolution date ≤ AE end date
                  const indexDate = p.cohortIndexDate;
                  const onsetDate = c.date_B;
                  const resolutionDate = c.date_resolution;
                  const aeEndDate = p.aeEndDate;

                  const isBeforeOnset = IsOnsetBeforeIndex(
                    resolutionDate,
                    onsetDate,
                  );
                  const isBeforeIndex = IsOnsetBeforeIndex(
                    resolutionDate,
                    indexDate,
                  );

                  const isAfterAeEnd = IsDateAfterFunction(
                    resolutionDate,
                    aeEndDate,
                  );

                  const isAfterEof = IsDateAfter(
                    resolutionDate,
                    endOfFollowUpDate,
                  );

                  // Single error flag for date range validation
                  resolutiondaterangeerr =
                    isBeforeIndex ||
                    isBeforeOnset ||
                    isAfterAeEnd ||
                    isAfterEof;
                }
              }
            }

            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              C_empty_err ||
              B_date_before_eof ||
              resolutionemptyerr ||
              resolutiondateemptyerr ||
              resolutiondateinvalid ||
              resolutiondaterangeerr
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              C_empty_err,
              B_date_before_eof,
              resolutionemptyerr,
              resolutiondateemptyerr,
              resolutiondateinvalid,
              resolutiondaterangeerr,
            };
          });
        }
        if (p.q54_icans_list && p.q54_icans_list.length > 0) {
          innerArrQ54 = p.q54_icans_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_before_eof = false;
            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_before_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }
            if (cIndex > 0 && c.date_B) {
              const previousDates = p.q54_icans_list
                .slice(0, cIndex)
                .filter(
                  (_, idx) => idx !== cIndex && p.q54_icans_list[idx].date_B,
                )
                .map((crs) => crs.date_B);

              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }

            // SEVERITY VALIDATION
            const Cemptyerr =
              isNewEcrfA &&
              c.rbl_B !== null &&
              c.rbl_B !== 1 &&
              c.rblC === null;

            //  RESOLUTION VALIDATION (ONLY FOR isNewEcrfA)
            let resolutionemptyerr = false;
            let resolutiondateemptyerr = false;
            let resolutiondateinvalid = false;
            let resolutiondaterangeerr = false;

            if (isNewEcrfA && c.rbl_B !== null && c.rbl_B !== 1) {
              resolutionemptyerr = c.rblresolution === null;

              if (!resolutionemptyerr && c.rblresolution === 2) {
                if (
                  isStringEmpty(c.dateresolution) ||
                  c.dateresolution === null
                ) {
                  resolutiondateemptyerr = true;
                } else if (!IsDateValid(c.dateresolution)) {
                  resolutiondateinvalid = true;
                } else {
                  const indexDate = p.cohortIndexDate;
                  const onsetDate = c.date_B;
                  const resolutionDate = c.dateresolution;
                  const aeEndDate = p.aeEndDate;

                  const isBeforeOnset = IsOnsetBeforeIndex(
                    resolutionDate,
                    onsetDate,
                  );
                  const isBeforeIndex = IsOnsetBeforeIndex(
                    resolutionDate,
                    indexDate,
                  );
                  const isAfterAeEnd = IsDateAfterFunction(
                    resolutionDate,
                    aeEndDate,
                  );
                  const isAfterEof = IsDateAfter(
                    resolutionDate,
                    endOfFollowUpDate,
                  );

                  resolutiondaterangeerr =
                    isBeforeIndex ||
                    isBeforeOnset ||
                    isAfterAeEnd ||
                    isAfterEof;
                }
              }
            }

            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              B_date_before_eof ||
              resolutionemptyerr ||
              resolutiondateemptyerr ||
              resolutiondateinvalid ||
              resolutiondaterangeerr ||
              Cemptyerr
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              B_date_before_eof,
              resolutionemptyerr,
              resolutiondateemptyerr,
              resolutiondateinvalid,
              resolutiondaterangeerr,
              Cemptyerr,
            };
          });
        }
        if (p.q55_neutropenia_list && p.q55_neutropenia_list.length > 0) {
          innerArrQ55 = p.q55_neutropenia_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_after_eof = false;

            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_after_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }
            if (cIndex > 0 && c.date_B) {
              const previousDates = p.q55_neutropenia_list
                .slice(0, cIndex)
                .filter(
                  (_, idx) =>
                    idx !== cIndex && p.q55_neutropenia_list[idx].date_B,
                )
                .map((crs) => crs.date_B);

              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }

            let C_empty_err = false;
            let C_date_empty_err = false;
            let C_date_before_index_err = false;
            let C_date_before_onset_err = false;
            let C_date_after_err = false;
            let C_date_invalid = false;
            let C_date_before_eof = false;

            if (c.rbl_B != null && c.rbl_B !== 1) {
              C_empty_err = c.rbl_C == null;
              C_date_empty_err = false; //c.rbl_C === 2 && isStringEmpty(c.date_C);
              C_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_C, p.cohortIndexDate);
              C_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_C, c.date_B);
              C_date_after_err = false; //IsDateAfterFunction(c.date_C, p.aeEndDate);
              C_date_before_eof = false;

              if (!C_empty_err) {
                if (c.rbl_C === 2) {
                  if (isStringEmpty(c.date_C)) {
                    C_date_empty_err = true;
                  } else if (!IsDateValid(c.date_C)) {
                    C_date_invalid = true;
                  } else {
                    C_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_C,
                      p.cohortIndexDate,
                    );
                    C_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_C,
                      c.date_B,
                    );
                    C_date_after_err = IsDateAfterFunction(
                      c.date_C,
                      p.aeEndDate,
                    );
                    C_date_before_eof = IsDateAfter(
                      c.date_C,
                      endOfFollowUpDate,
                    );
                  }
                }
              }
            }

            let Demptyerr = false;
            if (isNewEcrfA && c.rbl_B !== null && c.rbl_B !== 1) {
              Demptyerr = c.rblD === null;
            }

            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              B_date_after_eof ||
              C_empty_err ||
              C_date_empty_err ||
              C_date_before_index_err ||
              C_date_before_onset_err ||
              C_date_after_err ||
              C_date_invalid ||
              C_date_before_eof ||
              Demptyerr
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              C_empty_err,
              C_date_empty_err,
              C_date_before_index_err,
              C_date_before_onset_err,
              C_date_after_err,
              C_date_invalid,
              B_date_after_eof,
              C_date_before_eof,
              Demptyerr,
            };
          });
        }
        if (p.q56_cytopenia_list && p.q56_cytopenia_list.length > 0) {
          innerArrQ56 = p.q56_cytopenia_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_after_eof = false;

            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_after_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }
            if (cIndex > 0 && c.date_B) {
              const previousDates = p.q56_cytopenia_list
                .slice(0, cIndex)
                .filter(
                  (_, idx) =>
                    idx !== cIndex && p.q56_cytopenia_list[idx].date_B,
                )
                .map((crs) => crs.date_B);

              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }

            let C_empty_err = false;
            let C_date_empty_err = false;
            let C_date_before_index_err = false;
            let C_date_before_onset_err = false;
            let C_date_after_err = false;
            let C_date_invalid = false;
            let C_date_before_eof = false;

            if (c.rbl_B != null && c.rbl_B !== 1) {
              C_empty_err = c.rbl_C == null;
              C_date_empty_err = false; //c.rbl_C === 2 && isStringEmpty(c.date_C);
              C_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_C, p.cohortIndexDate);
              C_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_C, c.date_B);
              C_date_after_err = false; //IsDateAfterFunction(c.date_C, p.aeEndDate);
              C_date_before_eof = false;

              if (!C_empty_err) {
                if (c.rbl_C === 2) {
                  if (isStringEmpty(c.date_C)) {
                    C_date_empty_err = true;
                  } else if (!IsDateValid(c.date_C)) {
                    C_date_invalid = true;
                  } else {
                    C_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_C,
                      p.cohortIndexDate,
                    );
                    C_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_C,
                      c.date_B,
                    );
                    C_date_after_err = IsDateAfterFunction(
                      c.date_C,
                      p.aeEndDate,
                    );
                    C_date_before_eof = IsDateAfter(
                      c.date_C,
                      endOfFollowUpDate,
                    );
                  }
                }
              }
            }

            let Demptyerr = false;
            if (isNewEcrfA && c.rbl_B !== null && c.rbl_B !== 1) {
              Demptyerr = c.rblD === null;
            }

            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              B_date_after_eof ||
              C_empty_err ||
              C_date_empty_err ||
              C_date_before_index_err ||
              C_date_before_onset_err ||
              C_date_after_err ||
              C_date_invalid ||
              C_date_before_eof ||
              Demptyerr
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              C_empty_err,
              C_date_empty_err,
              C_date_before_index_err,
              C_date_before_onset_err,
              C_date_after_err,
              C_date_invalid,
              B_date_after_eof,
              C_date_before_eof,
              Demptyerr,
            };
          });
        }
        if (p.q57_infection_list && p.q57_infection_list.length > 0) {
          innerArrQ57 = p.q57_infection_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_after_eof = false;

            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_after_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }
            if (cIndex > 0 && c.date_B) {
              const previousDates = p.q57_infection_list
                .slice(0, cIndex)
                .filter(
                  (_, idx) =>
                    idx !== cIndex && p.q57_infection_list[idx].date_B,
                )
                .map((crs) => crs.date_B);

              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }
            let C_empty_err = false;
            let D_empty_err = false;
            let D_txt_empty_err = false;
            let E_empty_err = false;
            let F_empty_err = false;
            let G_empty_err = false;
            let G_txt_empty_err = false;

            if (c.rbl_B != null && c.rbl_B !== 1) {
              C_empty_err = !c.chk_C_1 && !c.chk_C_2 && !c.chk_C_3 && !c.rb_C;
              D_empty_err =
                !c.chk_D_1 &&
                !c.chk_D_2 &&
                !c.chk_D_3 &&
                !c.chk_D_4 &&
                !c.chk_D_5 &&
                !c.chk_D_6 &&
                !c.chk_D_7 &&
                !c.chk_D_8 &&
                !c.chk_D_9 &&
                !c.chk_D_10 &&
                !c.chk_D_11 &&
                !c.chk_D_12 &&
                !c.chk_D_13 &&
                !c.chk_D_14 &&
                !c.chk_D_15 &&
                !c.txt_D_oth &&
                !c.rb_D;
              D_txt_empty_err = c.chk_D_15 && isStringEmpty(c.txt_D_oth);
              E_empty_err = c.rbl_E == null;
              F_empty_err = c.rbl_F == null;

              if (isNewEcrfB) {
                G_empty_err =
                  !c.chk_G_1 &&
                  !c.chk_G_2 &&
                  !c.chk_G_3 &&
                  !c.chk_G_4 &&
                  !c.chk_G_5 &&
                  !c.rb_G_unk;
                G_txt_empty_err = c.chk_G_5 && isStringEmpty(c.txt_G_oth);
              }
            }

            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_eof ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              C_empty_err ||
              D_empty_err ||
              D_txt_empty_err ||
              E_empty_err ||
              F_empty_err ||
              G_empty_err ||
              G_txt_empty_err
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              C_empty_err,
              D_empty_err,
              D_txt_empty_err,
              E_empty_err,
              F_empty_err,
              B_date_after_eof,
              G_empty_err,
              G_txt_empty_err,
            };
          });
        }
        if (p.q58_weightLoss_list && p.q58_weightLoss_list.length > 0) {
          innerArrQ58 = p.q58_weightLoss_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_after_eof = false;
            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_after_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }
            if (cIndex > 0 && c.date_B) {
              const previousDates = p.q58_weightLoss_list
                .slice(0, cIndex)
                .filter(
                  (_, idx) =>
                    idx !== cIndex && p.q58_weightLoss_list[idx].date_B,
                )
                .map((crs) => crs.date_B);

              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }

            let C_empty_err = false;
            let C_date_empty_err = false;
            let C_date_before_index_err = false;
            let C_date_before_onset_err = false;
            let C_date_after_err = false;
            let C_date_invalid = false;
            let C_date_before_eof = false;
            let D_empty_err = false;
            let D_date_empty_err = false;
            let D_date_before_index_err = false;
            let D_date_before_onset_err = false;
            let D_date_before_res_err = false;
            let D_date_after_err = false;
            let D_date_invalid = false;
            let D_date_before_eof = false;

            if (c.rbl_B != null && c.rbl_B !== 1) {
              C_empty_err = c.rbl_C == null;
              C_date_empty_err = false; //c.rbl_C === 2 && isStringEmpty(c.date_C);
              C_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_C, p.cohortIndexDate);
              C_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_C, c.date_B);
              C_date_after_err = false; //IsDateAfterFunction(c.date_C, p.aeEndDate);
              C_date_before_eof = false;
              if (!C_empty_err) {
                if (c.rbl_C === 2) {
                  if (isStringEmpty(c.date_C)) {
                    C_date_empty_err = true;
                  } else if (!IsDateValid(c.date_C)) {
                    C_date_invalid = true;
                  } else {
                    C_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_C,
                      p.cohortIndexDate,
                    );
                    C_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_C,
                      c.date_B,
                    );
                    C_date_after_err = IsDateAfterFunction(
                      c.date_C,
                      p.aeEndDate,
                    );
                    C_date_before_eof = IsDateAfter(
                      c.date_C,
                      endOfFollowUpDate,
                    );
                  }
                }
              }

              D_empty_err = c.rbl_D == null;
              D_date_empty_err = false; //c.rbl_D === 2 && isStringEmpty(c.date_D);
              D_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_D, p.cohortIndexDate);
              D_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_D, c.date_B);
              D_date_before_res_err = false; //IsOnsetBeforeIndex(c.date_D, c.date_C);
              D_date_after_err = false; //IsDateAfterFunction(c.date_D, p.aeEndDate);
              D_date_before_eof = false;

              if (!D_empty_err) {
                if (c.rbl_D === 2) {
                  if (isStringEmpty(c.date_D)) {
                    D_date_empty_err = true;
                  } else if (!IsDateValid(c.date_D)) {
                    D_date_invalid = true;
                  } else {
                    D_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_D,
                      p.cohortIndexDate,
                    );
                    D_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_D,
                      c.date_B,
                    );
                    D_date_after_err = IsDateAfterFunction(
                      c.date_D,
                      p.aeEndDate,
                    );
                    D_date_before_eof = IsDateAfter(
                      c.date_D,
                      endOfFollowUpDate,
                    );
                  }
                }
              }
            }

            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              B_date_after_eof ||
              C_empty_err ||
              C_date_empty_err ||
              C_date_before_index_err ||
              C_date_before_onset_err ||
              C_date_after_err ||
              C_date_invalid ||
              C_date_before_eof ||
              D_empty_err ||
              D_date_empty_err ||
              D_date_before_index_err ||
              D_date_before_onset_err ||
              D_date_before_res_err ||
              D_date_after_err ||
              D_date_invalid ||
              D_date_before_eof
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              C_empty_err,
              C_date_empty_err,
              C_date_before_index_err,
              C_date_before_onset_err,
              C_date_after_err,
              C_date_invalid,
              D_empty_err,
              D_date_empty_err,
              D_date_before_index_err,
              D_date_before_onset_err,
              D_date_before_res_err,
              D_date_after_err,
              D_date_invalid,
              B_date_after_eof,
              C_date_before_eof,
              D_date_before_eof,
            };
          });
        }
        if (p.q59_dysgeusia_list && p.q59_dysgeusia_list.length > 0) {
          innerArrQ59 = p.q59_dysgeusia_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_after_eof = false;
            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_after_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }
            if (cIndex > 0 && c.date_B) {
              const previousDates = p.q59_dysgeusia_list
                .slice(0, cIndex)
                .filter(
                  (_, idx) =>
                    idx !== cIndex && p.q59_dysgeusia_list[idx].date_B,
                )
                .map((crs) => crs.date_B);

              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }

            let CC_1_empty_err = false;
            let CC_2_empty_err = false;
            let CC_3_empty_err = false;
            let CC_4_empty_err = false;
            let CC_5_empty_err = false;
            let CC_6_empty_err = false;
            let CC_7_empty_err = false;
            let CC_empty_err = false;
            let CC_txt_empty_err = false;

            let C_empty_err = false;
            let C_date_empty_err = false;
            let C_date_before_index_err = false;
            let C_date_before_onset_err = false;
            let C_date_after_err = false;
            let C_date_invalid = false;
            let C_date_before_eof = false;

            let D_empty_err = false;
            let D_date_empty_err = false;
            let D_date_before_index_err = false;
            let D_date_before_onset_err = false;
            let D_date_before_impr_err = false;
            let D_date_after_err = false;
            let D_date_invalid = false;
            let D_date_before_eof = false;

            if (c.rbl_B != null && c.rbl_B !== 1) {
              CC_1_empty_err = c.chk_CC_1 && !c.chk_CC_1_P && !c.chk_CC_1_T;
              CC_2_empty_err = c.chk_CC_2 && !c.chk_CC_2_P && !c.chk_CC_2_T;
              CC_3_empty_err = c.chk_CC_3 && !c.chk_CC_3_P && !c.chk_CC_3_T;
              CC_4_empty_err = c.chk_CC_4 && !c.chk_CC_4_P && !c.chk_CC_4_T;
              CC_5_empty_err = c.chk_CC_5 && !c.chk_CC_5_P && !c.chk_CC_5_T;
              CC_6_empty_err = c.chk_CC_6 && !c.chk_CC_6_P && !c.chk_CC_6_T;
              CC_7_empty_err = c.chk_CC_7 && !c.chk_CC_7_P && !c.chk_CC_7_T;
              CC_empty_err =
                !c.chk_CC_1 &&
                !c.chk_CC_2 &&
                !c.chk_CC_3 &&
                !c.chk_CC_4 &&
                !c.chk_CC_5 &&
                !c.chk_CC_6 &&
                !c.chk_CC_7 &&
                !c.rb_CC;
              CC_txt_empty_err = c.chk_CC_7 && isStringEmpty(c.txt_CC_oth);

              C_empty_err = c.rbl_C == null;
              C_date_empty_err = false; //c.rbl_C === 2 && isStringEmpty(c.date_C);
              C_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_C, p.cohortIndexDate);
              C_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_C, c.date_B);
              C_date_after_err = false; //IsDateAfterFunction(c.date_C, p.aeEndDate);
              C_date_before_eof = false;
              if (!C_empty_err) {
                if (c.rbl_C === 2) {
                  if (isStringEmpty(c.date_C)) {
                    C_date_empty_err = true;
                  } else if (!IsDateValid(c.date_C)) {
                    C_date_invalid = true;
                  } else {
                    C_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_C,
                      p.cohortIndexDate,
                    );
                    C_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_C,
                      c.date_B,
                    );
                    C_date_after_err = IsDateAfterFunction(
                      c.date_C,
                      p.aeEndDate,
                    );
                    C_date_before_eof = IsDateAfter(
                      c.date_C,
                      endOfFollowUpDate,
                    );
                  }
                }
              }

              D_empty_err = c.rbl_D == null;
              D_date_empty_err = false; //c.rbl_D === 2 && isStringEmpty(c.date_D);
              D_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_D, p.cohortIndexDate);
              D_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_D, c.date_B);
              D_date_before_impr_err = false; //IsOnsetBeforeIndex(c.date_D, c.date_C);
              D_date_after_err = false; //IsDateAfterFunction(c.date_D, p.aeEndDate);
              D_date_before_eof = false;
              if (!D_empty_err) {
                if (c.rbl_D === 2) {
                  if (isStringEmpty(c.date_D)) {
                    D_date_empty_err = true;
                  } else if (!IsDateValid(c.date_D)) {
                    D_date_invalid = true;
                  } else {
                    D_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_D,
                      p.cohortIndexDate,
                    );
                    D_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_D,
                      c.date_B,
                    );
                    D_date_before_impr_err = IsOnsetBeforeIndex(
                      c.date_D,
                      c.date_C,
                    );
                    D_date_after_err = IsDateAfterFunction(
                      c.date_D,
                      p.aeEndDate,
                    );
                    D_date_before_eof = IsDateAfter(
                      c.date_D,
                      endOfFollowUpDate,
                    );
                  }
                }
              }
            }
            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              B_date_after_eof ||
              CC_1_empty_err ||
              CC_2_empty_err ||
              CC_3_empty_err ||
              CC_4_empty_err ||
              CC_5_empty_err ||
              CC_6_empty_err ||
              CC_7_empty_err ||
              CC_empty_err ||
              CC_txt_empty_err ||
              C_empty_err ||
              C_date_empty_err ||
              C_date_before_index_err ||
              C_date_before_onset_err ||
              C_date_after_err ||
              C_date_invalid ||
              C_date_before_eof ||
              D_empty_err ||
              D_date_empty_err ||
              D_date_before_index_err ||
              D_date_before_onset_err ||
              D_date_before_impr_err ||
              D_date_after_err ||
              D_date_invalid ||
              D_date_before_eof
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              B_date_after_eof,
              CC_1_empty_err,
              CC_2_empty_err,
              CC_3_empty_err,
              CC_4_empty_err,
              CC_5_empty_err,
              CC_6_empty_err,
              CC_7_empty_err,
              CC_empty_err,
              CC_txt_empty_err,
              C_empty_err,
              C_date_empty_err,
              C_date_before_index_err,
              C_date_before_onset_err,
              C_date_after_err,
              C_date_invalid,
              C_date_before_eof,
              D_empty_err,
              D_date_empty_err,
              D_date_before_index_err,
              D_date_before_onset_err,
              D_date_before_impr_err,
              D_date_after_err,
              D_date_invalid,
              D_date_before_eof,
            };
          });
        }
        if (p.q60_nail_list && p.q60_nail_list.length > 0) {
          innerArrQ60 = p.q60_nail_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_after_eof = false;

            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_after_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }
            if (cIndex > 0 && c.date_B) {
              const previousDates = p.q60_nail_list
                .slice(0, cIndex)
                .filter(
                  (_, idx) => idx !== cIndex && p.q60_nail_list[idx].date_B,
                )
                .map((crs) => crs.date_B);

              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }

            let C_empty_err = false;
            let C_date_empty_err = false;
            let C_date_before_index_err = false;
            let C_date_before_onset_err = false;
            let C_date_after_err = false;
            let C_date_invalid = false;
            let C_date_before_eof = false;

            let D_empty_err = false;
            let D_date_empty_err = false;
            let D_date_before_index_err = false;
            let D_date_before_onset_err = false;
            let D_date_before_impr_err = false;
            let D_date_after_err = false;
            let D_date_invalid = false;
            let D_date_before_eof = false;

            if (c.rbl_B != null && c.rbl_B !== 1) {
              C_empty_err = c.rbl_C == null;
              C_date_empty_err = false; //c.rbl_C === 2 && isStringEmpty(c.date_C);
              C_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_C, p.cohortIndexDate);
              C_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_C, c.date_B);
              C_date_after_err = false; //IsDateAfterFunction(c.date_C, p.aeEndDate);
              C_date_before_eof = false;
              if (!C_empty_err) {
                if (c.rbl_C === 2) {
                  if (isStringEmpty(c.date_C)) {
                    C_date_empty_err = true;
                  } else if (!IsDateValid(c.date_C)) {
                    C_date_invalid = true;
                  } else {
                    C_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_C,
                      p.cohortIndexDate,
                    );
                    C_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_C,
                      c.date_B,
                    );
                    C_date_after_err = IsDateAfterFunction(
                      c.date_C,
                      p.aeEndDate,
                    );
                    C_date_before_eof = IsDateAfter(
                      c.date_C,
                      endOfFollowUpDate,
                    );
                  }
                }
              }

              D_empty_err = c.rbl_D == null;
              D_date_empty_err = false; //c.rbl_D === 2 && isStringEmpty(c.date_D);
              D_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_D, p.cohortIndexDate);
              D_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_D, c.date_B);
              D_date_before_impr_err = false; //IsOnsetBeforeIndex(c.date_D, c.date_C);
              D_date_after_err = false; //IsDateAfterFunction(c.date_D, p.aeEndDate);
              D_date_before_eof = false;
              if (!D_empty_err) {
                if (c.rbl_D === 2) {
                  if (isStringEmpty(c.date_D)) {
                    D_date_empty_err = true;
                  } else if (!IsDateValid(c.date_D)) {
                    D_date_invalid = true;
                  } else {
                    D_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_D,
                      p.cohortIndexDate,
                    );
                    D_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_D,
                      c.date_B,
                    );
                    D_date_before_impr_err = IsOnsetBeforeIndex(
                      c.date_D,
                      c.date_C,
                    );
                    D_date_after_err = IsDateAfterFunction(
                      c.date_D,
                      p.aeEndDate,
                    );
                    D_date_before_eof = IsDateAfter(
                      c.date_D,
                      endOfFollowUpDate,
                    );
                  }
                }
              }
            }
            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              B_date_after_eof ||
              C_empty_err ||
              C_date_empty_err ||
              C_date_before_index_err ||
              C_date_before_onset_err ||
              C_date_after_err ||
              C_date_invalid ||
              C_date_before_eof ||
              D_empty_err ||
              D_date_empty_err ||
              D_date_before_index_err ||
              D_date_before_onset_err ||
              D_date_before_impr_err ||
              D_date_after_err ||
              D_date_invalid ||
              C_date_before_eof
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              B_date_after_eof,
              C_empty_err,
              C_date_empty_err,
              C_date_before_index_err,
              C_date_before_onset_err,
              C_date_after_err,
              C_date_invalid,
              C_date_before_eof,
              D_empty_err,
              D_date_empty_err,
              D_date_before_index_err,
              D_date_before_onset_err,
              D_date_before_impr_err,
              D_date_after_err,
              D_date_invalid,
              D_date_before_eof,
            };
          });
        }
        if (p.q61_skin_list && p.q61_skin_list.length > 0) {
          innerArrQ61 = p.q61_skin_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_after_eof = false;
            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_after_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }
            if (cIndex > 0 && c.date_B) {
              const previousDates = p.q61_skin_list
                .slice(0, cIndex)
                .filter(
                  (_, idx) => idx !== cIndex && p.q61_skin_list[idx].date_B,
                )
                .map((crs) => crs.date_B);

              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }

            let C_empty_err = false;
            let C_date_empty_err = false;
            let C_date_before_index_err = false;
            let C_date_before_onset_err = false;
            let C_date_after_err = false;
            let C_date_invalid = false;
            let C_date_before_eof = false;

            let D_empty_err = false;
            let D_date_empty_err = false;
            let D_date_before_index_err = false;
            let D_date_before_onset_err = false;
            let D_date_before_impr_err = false;
            let D_date_after_err = false;
            let D_date_invalid = false;
            let D_date_before_eof = false;

            if (c.rbl_B != null && c.rbl_B !== 1) {
              C_empty_err = c.rbl_C == null;
              C_date_empty_err = false; //c.rbl_C === 2 && isStringEmpty(c.date_C);
              C_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_C, p.cohortIndexDate);
              C_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_C, c.date_B);
              C_date_after_err = false; //IsDateAfterFunction(c.date_C, p.aeEndDate);
              C_date_before_eof = false;
              if (!C_empty_err) {
                if (c.rbl_C === 2) {
                  if (isStringEmpty(c.date_C)) {
                    C_date_empty_err = true;
                  } else if (!IsDateValid(c.date_C)) {
                    C_date_invalid = true;
                  } else {
                    C_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_C,
                      p.cohortIndexDate,
                    );
                    C_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_C,
                      c.date_B,
                    );
                    C_date_after_err = IsDateAfterFunction(
                      c.date_C,
                      p.aeEndDate,
                    );
                    C_date_before_eof = IsDateAfter(
                      c.date_C,
                      endOfFollowUpDate,
                    );
                  }
                }
              }

              D_empty_err = c.rbl_D == null;
              D_date_empty_err = false; //c.rbl_D === 2 && isStringEmpty(c.date_D);
              D_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_D, p.cohortIndexDate);
              D_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_D, c.date_B);
              D_date_before_impr_err = false; //IsOnsetBeforeIndex(c.date_D, c.date_C);
              D_date_after_err = false; //IsDateAfterFunction(c.date_D, p.aeEndDate);
              D_date_before_eof = false;
              if (!D_empty_err) {
                if (c.rbl_D === 2) {
                  if (isStringEmpty(c.date_D)) {
                    D_date_empty_err = true;
                  } else if (!IsDateValid(c.date_D)) {
                    D_date_invalid = true;
                  } else {
                    D_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_D,
                      p.cohortIndexDate,
                    );
                    D_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_D,
                      c.date_B,
                    );
                    D_date_before_impr_err = IsOnsetBeforeIndex(
                      c.date_D,
                      c.date_C,
                    );
                    D_date_after_err = IsDateAfterFunction(
                      c.date_D,
                      p.aeEndDate,
                    );
                    D_date_before_eof = IsDateAfter(
                      c.date_D,
                      endOfFollowUpDate,
                    );
                  }
                }
              }
            }
            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              B_date_after_eof ||
              C_empty_err ||
              C_date_empty_err ||
              C_date_before_index_err ||
              C_date_before_onset_err ||
              C_date_after_err ||
              C_date_invalid ||
              C_date_before_eof ||
              D_empty_err ||
              D_date_empty_err ||
              D_date_before_index_err ||
              D_date_before_onset_err ||
              D_date_before_impr_err ||
              D_date_after_err ||
              D_date_invalid ||
              D_date_before_eof
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              B_date_after_eof,
              C_empty_err,
              C_date_empty_err,
              C_date_before_index_err,
              C_date_before_onset_err,
              C_date_after_err,
              C_date_invalid,
              C_date_before_eof,
              D_empty_err,
              D_date_empty_err,
              D_date_before_index_err,
              D_date_before_onset_err,
              D_date_before_impr_err,
              D_date_after_err,
              D_date_invalid,
              D_date_before_eof,
            };
          });
        }
        if (p.q62_spm_list && p.q62_spm_list.length > 0) {
          innerArrQ62 = p.q62_spm_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_after_eof = false;

            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_after_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }
            if (cIndex > 0 && c.date_B) {
              const previousDates = p.q62_spm_list
                .slice(0, cIndex)
                .filter(
                  (_, idx) => idx !== cIndex && p.q62_spm_list[idx].date_B,
                )
                .map((crs) => crs.date_B);

              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }

            let q62CEmptyError = false;
            let q62CDateEmptyError = false;
            let q62CDateInvalidError = false;
            let q62CDateBeforeIndexError = false;
            let q62CDateBeforeOnsetError = false;
            let q62CDateAfterAEDateError = false;

            let q62DEmptyError = false;

            if (c.rbl_B != null && c.rbl_B !== 1 && isNewEcrfA) {
              q62CEmptyError = c.q62_rbl_C == null;

              if (!q62CEmptyError) {
                if (c.q62_rbl_C === 2) {
                  if (isStringEmpty(c.q62_date_C)) {
                    q62CDateEmptyError = true;
                  } else if (!IsDateValid(c.q62_date_C)) {
                    q62CDateInvalidError = true;
                  } else {
                    q62CDateBeforeIndexError = IsOnsetBeforeIndex(
                      c.q62_date_C,
                      p.cohortIndexDate,
                    );
                    q62CDateBeforeOnsetError = IsOnsetBeforeIndex(
                      c.q62_date_C,
                      c.date_B,
                    );
                    q62CDateAfterAEDateError = IsDateAfterFunction(
                      c.q62_date_C,
                      p.aeEndDate,
                    );
                  }
                }
              }

              q62DEmptyError = c.q62_severity == null;
            }

            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              B_date_after_eof ||
              q62CEmptyError ||
              q62CDateEmptyError ||
              q62CDateInvalidError ||
              q62CDateBeforeIndexError ||
              q62CDateBeforeOnsetError ||
              q62CDateAfterAEDateError ||
              q62DEmptyError
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              B_date_after_eof,
              q62CEmptyError,
              q62CDateEmptyError,
              q62CDateInvalidError,
              q62CDateBeforeIndexError,
              q62CDateBeforeOnsetError,
              q62CDateAfterAEDateError,
              q62DEmptyError,
            };
          });
        }
        if (p.q63_neurotoxicity_list && p.q63_neurotoxicity_list.length > 0) {
          innerArrQ63 = p.q63_neurotoxicity_list.map((c, cIndex) => {
            const B_empty_err = c.rbl_B == null;
            let B_date_empty_err = false; //c.rbl_B === 2 && isStringEmpty(c.date_B);
            let B_date_before_err = false; //IsOnsetBeforeIndex(c.date_B, p.cohortIndexDate);
            let B_date_after_err = false; //IsDateAfterFunction(c.date_B, p.aeEndDate);
            let B_date_equal_prev_ep_err = false;
            let B_date_invalid = false;
            let B_date_after_eof = false;
            if (!B_empty_err) {
              if (c.rbl_B === 2) {
                if (isStringEmpty(c.date_B)) {
                  B_date_empty_err = true;
                } else if (!IsDateValid(c.date_B)) {
                  B_date_invalid = true;
                } else {
                  B_date_before_err = IsOnsetBeforeIndex(
                    c.date_B,
                    p.cohortIndexDate,
                  );
                  B_date_after_err = IsDateAfterFunction(c.date_B, p.aeEndDate);
                  B_date_after_eof = IsDateAfter(c.date_B, endOfFollowUpDate);
                }
              }
            }
            if (cIndex > 0 && c.date_B) {
              const previousDates = p.q63_neurotoxicity_list
                .slice(0, cIndex)
                .filter(
                  (_, idx) =>
                    idx !== cIndex && p.q63_neurotoxicity_list[idx].date_B,
                )
                .map((crs) => crs.date_B);

              if (previousDates.length > 0) {
                if (previousDates.includes(c.date_B)) {
                  B_date_equal_prev_ep_err = true;
                }
              }
            }

            let C_empty_err = false;
            let C_date_empty_err = false;
            let C_date_before_index_err = false;
            let C_date_before_onset_err = false;
            let C_date_after_err = false;
            let C_date_invalid = false;
            let C_date_before_eof = false;

            let D_empty_err = false;
            let D_txt_empty_err = false;
            let E_empty_err = false;
            let F_empty_err = false;
            let G_empty_err = false;

            if (c.rbl_B != null && c.rbl_B !== 1) {
              C_empty_err = c.rbl_C == null;
              C_date_empty_err = false; //c.rbl_C === 2 && isStringEmpty(c.date_C);
              C_date_before_index_err = false; //IsOnsetBeforeIndex(c.date_C, p.cohortIndexDate);
              C_date_before_onset_err = false; //IsOnsetBeforeIndex(c.date_C, c.date_B);
              C_date_after_err = false; //IsDateAfterFunction(c.date_C, p.aeEndDate);
              C_date_before_eof = false;
              if (!C_empty_err) {
                if (c.rbl_C === 2) {
                  if (isStringEmpty(c.date_C)) {
                    C_date_empty_err = true;
                  } else if (!IsDateValid(c.date_C)) {
                    C_date_invalid = true;
                  } else {
                    C_date_before_index_err = IsOnsetBeforeIndex(
                      c.date_C,
                      p.cohortIndexDate,
                    );
                    C_date_before_onset_err = IsOnsetBeforeIndex(
                      c.date_C,
                      c.date_B,
                    );
                    C_date_after_err = IsDateAfterFunction(
                      c.date_C,
                      p.aeEndDate,
                    );
                    C_date_before_eof = IsDateAfter(
                      c.date_C,
                      endOfFollowUpDate,
                    );
                  }
                }
              }

              D_empty_err = c.rbl_D == null;

              if (c.rbl_D === 7) {
                D_txt_empty_err = isStringEmpty(c.txt_D_oth);
              }

              E_empty_err = c.rbl_E == null;

              F_empty_err =
                !c.chk_F_1 &&
                !c.chk_F_2 &&
                !c.chkFInpatient &&
                !c.chkFEmergencyRoom &&
                !c.chkFIntensiveCareUnit &&
                !c.chkFUrgentCareVisit &&
                !c.chkFOther &&
                !c.rb_F;
              G_empty_err =
                !c.chk_G_1 &&
                !c.chk_G_2 &&
                !c.chk_G_3 &&
                !c.chk_G_4 &&
                !c.chk_G_5 &&
                !c.rb_G;
            }

            // After Gemptyerr validation, add Column H validation:
            let Hemptyerr = false;
            let Hdateemptyerr = false;
            let Hdateinvalid = false;
            let Hdatebeforeindexerr = false;
            let Hdatebeforeonseterr = false;
            let Hdatebeforereserr = false;
            let Hdateaftererr = false;
            let Hdatebeforeeof = false;

            if (c.rbl_B !== null && c.rbl_B !== 1 && isNewEcrfA) {
              // Column H: Earliest date of improvement validation
              Hemptyerr = c.rblH === null;
              if (!Hemptyerr && isNewEcrfA) {
                if (c.rblH === 2) {
                  if (isStringEmpty(c.dateH)) {
                    Hdateemptyerr = true;
                  } else if (!IsDateValid(c.dateH)) {
                    Hdateinvalid = true;
                  } else {
                    Hdatebeforeindexerr = IsOnsetBeforeIndex(
                      c.dateH,
                      p.cohortIndexDate,
                    );
                    Hdatebeforeonseterr = IsOnsetBeforeIndex(c.dateH, c.date_B);
                    Hdatebeforereserr = IsDateAfterFunction(c.dateH, c.date_C);
                    Hdateaftererr = IsDateAfterFunction(c.dateH, p.aeEndDate);
                    Hdatebeforeeof = IsDateAfter(c.dateH, endOfFollowUpDate);
                  }
                }
              }
            }

            if (
              B_empty_err ||
              B_date_empty_err ||
              B_date_before_err ||
              B_date_after_err ||
              B_date_equal_prev_ep_err ||
              B_date_invalid ||
              B_date_after_eof ||
              C_empty_err ||
              C_date_empty_err ||
              C_date_before_index_err ||
              C_date_before_onset_err ||
              C_date_after_err ||
              C_date_invalid ||
              C_date_before_eof ||
              D_empty_err ||
              D_txt_empty_err ||
              E_empty_err ||
              F_empty_err ||
              G_empty_err ||
              Hemptyerr ||
              Hdateemptyerr ||
              Hdateinvalid ||
              Hdatebeforeindexerr ||
              Hdatebeforeonseterr ||
              Hdatebeforereserr ||
              Hdateaftererr ||
              Hdatebeforeeof
            ) {
              isValid = false;
            }

            return {
              ...c,
              B_empty_err,
              B_date_empty_err,
              B_date_before_err,
              B_date_after_err,
              B_date_equal_prev_ep_err,
              B_date_invalid,
              B_date_after_eof,
              C_empty_err,
              C_date_empty_err,
              C_date_before_index_err,
              C_date_before_onset_err,
              C_date_after_err,
              C_date_invalid,
              C_date_before_eof,
              D_empty_err,
              D_txt_empty_err,
              E_empty_err,
              F_empty_err,
              G_empty_err,

              Hemptyerr,
              Hdateemptyerr,
              Hdateinvalid,
              Hdatebeforeindexerr,
              Hdatebeforeonseterr,
              Hdatebeforereserr,
              Hdateaftererr,
              Hdatebeforeeof,
            };
          });
        }

        // Q64 Validations
        if (isNewEcrfA && p.q64_enterocolitis_list?.length > 0) {
          innerArrQ64 = p.q64_enterocolitis_list.map((c, cIndex) => {
            const errors = {
              q64BEmptyError: false,
              q64BDateEmptyError: false,
              q64BDateInvalidError: false,
              q64BDateEqualPrevError: false,
              q64BDateBeforeIndexDateError: false,
              q64BDateAfterCDateError: false,
              q64BDateAfterResolutionDateError: false,
              q64BDateAfterAEDateError: false,

              q64CEmptyError: false,
              q64CDateEmptyError: false,
              q64CDateInvalidError: false,
              q64CDateBeforeError: false,
              q64CDateAfterResolutionDateError: false,
              q64CDateAfterAEDateError: false,

              q64DEmptyError: false,
              q64DDateEmptyError: false,
              q64DDateInvalidError: false,
              q64DDateBeforeError: false,
              q64DDateAfterAEDateError: false,

              q64EEmptyError: false,
              q64EOtherTxtEmptyError: false,
              q64FEmptyError: false,
            };

            errors.q64BEmptyError = c.q64_rbl_B == null;

            if (!errors.q64BEmptyError && c.q64_rbl_B === 2) {
              if (isStringEmpty(c.q64_date_B)) {
                errors.q64BDateEmptyError = true;
              } else if (!IsDateValid(c.q64_date_B)) {
                errors.q64BDateInvalidError = true;
              }

              // Duplicate B date
              if (cIndex > 0 && c.q64_date_B) {
                const prevBDates = p.q64_enterocolitis_list
                  .slice(0, cIndex)
                  .map((x) => x.q64_date_B)
                  .filter(Boolean);

                if (prevBDates.includes(c.q64_date_B)) {
                  errors.q64BDateEqualPrevError = true;
                }
              }
            }

            if (c.q64_rbl_B != null && c.q64_rbl_B !== 1) {
              // C
              errors.q64CEmptyError = c.q64_rbl_C == null;
              if (!errors.q64CEmptyError && c.q64_rbl_C === 2) {
                if (isStringEmpty(c.q64_date_C)) {
                  errors.q64CDateEmptyError = true;
                } else if (!IsDateValid(c.q64_date_C)) {
                  errors.q64CDateInvalidError = true;
                }
              }

              // D
              errors.q64DEmptyError = c.q64_rbl_D == null;
              if (!errors.q64DEmptyError && c.q64_rbl_D === 2) {
                if (isStringEmpty(c.q64_date_D)) {
                  errors.q64DDateEmptyError = true;
                } else if (!IsDateValid(c.q64_date_D)) {
                  errors.q64DDateInvalidError = true;
                }
              }

              // E
              errors.q64EEmptyError =
                !c.q64_chk_E_1 &&
                !c.q64_chk_E_2 &&
                !c.q64_chk_E_3 &&
                !c.q64_chk_E_4 &&
                !c.q64_chk_E_5 &&
                !c.q64_E_unk;

              if (c.q64_chk_E_5 && isStringEmpty(c.q64_chk_E_othTxt)) {
                errors.q64EOtherTxtEmptyError = true;
              }

              // F
              errors.q64FEmptyError = c.q64_severity == null;
            }

            /* Index ≤ B ≤ C ≤ D ≤ AE End
             */
            // --- DATE CHAIN VALIDATION ---
            const dateChainErrors = validateQ64Dates(
              c,
              p.cohortIndexDate,
              p.aeEndDate,
            );
            Object.assign(errors, dateChainErrors);

            // mark overall validity
            if (Object.values(errors).some(Boolean)) isValid = false;

            return { ...c, ...errors };
          });
        }

        // Q65 Validations
        if (isNewEcrfB && p.q65_lymphopenia_list?.length > 0) {
          innerArrQ65 = p.q65_lymphopenia_list.map((c, cIndex) => {
            const errors = {
              q65BEmptyError: false,
              q65BDateEmptyError: false,
              q65BDateInvalidError: false,
              q65BDateEqualPrevError: false,
              q65BDateBeforeIndexDateError: false,
              q65BDateAfterAEDateError: false,

              q65CEmptyError: false,
              q65CDateEmptyError: false,
              q65CDateInvalidError: false,
              q65CDateBeforeError: false,
              q65CDateAfterAEDateError: false,

              q65DEmptyError: false,
            };

            errors.q65BEmptyError = c.q65_rbl_B == null;

            if (!errors.q65BEmptyError && c.q65_rbl_B === 2) {
              if (isStringEmpty(c.q65_date_B)) {
                errors.q65BDateEmptyError = true;
              } else if (!IsDateValid(c.q65_date_B)) {
                errors.q65BDateInvalidError = true;
              }

              // Duplicate B date
              if (cIndex > 0 && c.q65_date_B) {
                const prevBDates = p.q65_lymphopenia_list
                  .slice(0, cIndex)
                  .map((x) => x.q65_date_B)
                  .filter(Boolean);

                if (prevBDates.includes(c.q65_date_B)) {
                  errors.q65BDateEqualPrevError = true;
                }
              }
            }

            if (c.q65_rbl_B != null && c.q65_rbl_B !== 1) {
              // C
              errors.q65CEmptyError = c.q65_rbl_C == null;
              if (!errors.q65CEmptyError && c.q65_rbl_C === 2) {
                if (isStringEmpty(c.q65_date_C)) {
                  errors.q65CDateEmptyError = true;
                } else if (!IsDateValid(c.q65_date_C)) {
                  errors.q65CDateInvalidError = true;
                }
              }

              // D
              errors.q65DEmptyError = c.q65_severity == null;
            }

            /* Index ≤ B ≤ C ≤ AE End
             */
            // --- DATE CHAIN VALIDATION ---
            const dateChainErrors = validateQ65Dates(
              c,
              p.cohortIndexDate,
              p.aeEndDate,
            );
            Object.assign(errors, dateChainErrors);

            // mark overall validity
            if (Object.values(errors).some(Boolean)) isValid = false;

            return { ...c, ...errors };
          });
        }

        // Q57.1.B Validations
        const q57RecordsExist = p.q57_infection_list?.some(
          (ep) => ep.rbl_B != null && ep.rbl_B !== 1,
        );
        if (
          isNewEcrfB &&
          p.q571B_immunoglobin_list?.length > 0 &&
          q57RecordsExist
        ) {
          innerArrQ571B = p.q571B_immunoglobin_list.map((c, cIndex) => {
            const errors = {
              q571BEmptyError: false,
              q571BDateEmptyError: false,
              q571BDateInvalidError: false,
              q571BDateEqualPrevError: false,
              q571BDateBeforeIndexDateError: false,
              q571BDateAfterDateError: false,

              q571CEmptyError: false,
              q571CUnitEmptyError: false,
              q571CUnitInvalidError: false,

              q571DEmptyError: false,
            };

            errors.q571BEmptyError = c.q571B_rbl_B == null;

            if (!errors.q571BEmptyError && c.q571B_rbl_B === 2) {
              if (isStringEmpty(c.q571B_date_B)) {
                errors.q571BDateEmptyError = true;
              } else if (!IsDateValid(c.q571B_date_B)) {
                errors.q571BDateInvalidError = true;
              } else {
                errors.q571BDateBeforeIndexDateError = IsOnsetBeforeIndex(
                  c.q571B_date_B,
                  p.cohortIndexDate,
                );
                if (!errors.q571BDateBeforeIndexDateError) {
                  let earliestEnd = GetEarliestDate(
                    c.subsequentLOTStartDate,
                    p.aeEndDate,
                    endOfFollowUpDate,
                  );

                  if (!isStringEmpty(earliestEnd)) {
                    errors.q571BDateAfterDateError = IsDateAfterFunction(
                      c.q571B_date_B,
                      earliestEnd,
                    );
                  }
                }
              }

              // Duplicate B date
              if (cIndex > 0 && c.q571B_date_B) {
                const prevBDates = p.q571B_immunoglobin_list
                  .slice(0, cIndex)
                  .map((x) => x.q571B_date_B)
                  .filter(Boolean);

                if (prevBDates.includes(c.q571B_date_B)) {
                  errors.q571BDateEqualPrevError = true;
                }
              }
            }

            if (c.q571B_rbl_B != null && c.q571B_rbl_B !== 1) {
              // C
              errors.q571CEmptyError = c.q571B_rbl_C == null;
              if (!errors.q571CEmptyError && c.q571B_rbl_C !== 99) {
                if (isStringEmpty(c.q571B_unit_C)) {
                  errors.q571CUnitEmptyError = true;
                } else {
                  const unitVal = parseFloat(c.q571B_unit_C);
                  const minVal = 0.01;
                  const maxVal = c.q571B_rbl_C === 1 ? 5000 : 50;

                  if (isNaN(unitVal) || unitVal < minVal || unitVal > maxVal) {
                    errors.q571CUnitInvalidError = true;
                  }
                }
              }

              // D
              errors.q571DEmptyError = c.q571B_episode_D == null;
            }

            // mark overall validity
            if (Object.values(errors).some(Boolean)) isValid = false;

            return { ...c, ...errors };
          });
        }

        return {
          ...p,
          q53_crs_list: innerArrQ53,
          q54_icans_list: innerArrQ54,

          q55_neutropenia_list: innerArrQ55,
          q56_cytopenia_list: innerArrQ56,
          q57_infection_list: innerArrQ57,
          q58_weightLoss_list: innerArrQ58,
          q59_dysgeusia_list: innerArrQ59,
          q60_nail_list: innerArrQ60,
          q61_skin_list: innerArrQ61,
          q62_spm_list: innerArrQ62,
          q63_neurotoxicity_list: innerArrQ63,
          q64_enterocolitis_list: innerArrQ64,
          q65_lymphopenia_list: innerArrQ65,
          q571B_immunoglobin_list: innerArrQ571B,
        };
      });

      if (isNewEcrfB) {
        const updatedWarnings = validateQ65Warnings(
          updatedArr,
          q65QLymphopheniaSelectionList,
        );
        setQ65Warnings(updatedWarnings);

        //Q57.1.B
        const qQ571BWarnings = validateQ571BWarnings(updatedArr);
        setQ571BWarnings(qQ571BWarnings);
      }
      setAEDetails(updatedArr);
    }

    return isValid;
  };

  function validateQ64Dates(row, cohortIndexDate, aeEndDate) {
    const errors = {
      q64BDateBeforeIndexDateError: false,
      q64BDateAfterCDateError: false,
      q64BDateAfterResolutionDateError: false,
      q64BDateAfterAEDateError: false,

      q64CDateBeforeError: false,
      q64CDateAfterResolutionDateError: false,
      q64CDateAfterAEDateError: false,

      q64DDateBeforeError: false,
      q64DDateAfterAEDateError: false,
    };

    function parseDate(d) {
      if (!d) return null;
      const dt = new Date(d);
      return isNaN(dt.getTime())
        ? null
        : new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
    }

    const Index = parseDate(cohortIndexDate);
    const B = parseDate(row.q64_date_B);
    const C = parseDate(row.q64_date_C);
    const D = parseDate(row.q64_date_D);
    const AE = parseDate(aeEndDate);

    function isAfter(a, b) {
      return a && b && a > b;
    }

    // B validations
    if (B) {
      if (isAfter(Index, B)) errors.q64BDateBeforeIndexDateError = true;
      if (C && isAfter(B, C)) errors.q64BDateAfterCDateError = true;
      if (D && isAfter(B, D)) errors.q64BDateAfterResolutionDateError = true;
      if (AE && isAfter(B, AE)) errors.q64BDateAfterAEDateError = true;
    }

    // C validations
    if (C) {
      // C is validated against B and Index
      if ((Index && isAfter(Index, C)) || (B && isAfter(B, C)))
        errors.q64CDateBeforeError = true;
      if (D && isAfter(C, D)) errors.q64CDateAfterResolutionDateError = true;
      if (AE && isAfter(C, AE)) errors.q64CDateAfterAEDateError = true;
    }

    // D validations
    if (D) {
      // D validated against Index, B  and C
      if (
        (Index && isAfter(Index, D)) ||
        (C && isAfter(C, D)) ||
        (B && isAfter(B, D))
      )
        errors.q64DDateBeforeError = true;
      if (AE && isAfter(D, AE)) errors.q64DDateAfterAEDateError = true;
    }

    return errors;
  }

  function validateQ65Dates(row, cohortIndexDate, aeEndDate) {
    const errors = {
      q65BDateBeforeIndexDateError: false,
      q65BDateAfterAEDateError: false,

      q65CDateBeforeError: false,
      q65CDateAfterAEDateError: false,
    };

    function parseDate(d) {
      if (!d) return null;
      const dt = new Date(d);
      return isNaN(dt.getTime())
        ? null
        : new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
    }

    const Index = parseDate(cohortIndexDate);
    const B = parseDate(row.q65_date_B);
    const C = parseDate(row.q65_date_C);
    const AE = parseDate(aeEndDate);

    function isAfter(a, b) {
      return a && b && a > b;
    }

    // B validations
    if (B) {
      if (isAfter(Index, B)) errors.q65BDateBeforeIndexDateError = true;
      if (AE && isAfter(B, AE)) errors.q65BDateAfterAEDateError = true;
    }

    // C validations
    if (C) {
      // C is validated against B and Index
      if ((Index && isAfter(Index, C)) || (B && isAfter(B, C)))
        errors.q65CDateBeforeError = true;
      if (AE && isAfter(C, AE)) errors.q65CDateAfterAEDateError = true;
    }

    return errors;
  }

  const AutoPopulateQ63FromQ54 = (parentIndex, currentArray) => {
    if (!currentArray || !currentArray[parentIndex]) {
      return currentArray;
    }

    const cohortId = currentArray[parentIndex]?.cohortTreatmentId;
    const isCARVYKTI = cohortId === RRMMCohortTreatment.CARVYKTI;
    const isABECMA = cohortId === RRMMCohortTreatment.ABECMA;

    if (!isCARVYKTI && !isABECMA) {
      return currentArray;
    }

    const Q54List = currentArray[parentIndex]?.q54_icans_list ?? [];
    let Q63List = [
      ...(currentArray[parentIndex]?.q63_neurotoxicity_list ?? []),
    ];

    // Valid Q54 ICANS events WITH THEIR INDICES
    const validQ54WithIndices = Q54List.map((item, index) => ({
      item,
      index,
    })).filter(({ item }) => {
      return (
        item &&
        item.rbl_B !== null &&
        item.rbl_B !== 1 &&
        (item.rbl_B === 2 || item.rbl_B === 99) &&
        (item.date_B || item.rbl_B === 99)
      );
    });

    // Track which Q63 rows we've already updated
    const matchedQ63Indices = new Set();

    // Build sets for cleanup
    const validQ54Indices = new Set(
      validQ54WithIndices.map(({ index }) => index),
    );
    const validQ54Ids = new Set(
      validQ54WithIndices
        .map(({ item }) => item.icansId)
        .filter((id) => id != null && id !== undefined && id !== 0),
    );

    // Process each valid Q54 item WITH ITS INDEX
    validQ54WithIndices.forEach(({ item: q54Item, index: q54Index }) => {
      let resolutionRadio = null;
      let resolutionDate = null;
      const rblResolution = q54Item?.rblresolution;

      if (rblResolution != null) {
        if (!isNewEcrfA) {
          resolutionRadio = 99;
        } else {
          resolutionRadio = rblResolution === 4 ? 99 : rblResolution;

          if (rblResolution === 2) {
            resolutionDate = q54Item?.dateresolution ?? null;
          }
        }
      } else if (!isNewEcrfA) {
        resolutionRadio = 99;
      }

      const sourceId = q54Item.icansId ?? null;
      const hasSavedId = sourceId && sourceId !== 0;

      // FIRST: Try to match by Q54 array index (works for unsaved & saved rows)
      let existingQ63Index = Q63List.findIndex(
        (q63, idx) =>
          q63.neurotoxicityId === 0 && // UNSAVED row (newly created)
          q63.isAutoPopulated === true &&
          q63.rbl_D === 2 &&
          q63.sourceQ54Index === q54Index && // Match by index (works for unsaved)
          !matchedQ63Indices.has(idx),
      );

      // SECOND: If no match by index, try by saved icansId
      if (existingQ63Index === -1 && hasSavedId) {
        existingQ63Index = Q63List.findIndex(
          (q63, idx) =>
            q63.neurotoxicityId !== 0 && // SAVED row (has ID from DB)
            q63.rbl_D === 2 && // ICANS type
            q63.sourceQ54IcansId === sourceId && // Match by Q54's saved ID
            !matchedQ63Indices.has(idx),
        );
      }
      if (existingQ63Index !== -1) {
        // UPDATE existing row
        matchedQ63Indices.add(existingQ63Index);

        const existing = Q63List[existingQ63Index];

        Q63List[existingQ63Index] = {
          ...existing,
          rbl_B: q54Item.rbl_B,
          date_B: q54Item.date_B, //  Date gets updated
          rbl_C: resolutionRadio,
          date_C: resolutionDate,
          rbl_D: 2,
          rbl_E: !isNewEcrfA ? 99 : (q54Item?.rblC ?? null),
          isAutoPopulated: true,
          sourceQ54IcansId: hasSavedId
            ? sourceId
            : Q63List[existingQ63Index].sourceQ54IcansId,
          sourceQ54Index: q54Index, //  Always track current index
          sourceQ54Date: q54Item.date_B,

          // Clear validation errors
          B_empty_err: false,
          B_date_empty_err: false,
          B_date_before_err: false,
          B_date_after_err: false,
          B_date_equal_prev_ep_err: false,
          B_date_invalid: false,
          B_date_after_eof: false,
          C_empty_err: false,
          C_date_empty_err: false,
          C_date_before_index_err: false,
          C_date_before_onset_err: false,
          C_date_after_err: false,
          C_date_invalid: false,
          C_date_before_eof: false,
          D_empty_err: false,
          D_txt_empty_err: false,
          E_empty_err: false,
        };
      } else {
        // CREATE new Q63 row
        const newQ63Row = {
          ...q63_neurotoxicity_row,
          neurotoxicityId: 0,
          rbl_B: q54Item.rbl_B,
          date_B: q54Item.date_B,
          rbl_C: resolutionRadio,
          date_C: resolutionDate,
          rbl_D: 2,
          rbl_E: !isNewEcrfA ? 99 : (q54Item?.rblC ?? null),
          isAutoPopulated: true,
          sourceQ54IcansId: hasSavedId ? sourceId : null,
          sourceQ54Index: q54Index, // ✅ Track index for new rows
          sourceQ54Date: q54Item.date_B,
        };

        Q63List.push(newQ63Row);
      }
    });

    // Remove orphaned auto-populated ICANS rows
    Q63List = Q63List.filter((q63) => {
      // Keep manual rows and non-ICANS rows
      if (q63.isAutoPopulated !== true || q63.rbl_D !== 2) {
        return true;
      }

      // Keep auto-ICANS if matched by saved ID
      if (q63.sourceQ54IcansId && q63.sourceQ54IcansId !== 0) {
        return validQ54Ids.has(q63.sourceQ54IcansId);
      }

      // Keep auto-ICANS if matched by index
      if (q63.sourceQ54Index !== null && q63.sourceQ54Index !== undefined) {
        return validQ54Indices.has(q63.sourceQ54Index);
      }

      // Remove if no tracking info
      return false;
    });

    const updatedArray = [...currentArray];
    updatedArray[parentIndex] = {
      ...updatedArray[parentIndex],
      q63_neurotoxicity_list: Q63List,
    };

    return updatedArray;
  };

  return (
    <div className="survey-section-content">
      <div className="survey-section-content-header">
        <h4>ADVERSE EVENTS (AEs)</h4>
      </div>
      {showTopErrMsg && (
        <div className="clean-error ">
          <ErrorField
            show={showTopErrMsg}
            message={CommonError_Msgs.Hard_Empty}
          />
        </div>
      )}
      <div className="survey-question-section">
        <div className="survey-question-content">
          <div className="question-answer">
            <div style={{ paddingBottom: "10px" }}>
              As you review and abstract the patient’s chart, please remember
              the requirements on AE reporting according to the Study Protocol,
              Section 5. See{" "}
              <span
                data-tooltip-id="encounterTip"
                className="modal-popup"
                onClick={() => setShowHideHyperlinkModalAEReporting(true)}
              >
                AE Reporting
              </span>
              <span style={{ fontSize: "14px" }}>
                {showHideHyperlinkModalAEReporting && (
                  <InfoPopUp
                    description={hyperlinkTextAEReporting}
                    OkClick={() => setShowHideHyperlinkModalAEReporting(false)}
                  />
                )}{" "}
              </span>
              for more information.
            </div>

            <div style={{ paddingBottom: "10px" }}>
              <b>Note:</b> Please report all observed adverse events and their
              severity as documented in the patient chart. Applicable severity
              grading criteria include American Society for Transplantation and
              Cellular Therapy (ASTCT) for cytokine release syndrome (CRS) and
              immune cell-associated neurotoxicity syndrome (ICANS), and the
              Common Terminology Criteria for Adverse Events (CTCAE) for all
              other adverse events, including infections.
            </div>

            {aeDetails &&
              aeDetails.length > 0 &&
              aeDetails.map((row, idx) => (
                <div className="dependent-section" key={idx}>
                  <div className="cohort-header">
                    <span>
                      {/* style={{ color: PageDesignConstants.fontColor }} */}
                      {row.cohortTreatmentName}
                      {!isStringEmpty(row.superScriptText) && (
                        <>
                          <sup className="supscript">
                            {row.superScriptText.slice(0, 2)}
                          </sup>
                          {row.superScriptText.slice(2)}
                        </>
                      )}
                    </span>
                  </div>
                  <div className="question-bot-sapce">
                    <span>
                      Provide information for each adverse event experienced by
                      the patient during treatment with{" "}
                      <span
                        style={{
                          color: "steelblue",
                          fontWeight: "bolder",
                        }}
                      >
                        {/* style={{ color: PageDesignConstants.fontColor }} */}
                        {row.cohortTreatmentName}
                        {!isStringEmpty(row.superScriptText) && (
                          <>
                            <sup className="supscript">
                              {row.superScriptText.slice(0, 2)}
                            </sup>
                            {row.superScriptText.slice(2)}
                          </>
                        )}
                      </span>{" "}
                      from{" "}
                      <span
                        style={{
                          color: "steelblue",
                          fontWeight: "bolder",
                        }}
                      >
                        {row.cohortIndexDate}
                      </span>{" "}
                      to{" "}
                      <span
                        style={{
                          color: "steelblue",
                          fontWeight: "bolder",
                        }}
                      >
                        {row.aeEndDate}
                      </span>
                      .
                      <b>
                        {" "}
                        <u>
                          If the patient experienced &gt;1 episode of the same
                          type of adverse event, please add more rows to enter
                          the data for each episode.
                        </u>
                      </b>
                    </span>
                  </div>

                  {row.q53_crs_list?.some(
                    (item) => item.ae_ManagementAeWarningTec,
                  ) && (
                    <div className="question-bot-sapce">
                      <ErrorField message={AdverseEvents_Msgs.AEMessages} />
                    </div>
                  )}

                  {/* Q53. */}
                  {row.q53_crs_list && row.q53_crs_list.length > 0 && (
                    <>
                      {/* {row.q53_crs_list && row.q53_crs_list.length > 0 && */}

                      <div className="question question-weight">
                        <span>Q53.</span>
                        <span className="quest-text-pad">
                          Cytokine release syndrome (CRS)
                        </span>
                      </div>

                      <div>
                        {" "}
                        <div className="dependent-section">
                          {row.q53_crs_list.map((childRow, childIdx) => (
                            <div className="loop-section-ul" key={childIdx}>
                              <div className="loop-head">
                                <span className="question-weight">
                                  {GetOrdinal(childIdx + 1)} Episode
                                </span>
                                {childIdx != 0 && (
                                  <div className="delete-btn-div">
                                    <img
                                      width="16px"
                                      src="../Assets/images/Icon-material-delete.png"
                                      alt=""
                                      onClick={() =>
                                        DeleteQ53Row(idx, childIdx)
                                      }
                                    />
                                  </div>
                                )}
                              </div>

                              <div className="">
                                <div className="sub-question grid-overflow">
                                  <table
                                    style={{
                                      border: "1px solid black",
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Treatment
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Date of onset
                                        </th>
                                        {isNewEcrfA && (
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Date of resolution
                                          </th>
                                        )}
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Severity
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <span>
                                            {getCohortTreatmentDisplayName(
                                              row.cohortTreatmentId,
                                            )}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div className="">
                                            {childIdx === 0 && (
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q53_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      childRow.rbl_B === 1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    No events occurred
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                            <div className="long-text-option">
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q53_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={childRow.rbl_B === 2}
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding text-nowrap">
                                                  Event occurred on:{" "}
                                                </span>
                                              </label>
                                              <span className="date-field-padding">
                                                <DatePickerComponent
                                                  ctrlId={
                                                    "q53_date_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  optionId={childIdx}
                                                  date={childRow.date_B}
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en"
                                                />
                                              </span>
                                            </div>
                                            <div>
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q53_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    childRow.rbl_B === 99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Event occurred but onset
                                                  unknown
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <ErrorField
                                            show={childRow.B_empty_err}
                                            message={
                                              AdverseEvents_Msgs.RadioNoSelection
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_empty_err}
                                            message={
                                              AdverseEvents_Msgs.OnsetDtEmpty
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_before_err}
                                            message={
                                              AdverseEvents_Msgs.OnsetDtBeforeIndex
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_after_err}
                                            message={
                                              AdverseEvents_Msgs.DtAfterAEEnd
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={
                                              childRow.B_date_equal_prev_ep_err
                                            }
                                            message={
                                              AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_invalid}
                                            message={
                                              CommonError_Msgs.InvalidDate
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_after_eof}
                                            message={
                                              TTCharacteristics_MSGS.DateBeforeEOF
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                        </td>

                                        {isNewEcrfA &&
                                        childRow.rbl_B !== null &&
                                        childRow.rbl_B !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              {/* Radio buttons remain the same */}
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q53rblresolution_${childIdx}_${idx}`}
                                                    value={1}
                                                    checked={
                                                      childRow.rbl_resolution ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event did not resolve
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q53rblresolution_${childIdx}_${idx}`}
                                                    value={2}
                                                    checked={
                                                      childRow.rbl_resolution ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding text-nowrap">
                                                    Event resolved on:
                                                  </span>
                                                  <span className="date-field-padding">
                                                    <DatePickerComponent
                                                      ctrlId={`q53dateresolution_${childIdx}_${idx}`}
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      optionId={childIdx}
                                                      date={
                                                        childRow.date_resolution
                                                      }
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en"
                                                    />
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q53rblresolution_${childIdx}_${idx}`}
                                                    value={3}
                                                    checked={
                                                      childRow.rbl_resolution ===
                                                      3
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event resolved but date
                                                    unknown
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q53rblresolution_${childIdx}_${idx}`}
                                                    value={4}
                                                    checked={
                                                      childRow.rbl_resolution ===
                                                      4
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Unknown whether event
                                                    resolved or not
                                                  </span>
                                                </label>
                                              </div>
                                            </div>

                                            {/* SIMPLIFIED ERROR MESSAGES - ONLY 4 */}
                                            <ErrorField
                                              show={childRow.resolutionemptyerr}
                                              message={
                                                AdverseEvents_Msgs.RadioNoSelection
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.resolutiondateemptyerr
                                              }
                                              message={
                                                AdverseEvents_Msgs.DysResDtEmpty
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.resolutiondateinvalid
                                              }
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.resolutiondaterangeerr
                                              }
                                              message={
                                                AdverseEvents_Msgs.chronologicalOrder
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </td>
                                        ) : (
                                          isNewEcrfA && (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              <span className="not-applicable">
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )
                                        )}

                                        {childRow.rbl_B != null &&
                                        childRow.rbl_B !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <>
                                              <div className="">
                                                {/* double-dig-answer */}
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q53_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        childRow.rbl_C === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Grade 1
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q53_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        childRow.rbl_C === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Grade 2
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q53_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={3}
                                                      checked={
                                                        childRow.rbl_C === 3
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Grade 3
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q53_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={4}
                                                      checked={
                                                        childRow.rbl_C === 4
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Grade 4
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q53_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={5}
                                                      checked={
                                                        childRow.rbl_C === 5
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Grade 5
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q53_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        childRow.rbl_C === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={childRow.C_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.RadioNoSelection
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              // alignContent: "flex-start",
                                              textAlign: "center",
                                              padding: "8px",
                                              //textAlign: 'start'
                                            }}
                                          >
                                            <span
                                              style={{
                                                textAlign: "center",
                                              }}
                                              className="not-applicable"
                                            >
                                              <b>Not applicable</b>
                                            </span>
                                          </td>
                                        )}
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                              {(row.cohortTreatmentId ===
                                RRMMCohortTreatment.TECVAYLI ||
                                row.cohortTreatmentId ===
                                  RRMMCohortTreatment.TALVEY) && (
                                <ErrorField
                                  show={childRow.Q53q36WarningMsg}
                                  message={AdverseEvents_Msgs.Q53q36CRS}
                                />
                              )}
                              {(row.cohortTreatmentId ===
                                RRMMCohortTreatment.TECVAYLI ||
                                row.cohortTreatmentId ===
                                  RRMMCohortTreatment.TALVEY) && (
                                <ErrorField
                                  show={childRow.Q53q39WarningMsg}
                                  message={AdverseEvents_Msgs.Q53q39CRS}
                                />
                              )}
                            </div>
                          ))}
                          {/* )} */}

                          {/* {row.q53_crs_list && row.q53_crs_list.length < 500 && row.q53_crs_list[row.q53_crs_list.length - 1].rbl_B != null && row.q53_crs_list[row.q53_crs_list.length - 1].rbl_B !== 1 && */}
                          {row.q53_crs_list.length < 500 &&
                            row.q53_crs_list[row.q53_crs_list.length - 1]
                              .rbl_B != null &&
                            row.q53_crs_list[row.q53_crs_list.length - 1]
                              .rbl_B !== 1 && (
                              <div className="sub-question-bot-sapce-ul mt-2">
                                <div
                                  className="answer-list-text"
                                  onClick={() => AddQ53Row(idx)}
                                >
                                  <a>
                                    <img
                                      width="18px"
                                      src="../Assets/images/plus.png"
                                      alt=""
                                    />
                                  </a>
                                  <a className="radio-text-padding">
                                    Click here to add another episode
                                  </a>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  )}
                  {/* Q54. */}
                  {row.q54_icans_list && row.q54_icans_list.length > 0 && (
                    <>
                      <div className="question question-weight">
                        <span>Q54.</span>
                        <span className="quest-text-pad">
                          Immune effector cell-associated neurotoxicity syndrome
                          (ICANS)
                        </span>
                      </div>
                      <div>
                        {" "}
                        {/*className="question-bot-sapce" */}
                        <div className="dependent-section">
                          {row.q54_icans_list.map((childRow, childIdx) => (
                            <div className="loop-section-ul" key={childIdx}>
                              <div className="loop-head">
                                <span className="question-weight">
                                  {GetOrdinal(childIdx + 1)} Episode
                                </span>
                                {childIdx != 0 && (
                                  <div className="delete-btn-div">
                                    <img
                                      width="16px"
                                      src="../Assets/images/Icon-material-delete.png"
                                      alt=""
                                      onClick={() =>
                                        DeleteQ54Row(idx, childIdx)
                                      }
                                    />
                                  </div>
                                )}
                              </div>

                              <div className="">
                                {/* question-bot-sapce */}
                                <div className="sub-question grid-overflow">
                                  <table
                                    style={{
                                      border: "1px solid black",
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Treatment
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Date of onset
                                        </th>

                                        {isNewEcrfA && (
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Date of resolution
                                          </th>
                                        )}

                                        {isNewEcrfA && (
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Severity
                                          </th>
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <span>
                                            {getCohortTreatmentDisplayName(
                                              row.cohortTreatmentId,
                                            )}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div className="">
                                            {/* double-dig-answer */}

                                            {childIdx === 0 && (
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q54_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      childRow.rbl_B === 1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    No events occurred
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                            <div className="long-text-option">
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q54_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={childRow.rbl_B === 2}
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding text-nowrap">
                                                  Event occurred on:{" "}
                                                </span>
                                              </label>
                                              <span className="date-field-padding">
                                                <DatePickerComponent
                                                  ctrlId={
                                                    "q54_date_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  optionId={childIdx}
                                                  date={childRow.date_B}
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en"
                                                />
                                              </span>
                                            </div>
                                            <div>
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q54_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    childRow.rbl_B === 99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Event occurred but onset
                                                  unknown
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <ErrorField
                                            show={childRow.B_empty_err}
                                            message={
                                              AdverseEvents_Msgs.RadioNoSelection
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_empty_err}
                                            message={
                                              AdverseEvents_Msgs.OnsetDtEmpty
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_before_err}
                                            message={
                                              AdverseEvents_Msgs.OnsetDtBeforeIndex
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_after_err}
                                            message={
                                              AdverseEvents_Msgs.DtAfterAEEnd
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={
                                              childRow.B_date_equal_prev_ep_err
                                            }
                                            message={
                                              AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_invalid}
                                            message={
                                              CommonError_Msgs.InvalidDate
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_after_eof}
                                            message={
                                              TTCharacteristics_MSGS.DateBeforeEOF
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                        </td>

                                        {isNewEcrfA &&
                                        childRow.rbl_B !== null &&
                                        childRow.rbl_B !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q54rblresolution_${childIdx}_${idx}`}
                                                    value="1"
                                                    checked={
                                                      childRow.rblresolution ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event did not resolve
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q54rblresolution_${childIdx}_${idx}`}
                                                    value="2"
                                                    checked={
                                                      childRow.rblresolution ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding text-nowrap">
                                                    Event resolved on:
                                                  </span>
                                                  <span className="date-field-padding">
                                                    <DatePickerComponent
                                                      ctrlId={`q54dateresolution_${childIdx}_${idx}`}
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      optionId={childIdx}
                                                      date={
                                                        childRow.dateresolution
                                                      }
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en"
                                                    />
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q54rblresolution_${childIdx}_${idx}`}
                                                    value="3"
                                                    checked={
                                                      childRow.rblresolution ===
                                                      3
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event resolved but date
                                                    unknown
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q54rblresolution_${childIdx}_${idx}`}
                                                    value="4"
                                                    checked={
                                                      childRow.rblresolution ===
                                                      4
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Unknown whether event
                                                    resolved or not
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                            <ErrorField
                                              show={childRow.resolutionemptyerr}
                                              message={
                                                AdverseEvents_Msgs.RadioNoSelection
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.resolutiondateemptyerr
                                              }
                                              message={
                                                AdverseEvents_Msgs.ResolutionDtEmpty
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.resolutiondateinvalid
                                              }
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.resolutiondaterangeerr
                                              }
                                              message={
                                                AdverseEvents_Msgs.chronologicalOrder
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </td>
                                        ) : (
                                          isNewEcrfA && (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              <span className="not-applicable">
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )
                                        )}

                                        {isNewEcrfA &&
                                        childRow.rbl_B !== null &&
                                        childRow.rbl_B !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q54rblC_${childIdx}_${idx}`}
                                                    value={1}
                                                    checked={
                                                      childRow.rblC === 1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Grade 1
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q54rblC_${childIdx}_${idx}`}
                                                    value={2}
                                                    checked={
                                                      childRow.rblC === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Grade 2
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q54rblC_${childIdx}_${idx}`}
                                                    value={3}
                                                    checked={
                                                      childRow.rblC === 3
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Grade 3
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q54rblC_${childIdx}_${idx}`}
                                                    value={4}
                                                    checked={
                                                      childRow.rblC === 4
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Grade 4
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q54rblC_${childIdx}_${idx}`}
                                                    value={5}
                                                    checked={
                                                      childRow.rblC === 5
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Grade 5
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={`q54rblC_${childIdx}_${idx}`}
                                                    value={99}
                                                    checked={
                                                      childRow.rblC === 99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                            <ErrorField
                                              show={childRow.Cemptyerr}
                                              message={
                                                AdverseEvents_Msgs.RadioNoSelection
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </td>
                                        ) : (
                                          isNewEcrfA && (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              <span className="not-applicable">
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )
                                        )}
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                              {(row.cohortTreatmentId ===
                                RRMMCohortTreatment.TECVAYLI ||
                                row.cohortTreatmentId ===
                                  RRMMCohortTreatment.TALVEY) && (
                                <ErrorField
                                  show={childRow.Q54q36WarningMsg}
                                  message={AdverseEvents_Msgs.Q54q36ICANS}
                                />
                              )}
                            </div>
                          ))}

                          {row.q54_icans_list.length < 500 &&
                            row.q54_icans_list[row.q54_icans_list.length - 1]
                              .rbl_B != null &&
                            row.q54_icans_list[row.q54_icans_list.length - 1]
                              .rbl_B !== 1 && (
                              <div className="sub-question-bot-sapce-ul mt-2">
                                <div
                                  className="answer-list-text"
                                  onClick={() => AddQ54Row(idx)}
                                >
                                  <a>
                                    <img
                                      width="18px"
                                      src="../Assets/images/plus.png"
                                      alt=""
                                    />
                                  </a>
                                  <a className="radio-text-padding">
                                    Click here to add another episode
                                  </a>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  )}
                  {/* Q55. */}
                  {row.q55_neutropenia_list &&
                    row.q55_neutropenia_list.length > 0 && (
                      <>
                        <div className="question question-weight">
                          <span>Q55.</span>
                          <span className="quest-text-pad">Neutropenia</span>
                        </div>
                        <div>
                          {" "}
                          {/*className="question-bot-sapce" */}
                          <div className="dependent-section">
                            {row.q55_neutropenia_list.map(
                              (childRow, childIdx) => (
                                <div className="loop-section-ul" key={childIdx}>
                                  <div className="loop-head">
                                    <span className="question-weight">
                                      {GetOrdinal(childIdx + 1)} Episode
                                    </span>
                                    {childIdx != 0 && (
                                      <div className="delete-btn-div">
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          onClick={() =>
                                            DeleteQ55Row(idx, childIdx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  <div className="">
                                    {/* question-bot-sapce */}
                                    <div className="sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of onset
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of resolution
                                            </th>

                                            {isNewEcrfA && (
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Severity
                                              </th>
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span>
                                                {getCohortTreatmentDisplayName(
                                                  row.cohortTreatmentId,
                                                )}
                                              </span>
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div className="">
                                                {/* double-dig-answer */}

                                                {childIdx === 0 && (
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q55_rbl_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.rbl_B === 1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        No events occurred
                                                      </span>
                                                    </label>
                                                  </div>
                                                )}
                                                <div>
                                                  {" "}
                                                  {/* className="long-text-option"*/}
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q55_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        childRow.rbl_B === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event occurred on:{" "}
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "q55_date_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={childIdx}
                                                        date={childRow.date_B}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                      />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q55_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        childRow.rbl_B === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event occurred but onset
                                                      unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={childRow.B_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.RadioNoSelection
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.OnsetDtEmpty
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.B_date_before_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.OnsetDtBeforeIndex
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_after_err}
                                                message={
                                                  AdverseEvents_Msgs.DtAfterAEEnd
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.B_date_equal_prev_ep_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_invalid}
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_after_eof}
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOF
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </td>

                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q55_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.rbl_C === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event did not resolve
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      {" "}
                                                      {/* className="long-text-option"*/}
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q55_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            childRow.rbl_C === 2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event resolved on:{" "}
                                                          {/* </span>
                                                              </label>
                                                              <span className="radio-text-padding"> */}
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "q55_date_C" +
                                                              childIdx +
                                                              "_" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            optionId={childIdx}
                                                            date={
                                                              childRow.date_C
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                          />
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q55_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            childRow.rbl_C === 3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event resolved but
                                                          date unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q55_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.rbl_C ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown whether event
                                                          resolved or not
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.C_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_empty_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.ResolutionDtEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_index_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DateBeforeIndex
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_onset_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.NeutroResolutionBeforeOnset
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_after_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DtAfterAEEnd
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_invalid
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_eof
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.DateBeforeEOF
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  // alignContent: "flex-start",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                  //textAlign: 'start'
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}

                                            {isNewEcrfA &&
                                              (childRow.rbl_B !== null &&
                                              childRow.rbl_B !== 1 ? (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q55rblD_${childIdx}_${idx}`}
                                                          value={1}
                                                          checked={
                                                            childRow.rblD === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 1
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q55rblD_${childIdx}_${idx}`}
                                                          value={2}
                                                          checked={
                                                            childRow.rblD === 2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 2
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q55rblD_${childIdx}_${idx}`}
                                                          value={3}
                                                          checked={
                                                            childRow.rblD === 3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 3
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q55rblD_${childIdx}_${idx}`}
                                                          value={4}
                                                          checked={
                                                            childRow.rblD === 4
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 4
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q55rblD_${childIdx}_${idx}`}
                                                          value={5}
                                                          checked={
                                                            childRow.rblD === 5
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 5
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q55rblD_${childIdx}_${idx}`}
                                                          value={99}
                                                          checked={
                                                            childRow.rblD === 99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.Demptyerr}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </td>
                                              ) : (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="not-applicable">
                                                    <b>Not applicable</b>
                                                  </span>
                                                </td>
                                              ))}
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ),
                            )}

                            {row.q55_neutropenia_list.length < 500 &&
                              row.q55_neutropenia_list[
                                row.q55_neutropenia_list.length - 1
                              ].rbl_B != null &&
                              row.q55_neutropenia_list[
                                row.q55_neutropenia_list.length - 1
                              ].rbl_B !== 1 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={() => AddQ55Row(idx)}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another episode
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </>
                    )}
                  {/* Q56. */}
                  {row.q56_cytopenia_list &&
                    row.q56_cytopenia_list.length > 0 && (
                      <>
                        <div className="question question-weight">
                          <span>Q56.</span>
                          <span className="quest-text-pad">Cytopenia</span>
                        </div>
                        <div>
                          {" "}
                          {/*className="question-bot-sapce" */}
                          <div className="dependent-section">
                            {row.q56_cytopenia_list.map(
                              (childRow, childIdx) => (
                                <div className="loop-section-ul" key={childIdx}>
                                  <div className="loop-head">
                                    <span className="question-weight">
                                      {GetOrdinal(childIdx + 1)} Episode
                                    </span>
                                    {childIdx != 0 && (
                                      <div className="delete-btn-div">
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          onClick={() =>
                                            DeleteQ56Row(idx, childIdx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  <div className="">
                                    {/* question-bot-sapce */}
                                    <div className="sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of onset
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of resolution
                                            </th>

                                            {isNewEcrfA && (
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Severity
                                              </th>
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span>
                                                {getCohortTreatmentDisplayName(
                                                  row.cohortTreatmentId,
                                                )}
                                              </span>
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div className="">
                                                {/* double-dig-answer */}

                                                {childIdx === 0 && (
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q56_rbl_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.rbl_B === 1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        No events occurred
                                                      </span>
                                                    </label>
                                                  </div>
                                                )}

                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q56_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        childRow.rbl_B === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event occurred on:{" "}
                                                      {/* </span>
                                                          </label>
                                                          <span className="radio-text-padding" > */}
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "q56_date_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={childIdx}
                                                        date={childRow.date_B}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                      />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q56_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        childRow.rbl_B === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event occurred but onset
                                                      unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={childRow.B_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.RadioNoSelection
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.OnsetDtEmpty
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.B_date_before_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.OnsetDtBeforeIndex
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_after_err}
                                                message={
                                                  AdverseEvents_Msgs.DtAfterAEEnd
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.B_date_equal_prev_ep_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_invalid}
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_after_eof}
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOF
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </td>

                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q56_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.rbl_C === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event did not resolve
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q56_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            childRow.rbl_C === 2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event resolved on:{" "}
                                                          {/* </span>
                                                              </label>
                                                              <span className="radio-text-padding" > */}
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "q56_date_C" +
                                                              childIdx +
                                                              "_" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            optionId={childIdx}
                                                            date={
                                                              childRow.date_C
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                          />
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q56_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            childRow.rbl_C === 3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event resolved but
                                                          date unknown{" "}
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q56_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.rbl_C ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown whether event
                                                          resolved or not
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.C_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_empty_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.ResolutionDtEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_index_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DateBeforeIndex
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_onset_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.CytoResolutionBeforeOnset
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_after_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DtAfterAEEnd
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_invalid
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_eof
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.DateBeforeEOF
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  // alignContent: "flex-start",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                  //textAlign: 'start'
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}

                                            {isNewEcrfA &&
                                              (childRow.rbl_B !== null &&
                                              childRow.rbl_B !== 1 ? (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div className="double-dig-answer">
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q56rblD_${childIdx}_${idx}`}
                                                          value={1}
                                                          checked={
                                                            childRow.rblD === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 1
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q56rblD_${childIdx}_${idx}`}
                                                          value={2}
                                                          checked={
                                                            childRow.rblD === 2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 2
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q56rblD_${childIdx}_${idx}`}
                                                          value={3}
                                                          checked={
                                                            childRow.rblD === 3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 3
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q56rblD_${childIdx}_${idx}`}
                                                          value={4}
                                                          checked={
                                                            childRow.rblD === 4
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 4
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q56rblD_${childIdx}_${idx}`}
                                                          value={5}
                                                          checked={
                                                            childRow.rblD === 5
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 5
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={`q56rblD_${childIdx}_${idx}`}
                                                          value={99}
                                                          checked={
                                                            childRow.rblD === 99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.Demptyerr}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </td>
                                              ) : (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <span className="not-applicable">
                                                    <b>Not applicable</b>
                                                  </span>
                                                </td>
                                              ))}
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ),
                            )}

                            {row.q56_cytopenia_list.length < 500 &&
                              row.q56_cytopenia_list[
                                row.q56_cytopenia_list.length - 1
                              ].rbl_B != null &&
                              row.q56_cytopenia_list[
                                row.q56_cytopenia_list.length - 1
                              ].rbl_B !== 1 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={() => AddQ56Row(idx)}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another episode
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </>
                    )}
                  {/* Q57. */}
                  {row.q57_infection_list &&
                    row.q57_infection_list.length > 0 && (
                      <>
                        <div className="question question-weight calender-datefix-survey">
                          <span>Q57.</span>
                          <span className="quest-text-pad">Infection</span>
                        </div>
                        <div>
                          {" "}
                          {/*className="question-bot-sapce" */}
                          <div className="dependent-section">
                            {row.q57_infection_list.map(
                              (childRow, childIdx) => (
                                <div className="loop-section-ul" key={childIdx}>
                                  <div className="loop-head">
                                    <span className="question-weight">
                                      {GetOrdinal(childIdx + 1)} Episode
                                    </span>
                                    {childIdx != 0 && (
                                      <div className="delete-btn-div">
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          onClick={() =>
                                            DeleteQ57Row(idx, childIdx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  <div className="">
                                    {/* question-bot-sapce */}
                                    <div
                                      className="sub-question grid-overflow"
                                      style={{ overflowX: "auto" }}
                                    >
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of onset
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Type of infection
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Infection organism
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Severity
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Did infection lead to hospital or
                                              ER visit?
                                            </th>
                                            {isNewEcrfB && (
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Management care setting of AE
                                              </th>
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span>
                                                {getCohortTreatmentDisplayName(
                                                  row.cohortTreatmentId,
                                                )}
                                              </span>
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div className="">
                                                {/* double-dig-answer */}

                                                {childIdx === 0 && (
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q57_rbl_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.rbl_B === 1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        No events occurred
                                                      </span>
                                                    </label>
                                                  </div>
                                                )}
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q57_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        childRow.rbl_B === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event occurred on:{" "}
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "q57_date_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={childIdx}
                                                        date={childRow.date_B}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                      />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q57_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        childRow.rbl_B === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event occurred but onset
                                                      unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={childRow.B_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.RadioNoSelection
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.OnsetDtEmpty
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.B_date_before_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.OnsetDtBeforeIndex
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_after_err}
                                                message={
                                                  AdverseEvents_Msgs.DtAfterAEEnd
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.B_date_equal_prev_ep_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_invalid}
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_after_eof}
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOF
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </td>
                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_C_1_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_C_1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Bacterial
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_C_2_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_C_2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Viral
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_C_3_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_C_3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Fungal
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rb_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.rb_C
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.C_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.ChkBoxRadNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  // alignContent: "flex-start",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                  //textAlign: 'start'
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}
                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_1_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Adenovirus
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_2_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Candida (thrush)
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_3_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          COVID-19
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_4_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_4
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Cytomegalovirus (CMV)
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_5_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_5
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Escherichia Coli (E
                                                          coli)
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_6_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_6
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Helicobacter pylori
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_7_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_7
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Hepatitis B
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_8_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_8
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Herpes simplex
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_9_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_9
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Influenza
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_10_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_10
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Pneumocystis jiroveci
                                                          pneumonia [PJP]
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_11_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_11
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Progressive multifocal
                                                          leukoencephalopathy
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_12_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_12
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Respiratory syncytial
                                                          virus (RSV)
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_13_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_13
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Streptococcus
                                                          pneumoniae
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_14_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_14
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Varicella zoster
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={childIdx}
                                                          name={
                                                            "q57_chk_D_15_" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.chk_D_15
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Others - please
                                                          specify:{" "}
                                                          <textarea
                                                            id={childIdx}
                                                            name={
                                                              "q57_txt_D_oth" +
                                                              childIdx +
                                                              "_" +
                                                              idx
                                                            }
                                                            type="text"
                                                            value={
                                                              childRow.txt_D_oth
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                            maxLength={300}
                                                            className="input-dash"
                                                            style={{
                                                              width: "200px",
                                                            }}
                                                          />
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rb_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.rb_D
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.D_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.ChkBoxRadNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_txt_empty_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.CheckedNoText
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  // alignContent: "flex-start",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                  //textAlign: 'start'
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}

                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rbl_E" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.rbl_E === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 1
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rbl_E" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            childRow.rbl_E === 2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 2
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rbl_E" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            childRow.rbl_E === 3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 3
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rbl_E" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={4}
                                                          checked={
                                                            childRow.rbl_E === 4
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 4
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rbl_E" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={5}
                                                          checked={
                                                            childRow.rbl_E === 5
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 5
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rbl_E" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.rbl_E ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.E_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  // alignContent: "flex-start",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                  //textAlign: 'start'
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}
                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rbl_F" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.rbl_F === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Yes
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rbl_F" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={0}
                                                          checked={
                                                            childRow.rbl_F === 0
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          No
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q57_rbl_F" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.rbl_F ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.F_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  // alignContent: "flex-start",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                  //textAlign: 'start'
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}

                                            {isNewEcrfB && (
                                              <>
                                                {childRow.rbl_B != null &&
                                                childRow.rbl_B !== 1 ? (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <>
                                                      <div className="">
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q57_chk_G_1_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_G_1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Outpatient
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q57_chk_G_2_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_G_2
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Inpatient
                                                              admission
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q57_chk_G_3_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_G_3
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Emergency room
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q57_chk_G_4_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_G_4
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Intensive care
                                                              unit
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q57_chk_G_5_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_G_5
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Other, please
                                                              specify:{" "}
                                                              <textarea
                                                                id={childIdx}
                                                                name={
                                                                  "q57_txt_G_oth" +
                                                                  childIdx +
                                                                  "_" +
                                                                  idx
                                                                }
                                                                type="text"
                                                                value={
                                                                  childRow.txt_G_oth
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                                maxLength={300}
                                                                className="input-dash"
                                                                style={{
                                                                  width:
                                                                    "200px",
                                                                }}
                                                              />
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q57_rb_G_unk" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.rb_G_unk
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Unknown
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          childRow.G_empty_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.ChkBoxRadNoSelection
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          childRow.G_txt_empty_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.q57CheckedNoText
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </>
                                                  </td>
                                                ) : (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      textAlign: "center",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not applicable</b>
                                                    </span>
                                                  </td>
                                                )}
                                              </>
                                            )}
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ),
                            )}

                            {row.q57_infection_list.length < 500 &&
                              row.q57_infection_list[
                                row.q57_infection_list.length - 1
                              ].rbl_B != null &&
                              row.q57_infection_list[
                                row.q57_infection_list.length - 1
                              ].rbl_B !== 1 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={() => AddQ57Row(idx)}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another episode
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </>
                    )}

                  {/* Q57.1.B. */}
                  {row.q571B_immunoglobin_list?.length > 0 &&
                    isNewEcrfB &&
                    row.q57_infection_list?.some(
                      (inf) => inf.rbl_B != null && inf.rbl_B !== 1,
                    ) && (
                      <>
                        <div className="question question-weight">
                          <span>Q57.1.B.</span>
                          <span className="quest-text-pad">
                            Please provide all immunoglobulin G (IgG) levels
                            that occurred during all infection-related AEs while
                            on treatment with{" "}
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                                fontWeight: "bolder",
                              }}
                            >
                              {getCohortTreatmentDisplayName(
                                row.cohortTreatmentId,
                              )}
                            </span>
                            . Add additional rows for each assessment, as
                            needed.
                          </span>
                        </div>
                        <div className="dependent-section">
                          {(() => {
                            const warnings =
                              q571BWarnings?.[row.cohortTreatmentId] || {};

                            return (
                              <>
                                <ErrorField
                                  show={warnings?.q571BDateWarning ?? false}
                                  message={
                                    AdverseEvents_Msgs.ImmunoglobinWarningMessage
                                  }
                                  style={{ padding: "0 0 10px" }}
                                />
                              </>
                            );
                          })()}
                          {row.q571B_immunoglobin_list.map(
                            (childRow, childIdx) => (
                              <div className="loop-section-ul" key={childIdx}>
                                <div className="loop-head">
                                  <span className="question-weight">
                                    {GetOrdinal(childIdx + 1)} Episode
                                  </span>
                                  {childIdx !== 0 && (
                                    <div className="delete-btn-div">
                                      <img
                                        width="16px"
                                        src="../Assets/images/Icon-material-delete.png"
                                        alt=""
                                        onClick={() =>
                                          DeleteQ571BRow(idx, childIdx)
                                        }
                                      />
                                    </div>
                                  )}
                                </div>

                                <div className="">
                                  <div
                                    className="sub-question grid-overflow"
                                    style={{ overflowX: "auto" }}
                                  >
                                    <table
                                      style={{
                                        border: "1px solid black",
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Treatment
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Date of IgG assessment
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Dosage
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Which AE infection episode is this
                                            IgG level associated with?
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <span>
                                              {getCohortTreatmentDisplayName(
                                                row.cohortTreatmentId,
                                              )}
                                            </span>
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "start",
                                            }}
                                          >
                                            <div className="">
                                              {childIdx === 0 && (
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q571B_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        childRow.q571B_rbl_B ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      IgG not assessed during
                                                      any infection-related AEs
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q571B_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      childRow.q571B_rbl_B === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    <DatePickerComponent
                                                      ctrlId={
                                                        "q571B_date_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      optionId={childIdx}
                                                      date={
                                                        childRow.q571B_date_B
                                                      }
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en"
                                                    />
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q571B_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      childRow.q571B_rbl_B ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Date unknown
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                            <ErrorField
                                              show={childRow.q571BEmptyError}
                                              message={
                                                AdverseEvents_Msgs.RadioNoSelection
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q571BDateEmptyError
                                              }
                                              message={
                                                AdverseEvents_Msgs.ImmonoglobinAssessmentDateEmpty
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q571BDateEqualPrevError
                                              }
                                              message={
                                                AdverseEvents_Msgs.AssessmentDtSameAsPrevEpisodes
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q571BDateInvalidError
                                              }
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q571BDateBeforeIndexDateError
                                              }
                                              message={
                                                AdverseEvents_Msgs.DateBeforeIndex
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q571BDateAfterDateError
                                              }
                                              message={
                                                AdverseEvents_Msgs.ImmonoglobinAssessmentDtAfterEndDateError
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </td>

                                          {childRow.q571B_rbl_B != null &&
                                          childRow.q571B_rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              <>
                                                <div className="">
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q571B_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.q571B_rbl_C ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          flexWrap: "wrap",
                                                        }}
                                                      >
                                                        <input
                                                          className="sub-input-dash"
                                                          id={idx}
                                                          name={
                                                            "q571B_unit_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={
                                                            childRow.q571B_rbl_C ===
                                                            1
                                                              ? (childRow.q571B_unit_C ??
                                                                "")
                                                              : ""
                                                          }
                                                          type="text"
                                                          style={{
                                                            width: "80px",
                                                            margin: "0 5px",
                                                          }}
                                                          onChange={(e) =>
                                                            HandleRepeaterUnitFieldChange(
                                                              e,
                                                              1,
                                                            )
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg/dL</span>
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q571B_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          childRow.q571B_rbl_C ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          flexWrap: "wrap",
                                                        }}
                                                      >
                                                        <input
                                                          className="sub-input-dash"
                                                          id={idx}
                                                          name={
                                                            "q571B_unit_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={
                                                            childRow.q571B_rbl_C ===
                                                            2
                                                              ? (childRow.q571B_unit_C ??
                                                                "")
                                                              : ""
                                                          }
                                                          type="text"
                                                          style={{
                                                            width: "80px",
                                                            margin: "0 5px",
                                                          }}
                                                          onChange={(e) =>
                                                            HandleRepeaterUnitFieldChange(
                                                              e,
                                                              2,
                                                            )
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;g/L</span>
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q571B_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          childRow.q571B_rbl_C ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={
                                                    childRow.q571CEmptyError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.RadioNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q571CUnitEmptyError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.ImmonoglobinUnitError
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q571CUnitInvalidError
                                                  }
                                                  message={
                                                    childRow.q571B_rbl_C === 1
                                                      ? AdverseEvents_Msgs.ImmonoglobiC1Range
                                                      : AdverseEvents_Msgs.ImmonoglobinC2Range
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                textAlign: "center",
                                                padding: "8px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}

                                          {childRow.q571B_rbl_B != null &&
                                          childRow.q571B_rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              <>
                                                {row.infectionEpisodeList?.map(
                                                  (episode, epIndex) => (
                                                    <div
                                                      key={episode.infectionKey}
                                                    >
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q571B_episode_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={
                                                            episode.infectionKey
                                                          }
                                                          checked={
                                                            childRow.q571B_episode_D ===
                                                            episode.infectionKey
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          {episode.episodeLabel}
                                                        </span>
                                                      </label>
                                                    </div>
                                                  ),
                                                )}
                                                <ErrorField
                                                  show={
                                                    childRow.q571DEmptyError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.RadioNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                textAlign: "center",
                                                padding: "8px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ),
                          )}

                          {row.q571B_immunoglobin_list.length < 500 &&
                            row.q571B_immunoglobin_list[
                              row.q571B_immunoglobin_list.length - 1
                            ].q571B_rbl_B != null &&
                            row.q571B_immunoglobin_list[
                              row.q571B_immunoglobin_list.length - 1
                            ].q571B_rbl_B !== 1 && (
                              <div className="sub-question-bot-sapce-ul mt-2">
                                <div
                                  className="answer-list-text"
                                  onClick={() =>
                                    AddQ571BRow(idx, row.cohortTreatmentId)
                                  }
                                >
                                  <a>
                                    <img
                                      width="18px"
                                      src="../Assets/images/plus.png"
                                      alt=""
                                    />
                                  </a>
                                  <a className="radio-text-padding">
                                    Click here to add another episode
                                  </a>
                                </div>
                              </div>
                            )}
                        </div>
                      </>
                    )}

                  {/* Q58. */}
                  {row.q58_weightLoss_list &&
                    row.q58_weightLoss_list.length > 0 && (
                      <>
                        <div className="question question-weight">
                          <span>Q58.</span>
                          <span className="quest-text-pad">Weight loss</span>
                        </div>
                        <div>
                          {" "}
                          <div className="dependent-section">
                            {row.q58_weightLoss_list.map(
                              (childRow, childIdx) => (
                                <div className="loop-section-ul" key={childIdx}>
                                  <div className="loop-head">
                                    <span className="question-weight">
                                      {GetOrdinal(childIdx + 1)} Episode
                                    </span>
                                    {childIdx != 0 && (
                                      <div className="delete-btn-div">
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          onClick={() =>
                                            DeleteQ58Row(idx, childIdx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  <div className="">
                                    {/* question-bot-sapce */}
                                    <div className="sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of onset
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of resolution
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of weight becoming stable
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span>
                                                {getCohortTreatmentDisplayName(
                                                  row.cohortTreatmentId,
                                                )}
                                              </span>
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div className="">
                                                {childIdx === 0 && (
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q58_rbl_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.rbl_B === 1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        No events occurred
                                                      </span>
                                                    </label>
                                                  </div>
                                                )}
                                                <div className="long-text-option">
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q58_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        childRow.rbl_B === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event occurred on:{" "}
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "q58_date_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={childIdx}
                                                        date={childRow.date_B}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                      />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q58_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        childRow.rbl_B === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event occurred but onset
                                                      unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={childRow.B_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.RadioNoSelection
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.OnsetDtEmpty
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.B_date_before_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.OnsetDtBeforeIndex
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_after_err}
                                                message={
                                                  AdverseEvents_Msgs.DtAfterAEEnd
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.B_date_equal_prev_ep_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_invalid}
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_after_eof}
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOF
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </td>
                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q58_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.rbl_C === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event did not resolve
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      {" "}
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q58_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            childRow.rbl_C === 2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event resolved on:{" "}
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "q58_date_C" +
                                                              childIdx +
                                                              "_" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            optionId={childIdx}
                                                            date={
                                                              childRow.date_C
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                          />
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q58_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            childRow.rbl_C === 3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event resolved but
                                                          date unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q58_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.rbl_C ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown whether event
                                                          resolved or not
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.C_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_empty_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.ResolutionDtEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_index_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DateBeforeIndex
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_onset_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.WtLossResolutionBeforeOnset
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_after_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DtAfterAEEnd
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_invalid
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q58_rbl_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.rbl_D === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          The patient’s weight
                                                          did not stabilize
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      {" "}
                                                      {/* className="long-text-option"*/}
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q58_rbl_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            childRow.rbl_D === 2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Weight stabilization
                                                          occurred on:{" "}
                                                          {/* </span>
                                                                </label>
                                                                <span className="radio-text-padding"> */}
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "q58_date_D" +
                                                              childIdx +
                                                              "_" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            optionId={childIdx}
                                                            date={
                                                              childRow.date_D
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                          />
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q58_rbl_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            childRow.rbl_D === 3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Weight stabilization
                                                          occurred but date
                                                          unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q58_rbl_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.rbl_D ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown whether the
                                                          patient’s weight
                                                          stabilized or not
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.D_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_empty_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.WtLossStabilizationDtEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_before_index_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DateBeforeIndex
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_before_onset_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.WtLossResolutionBeforeOnset
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_before_res_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.WtLossBeforeResolution
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_after_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DtAfterAEEnd
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_invalid
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_before_eof
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.DateBeforeEOF
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </td>
                                              </>
                                            ) : (
                                              <>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    // alignContent: "flex-start",
                                                    textAlign: "center",
                                                    padding: "8px",
                                                    //textAlign: 'start'
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not applicable</b>
                                                  </span>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    // alignContent: "flex-start",
                                                    textAlign: "center",
                                                    padding: "8px",
                                                    //textAlign: 'start'
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not applicable</b>
                                                  </span>
                                                </td>
                                              </>
                                            )}
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ),
                            )}

                            {row.q58_weightLoss_list.length < 500 &&
                              row.q58_weightLoss_list[
                                row.q58_weightLoss_list.length - 1
                              ].rbl_B != null &&
                              row.q58_weightLoss_list[
                                row.q58_weightLoss_list.length - 1
                              ].rbl_B !== 1 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={() => AddQ58Row(idx)}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another episode
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </>
                    )}
                  {/* Q59. */}
                  {row.q59_dysgeusia_list &&
                    row.q59_dysgeusia_list.length > 0 && (
                      <>
                        <div className="question question-weight">
                          <span>Q59.</span>
                          <span className="quest-text-pad">
                            Dysgeusia (including ageusia, dysgeusia, hypogeusia,
                            and other taste disorders)
                          </span>
                        </div>
                        <div>
                          {" "}
                          {/*className="question-bot-sapce" */}
                          <div className="dependent-section">
                            {row.q59_dysgeusia_list.map(
                              (childRow, childIdx) => (
                                <div className="loop-section-ul" key={childIdx}>
                                  <div className="loop-head">
                                    <span className="question-weight">
                                      {GetOrdinal(childIdx + 1)} Episode
                                    </span>
                                    {childIdx != 0 && (
                                      <div className="delete-btn-div">
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          onClick={() =>
                                            DeleteQ59Row(idx, childIdx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  <div className="">
                                    {/* question-bot-sapce */}
                                    <div className="sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of onset
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Intervention
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Earliest date of improvement
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of resolution
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span>
                                                {getCohortTreatmentDisplayName(
                                                  row.cohortTreatmentId,
                                                )}
                                              </span>
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div className="">
                                                {/* double-dig-answer */}

                                                {childIdx === 0 && (
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q59_rbl_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.rbl_B === 1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        No events occurred
                                                      </span>
                                                    </label>
                                                  </div>
                                                )}
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q59_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        childRow.rbl_B === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event occurred on:{" "}
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "q59_date_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={childIdx}
                                                        date={childRow.date_B}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                      />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q59_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        childRow.rbl_B === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event occurred but onset
                                                      unknown
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={childRow.B_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.RadioNoSelection
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.OnsetDtEmpty
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.B_date_before_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.OnsetDtBeforeIndex
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_after_err}
                                                message={
                                                  AdverseEvents_Msgs.DtAfterAEEnd
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.B_date_equal_prev_ep_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_invalid}
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.B_date_after_eof}
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOF
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </td>
                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q59_chk_CC_1_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_CC_1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Dexamethasone mouthwash
                                                      </span>
                                                    </label>
                                                    {childRow.chk_CC_1 && (
                                                      <Q59ProphylacticTherapeutic
                                                        parentIndex={idx}
                                                        childIdx={childIdx}
                                                        name="q59_chk_CC_1_"
                                                        pChecked={
                                                          childRow.chk_CC_1_P
                                                        }
                                                        sChecked={
                                                          childRow.chk_CC_1_T
                                                        }
                                                        HandleRepeaterFieldChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        error={
                                                          childRow.CC_1_empty_err
                                                        }
                                                      />
                                                    )}
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q59_chk_CC_2_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_CC_2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Nystatin mouthwash
                                                      </span>
                                                    </label>
                                                    {childRow.chk_CC_2 && (
                                                      <Q59ProphylacticTherapeutic
                                                        parentIndex={idx}
                                                        childIdx={childIdx}
                                                        name="q59_chk_CC_2_"
                                                        pChecked={
                                                          childRow.chk_CC_2_P
                                                        }
                                                        sChecked={
                                                          childRow.chk_CC_2_T
                                                        }
                                                        HandleRepeaterFieldChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        error={
                                                          childRow.CC_2_empty_err
                                                        }
                                                      />
                                                    )}
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q59_chk_CC_3_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_CC_3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Saline mouthwash
                                                      </span>
                                                    </label>
                                                    {childRow.chk_CC_3 && (
                                                      <Q59ProphylacticTherapeutic
                                                        parentIndex={idx}
                                                        childIdx={childIdx}
                                                        name="q59_chk_CC_3_"
                                                        pChecked={
                                                          childRow.chk_CC_3_P
                                                        }
                                                        sChecked={
                                                          childRow.chk_CC_3_T
                                                        }
                                                        HandleRepeaterFieldChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        error={
                                                          childRow.CC_3_empty_err
                                                        }
                                                      />
                                                    )}
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q59_chk_CC_4_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_CC_4
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Biotene mouthwash/spray
                                                      </span>
                                                    </label>
                                                    {childRow.chk_CC_4 && (
                                                      <Q59ProphylacticTherapeutic
                                                        parentIndex={idx}
                                                        childIdx={childIdx}
                                                        name="q59_chk_CC_4_"
                                                        pChecked={
                                                          childRow.chk_CC_4_P
                                                        }
                                                        sChecked={
                                                          childRow.chk_CC_4_T
                                                        }
                                                        HandleRepeaterFieldChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        error={
                                                          childRow.CC_4_empty_err
                                                        }
                                                      />
                                                    )}
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q59_chk_CC_5_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_CC_5
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Zinc
                                                      </span>
                                                    </label>
                                                    {childRow.chk_CC_5 && (
                                                      <Q59ProphylacticTherapeutic
                                                        parentIndex={idx}
                                                        childIdx={childIdx}
                                                        name="q59_chk_CC_5_"
                                                        pChecked={
                                                          childRow.chk_CC_5_P
                                                        }
                                                        sChecked={
                                                          childRow.chk_CC_5_T
                                                        }
                                                        HandleRepeaterFieldChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        error={
                                                          childRow.CC_5_empty_err
                                                        }
                                                      />
                                                    )}
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q59_chk_CC_6_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_CC_6
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Vitamin B
                                                      </span>
                                                    </label>
                                                    {childRow.chk_CC_6 && (
                                                      <Q59ProphylacticTherapeutic
                                                        parentIndex={idx}
                                                        childIdx={childIdx}
                                                        name="q59_chk_CC_6_"
                                                        pChecked={
                                                          childRow.chk_CC_6_P
                                                        }
                                                        sChecked={
                                                          childRow.chk_CC_6_T
                                                        }
                                                        HandleRepeaterFieldChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        error={
                                                          childRow.CC_6_empty_err
                                                        }
                                                      />
                                                    )}
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q59_chk_CC_7_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_CC_7
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Other, please specify:{" "}
                                                        <textarea
                                                          id={childIdx}
                                                          name={
                                                            "q59_txt_CC_oth" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          type="text"
                                                          value={
                                                            childRow.txt_CC_oth
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          maxLength={300}
                                                          className="input-dash"
                                                          style={{
                                                            width: "200px",
                                                          }}
                                                        />
                                                      </span>
                                                    </label>
                                                    {childRow.chk_CC_7 && (
                                                      <Q59ProphylacticTherapeutic
                                                        parentIndex={idx}
                                                        childIdx={childIdx}
                                                        name="q59_chk_CC_7_"
                                                        pChecked={
                                                          childRow.chk_CC_7_P
                                                        }
                                                        sChecked={
                                                          childRow.chk_CC_7_T
                                                        }
                                                        HandleRepeaterFieldChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        error={
                                                          childRow.CC_7_empty_err
                                                        }
                                                      />
                                                    )}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q59_rb_CC" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          checked={
                                                            childRow.rb_CC
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.CC_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.ChkBoxRadNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.CC_txt_empty_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.q59CheckedNoText
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  // alignContent: "flex-start",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                  //textAlign: 'start'
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}

                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q59_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.rbl_C === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          The patient did not
                                                          experience improvement
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q59_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            childRow.rbl_C === 2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Earliest improvement
                                                          occurred on:{" "}
                                                          {/* </span>
                                                              </label>
                                                              <span className="radio-text-padding"> */}
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "q59_date_C" +
                                                              childIdx +
                                                              "_" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            optionId={childIdx}
                                                            date={
                                                              childRow.date_C
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                          />
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q59_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            childRow.rbl_C === 3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Improvement occurred
                                                          but date unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q59_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.rbl_C ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown whether the
                                                          patient experienced
                                                          improvement or not
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.C_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_empty_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.EarlyImpDtEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_index_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DateBeforeIndex
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_onset_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DysResolutionBeforeOnset
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_after_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DtAfterAEEnd
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_invalid
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.C_date_before_eof
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.DateBeforeEOF
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  // alignContent: "flex-start",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                  //textAlign: 'start'
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}
                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q59_rbl_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.rbl_D === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event did not resolve
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q59_rbl_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            childRow.rbl_D === 2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event resolved on:{" "}
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "q59_date_D" +
                                                              childIdx +
                                                              "_" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            optionId={childIdx}
                                                            date={
                                                              childRow.date_D
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                          />
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q59_rbl_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            childRow.rbl_D === 3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event resolved but
                                                          date unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q59_rbl_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.rbl_D ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown whether event
                                                          resolved or not
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.D_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_empty_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.ResolutionDtEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_before_index_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DateBeforeIndex
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_before_onset_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DysResolutionBeforeOnset
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_before_impr_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DysResBeforeEarlyImp
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_after_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DtAfterAEEnd
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_invalid
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.D_date_before_eof
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.DateBeforeEOF
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  // alignContent: "flex-start",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                  //textAlign: 'start'
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ),
                            )}

                            {row.q59_dysgeusia_list.length < 500 &&
                              row.q59_dysgeusia_list[
                                row.q59_dysgeusia_list.length - 1
                              ].rbl_B != null &&
                              row.q59_dysgeusia_list[
                                row.q59_dysgeusia_list.length - 1
                              ].rbl_B !== 1 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={() => AddQ59Row(idx)}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another episode
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </>
                    )}
                  {/* Q60. */}
                  {row.q60_nail_list && row.q60_nail_list.length > 0 && (
                    <>
                      <div className="question question-weight">
                        <span>Q60.</span>
                        <span className="quest-text-pad">
                          Nail-related disorder
                        </span>
                      </div>
                      <div>
                        {" "}
                        <div className="dependent-section">
                          {row.q60_nail_list.map((childRow, childIdx) => (
                            <div className="loop-section-ul" key={childIdx}>
                              <div className="loop-head">
                                <span className="question-weight">
                                  {GetOrdinal(childIdx + 1)} Episode
                                </span>
                                {childIdx != 0 && (
                                  <div className="delete-btn-div">
                                    <img
                                      width="16px"
                                      src="../Assets/images/Icon-material-delete.png"
                                      alt=""
                                      onClick={() =>
                                        DeleteQ60Row(idx, childIdx)
                                      }
                                    />
                                  </div>
                                )}
                              </div>

                              <div className="">
                                {/* question-bot-sapce */}
                                <div className="sub-question grid-overflow">
                                  <table
                                    style={{
                                      border: "1px solid black",
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Treatment
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Date of onset
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Earliest date of improvement
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Date of resolution
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <span>
                                            {getCohortTreatmentDisplayName(
                                              row.cohortTreatmentId,
                                            )}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div className="">
                                            {/* double-dig-answer */}

                                            {childIdx === 0 && (
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q60_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      childRow.rbl_B === 1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    No events occurred
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                            <div>
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q60_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={childRow.rbl_B === 2}
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Event occurred on:{" "}
                                                  <DatePickerComponent
                                                    ctrlId={
                                                      "q60_date_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    optionId={childIdx}
                                                    date={childRow.date_B}
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en"
                                                  />
                                                </span>
                                              </label>
                                            </div>
                                            <div>
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q60_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    childRow.rbl_B === 99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Event occurred but onset
                                                  unknown
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <ErrorField
                                            show={childRow.B_empty_err}
                                            message={
                                              AdverseEvents_Msgs.RadioNoSelection
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_empty_err}
                                            message={
                                              AdverseEvents_Msgs.OnsetDtEmpty
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_before_err}
                                            message={
                                              AdverseEvents_Msgs.OnsetDtBeforeIndex
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_after_err}
                                            message={
                                              AdverseEvents_Msgs.DtAfterAEEnd
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={
                                              childRow.B_date_equal_prev_ep_err
                                            }
                                            message={
                                              AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_invalid}
                                            message={
                                              CommonError_Msgs.InvalidDate
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_after_eof}
                                            message={
                                              TTCharacteristics_MSGS.DateBeforeEOF
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                        </td>
                                        {childRow.rbl_B != null &&
                                        childRow.rbl_B !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <>
                                              <div className="">
                                                {/* double-dig-answer */}
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q60_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        childRow.rbl_C === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      The patient did not
                                                      experience improvement
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q60_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        childRow.rbl_C === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Earliest improvement
                                                      occurred on:{" "}
                                                      {/* </span>
                                                              </label>
                                                              <span className="radio-text-padding"> */}
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "q60_date_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={childIdx}
                                                        date={childRow.date_C}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                      />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q60_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={3}
                                                      checked={
                                                        childRow.rbl_C === 3
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Improvement occurred but
                                                      date unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q60_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        childRow.rbl_C === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Unknown whether the
                                                      patient experienced
                                                      improvement or not
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={childRow.C_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.RadioNoSelection
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.C_date_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.EarlyImpDtEmpty
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />

                                              <ErrorField
                                                show={
                                                  childRow.C_date_before_index_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.DateBeforeIndex
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.C_date_before_onset_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.NailResolutionBeforeOnset
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.C_date_after_err}
                                                message={
                                                  AdverseEvents_Msgs.DtAfterAEEnd
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.C_date_invalid}
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.C_date_before_eof
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOF
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              // alignContent: "flex-start",
                                              textAlign: "center",
                                              padding: "8px",
                                              //textAlign: 'start'
                                            }}
                                          >
                                            <span
                                              style={{
                                                textAlign: "center",
                                              }}
                                              className="not-applicable"
                                            >
                                              <b>Not applicable</b>
                                            </span>
                                          </td>
                                        )}
                                        {childRow.rbl_B != null &&
                                        childRow.rbl_B !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <>
                                              <div className="">
                                                {/* double-dig-answer */}
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q60_rbl_D" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        childRow.rbl_D === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event did not resolve
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q60_rbl_D" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        childRow.rbl_D === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event resolved on:{" "}
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "q60_date_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={childIdx}
                                                        date={childRow.date_D}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                      />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q60_rbl_D" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={3}
                                                      checked={
                                                        childRow.rbl_D === 3
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event resolved but date
                                                      unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q60_rbl_D" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        childRow.rbl_D === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Unknown whether event
                                                      resolved or not
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={childRow.D_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.RadioNoSelection
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.D_date_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.ResolutionDtEmpty
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />

                                              <ErrorField
                                                show={
                                                  childRow.D_date_before_index_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.DateBeforeIndex
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.D_date_before_onset_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.NailResolutionBeforeOnset
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.D_date_before_impr_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.NailResBeforeEarlyImp
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.D_date_after_err}
                                                message={
                                                  AdverseEvents_Msgs.DtAfterAEEnd
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.D_date_invalid}
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.D_date_before_eof
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOF
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              // alignContent: "flex-start",
                                              textAlign: "center",
                                              padding: "8px",
                                              //textAlign: 'start'
                                            }}
                                          >
                                            <span
                                              style={{
                                                textAlign: "center",
                                              }}
                                              className="not-applicable"
                                            >
                                              <b>Not applicable</b>
                                            </span>
                                          </td>
                                        )}
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          ))}

                          {row.q60_nail_list.length < 500 &&
                            row.q60_nail_list[row.q60_nail_list.length - 1]
                              .rbl_B != null &&
                            row.q60_nail_list[row.q60_nail_list.length - 1]
                              .rbl_B !== 1 && (
                              <div className="sub-question-bot-sapce-ul mt-2">
                                <div
                                  className="answer-list-text"
                                  onClick={() => AddQ60Row(idx)}
                                >
                                  <a>
                                    <img
                                      width="18px"
                                      src="../Assets/images/plus.png"
                                      alt=""
                                    />
                                  </a>
                                  <a className="radio-text-padding">
                                    Click here to add another episode
                                  </a>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  )}
                  {/* Q61. */}
                  {row.q61_skin_list && row.q61_skin_list.length > 0 && (
                    <>
                      <div className="question question-weight">
                        <span>Q61.</span>
                        <span className="quest-text-pad">
                          Skin-related disorder
                        </span>
                      </div>
                      <div>
                        {" "}
                        {/*className="question-bot-sapce" */}
                        <div className="dependent-section">
                          {row.q61_skin_list.map((childRow, childIdx) => (
                            <div className="loop-section-ul" key={childIdx}>
                              <div className="loop-head">
                                <span className="question-weight">
                                  {GetOrdinal(childIdx + 1)} Episode
                                </span>
                                {childIdx != 0 && (
                                  <div className="delete-btn-div">
                                    <img
                                      width="16px"
                                      src="../Assets/images/Icon-material-delete.png"
                                      alt=""
                                      onClick={() =>
                                        DeleteQ61Row(idx, childIdx)
                                      }
                                    />
                                  </div>
                                )}
                              </div>

                              <div className="">
                                {/* question-bot-sapce */}
                                <div className="sub-question grid-overflow">
                                  <table
                                    style={{
                                      border: "1px solid black",
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Treatment
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Date of onset
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Earliest date of improvement
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Date of resolution
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <span>
                                            {getCohortTreatmentDisplayName(
                                              row.cohortTreatmentId,
                                            )}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div className="">
                                            {/* double-dig-answer */}

                                            {childIdx === 0 && (
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q61_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      childRow.rbl_B === 1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    No events occurred
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                            <div>
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q61_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={childRow.rbl_B === 2}
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Event occurred on:{" "}
                                                  <DatePickerComponent
                                                    ctrlId={
                                                      "q61_date_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    optionId={childIdx}
                                                    date={childRow.date_B}
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en"
                                                  />
                                                </span>
                                              </label>
                                            </div>
                                            <div>
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q61_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    childRow.rbl_B === 99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Event occurred but onset
                                                  unknown
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <ErrorField
                                            show={childRow.B_empty_err}
                                            message={
                                              AdverseEvents_Msgs.RadioNoSelection
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_empty_err}
                                            message={
                                              AdverseEvents_Msgs.OnsetDtEmpty
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_before_err}
                                            message={
                                              AdverseEvents_Msgs.OnsetDtBeforeIndex
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_after_err}
                                            message={
                                              AdverseEvents_Msgs.DtAfterAEEnd
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={
                                              childRow.B_date_equal_prev_ep_err
                                            }
                                            message={
                                              AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_invalid}
                                            message={
                                              CommonError_Msgs.InvalidDate
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_before_eof}
                                            message={
                                              TTCharacteristics_MSGS.DateBeforeEOF
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                        </td>
                                        {childRow.rbl_B != null &&
                                        childRow.rbl_B !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <>
                                              <div className="">
                                                {/* double-dig-answer */}
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q61_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        childRow.rbl_C === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      The patient did not
                                                      experience improvement
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q61_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        childRow.rbl_C === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Earliest improvement
                                                      occurred on:{" "}
                                                      {/* </span>
                                                              </label>
                                                              <span className="radio-text-padding"> */}
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "q61_date_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={childIdx}
                                                        date={childRow.date_C}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                      />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q61_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={3}
                                                      checked={
                                                        childRow.rbl_C === 3
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Improvement occurred but
                                                      date unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q61_rbl_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        childRow.rbl_C === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Unknown whether the
                                                      patient experienced
                                                      improvement or not
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={childRow.C_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.RadioNoSelection
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.C_date_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.EarlyImpDtEmpty
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />

                                              <ErrorField
                                                show={
                                                  childRow.C_date_before_index_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.DateBeforeIndex
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.C_date_before_onset_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.SkinResolutionBeforeOnset
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.C_date_after_err}
                                                message={
                                                  AdverseEvents_Msgs.DtAfterAEEnd
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.C_date_invalid}
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.C_date_before_eof
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOF
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              // alignContent: "flex-start",
                                              textAlign: "center",
                                              padding: "8px",
                                              //textAlign: 'start'
                                            }}
                                          >
                                            <span
                                              style={{
                                                textAlign: "center",
                                              }}
                                              className="not-applicable"
                                            >
                                              <b>Not applicable</b>
                                            </span>
                                          </td>
                                        )}
                                        {childRow.rbl_B != null &&
                                        childRow.rbl_B !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <>
                                              <div className="">
                                                {/* double-dig-answer */}
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q61_rbl_D" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        childRow.rbl_D === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event did not resolve
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q61_rbl_D" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        childRow.rbl_D === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event resolved on:{" "}
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "q61_date_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={childIdx}
                                                        date={childRow.date_D}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                      />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q61_rbl_D" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={3}
                                                      checked={
                                                        childRow.rbl_D === 3
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Event resolved but date
                                                      unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q61_rbl_D" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        childRow.rbl_D === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Unknown whether event
                                                      resolved or not
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                              <ErrorField
                                                show={childRow.D_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.RadioNoSelection
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.D_date_empty_err}
                                                message={
                                                  AdverseEvents_Msgs.ResolutionDtEmpty
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />

                                              <ErrorField
                                                show={
                                                  childRow.D_date_before_index_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.DateBeforeIndex
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.D_date_before_onset_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.SkinResolutionBeforeOnset
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.D_date_before_impr_err
                                                }
                                                message={
                                                  AdverseEvents_Msgs.SkinResBeforeEarlyImp
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.D_date_after_err}
                                                message={
                                                  AdverseEvents_Msgs.DtAfterAEEnd
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={childRow.D_date_invalid}
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  childRow.D_date_before_eof
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOF
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              // alignContent: "flex-start",
                                              textAlign: "center",
                                              padding: "8px",
                                              //textAlign: 'start'
                                            }}
                                          >
                                            <span
                                              style={{
                                                textAlign: "center",
                                              }}
                                              className="not-applicable"
                                            >
                                              <b>Not applicable</b>
                                            </span>
                                          </td>
                                        )}
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          ))}

                          {row.q61_skin_list.length < 500 &&
                            row.q61_skin_list[row.q61_skin_list.length - 1]
                              .rbl_B != null &&
                            row.q61_skin_list[row.q61_skin_list.length - 1]
                              .rbl_B !== 1 && (
                              <div className="sub-question-bot-sapce-ul mt-2">
                                <div
                                  className="answer-list-text"
                                  onClick={() => AddQ61Row(idx)}
                                >
                                  <a>
                                    <img
                                      width="18px"
                                      src="../Assets/images/plus.png"
                                      alt=""
                                    />
                                  </a>
                                  <a className="radio-text-padding">
                                    Click here to add another episode
                                  </a>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  )}

                  {row.q62_spm_list && row.q62_spm_list.length > 0 && (
                    <>
                      <div className="question question-weight">
                        <span>Q62.</span>
                        <span className="quest-text-pad">
                          Secondary primary malignancy (other than MM)
                        </span>
                      </div>
                      <div>
                        {" "}
                        <div className="dependent-section">
                          {row.q62_spm_list.map((childRow, childIdx) => (
                            <div className="loop-section-ul" key={childIdx}>
                              <div className="loop-head">
                                <span className="question-weight">
                                  {GetOrdinal(childIdx + 1)} Episode
                                </span>
                                {childIdx != 0 && (
                                  <div className="delete-btn-div">
                                    <img
                                      width="16px"
                                      src="../Assets/images/Icon-material-delete.png"
                                      alt=""
                                      onClick={() =>
                                        DeleteQ62Row(idx, childIdx)
                                      }
                                    />
                                  </div>
                                )}
                              </div>

                              <div className="">
                                <div className="sub-question grid-overflow">
                                  <table
                                    style={{
                                      border: "1px solid black",
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                            width: "40%",
                                          }}
                                        >
                                          Treatment
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                            width: "60%",
                                          }}
                                        >
                                          Date of occurrence/recurrence
                                        </th>
                                        {isNewEcrfA && (
                                          <>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of resolution
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Severity
                                            </th>
                                          </>
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <span>
                                            {getCohortTreatmentDisplayName(
                                              row.cohortTreatmentId,
                                            )}
                                          </span>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div className="">
                                            {childIdx === 0 && (
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q62_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      childRow.rbl_B === 1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    No events occurred/recurred
                                                  </span>
                                                </label>
                                              </div>
                                            )}

                                            <div>
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q62_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={childRow.rbl_B === 2}
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Event onset/recurrence on:{" "}
                                                  <DatePickerComponent
                                                    ctrlId={
                                                      "q62_date_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    optionId={childIdx}
                                                    date={childRow.date_B}
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en"
                                                  />
                                                </span>
                                              </label>
                                            </div>
                                            <div>
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q62_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    childRow.rbl_B === 99
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Event occurred/recurred but
                                                  date of onset/recurrence
                                                  unknown
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <ErrorField
                                            show={childRow.B_empty_err}
                                            message={
                                              AdverseEvents_Msgs.RadioNoSelection
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_empty_err}
                                            message={
                                              AdverseEvents_Msgs.OnsetDtEmpty
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_before_err}
                                            message={
                                              AdverseEvents_Msgs.OnsetDtBeforeIndex
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_after_err}
                                            message={
                                              AdverseEvents_Msgs.DtAfterAEEnd
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={
                                              childRow.B_date_equal_prev_ep_err
                                            }
                                            message={
                                              AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_invalid}
                                            message={
                                              CommonError_Msgs.InvalidDate
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                          <ErrorField
                                            show={childRow.B_date_after_eof}
                                            message={
                                              TTCharacteristics_MSGS.DateBeforeEOF
                                            }
                                            style={{
                                              paddingLeft: "0px",
                                            }}
                                          />
                                        </td>
                                        {isNewEcrfA && (
                                          <>
                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q62_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.q62_rbl_C ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event did not resolve
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q62_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            childRow.q62_rbl_C ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event resolved on:{" "}
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "q62_date_C" +
                                                              childIdx +
                                                              "_" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            optionId={childIdx}
                                                            date={
                                                              childRow.q62_date_C
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                          />
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q62_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            childRow.q62_rbl_C ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Event resolved but
                                                          date unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q62_rbl_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.q62_rbl_C ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown whether event
                                                          resolved or not
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      childRow.q62CEmptyError
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.q62CDateEmptyError
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.ResolutionDtEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.q62CDateInvalidError
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.q62CDateBeforeIndexError
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DateBeforeIndex
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.q62CDateBeforeOnsetError
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.SPMResolutionBeforeOnset
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.q62CDateAfterAEDateError
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.SPMResolutionBeforeOnset
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}

                                            {childRow.rbl_B != null &&
                                            childRow.rbl_B !== 1 ? (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <>
                                                  <div className="">
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q62_severity" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.q62_severity ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 1
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q62_severity" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            childRow.q62_severity ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 2
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q62_severity" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            childRow.q62_severity ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 3
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q62_severity" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={4}
                                                          checked={
                                                            childRow.q62_severity ===
                                                            4
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 4
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q62_severity" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={5}
                                                          checked={
                                                            childRow.q62_severity ===
                                                            5
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Grade 5
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q62_severity" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.q62_severity ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      childRow.q62DEmptyError
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </>
                                              </td>
                                            ) : (
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              </td>
                                            )}
                                          </>
                                        )}
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          ))}

                          {row.q62_spm_list.length < 500 &&
                            row.q62_spm_list[row.q62_spm_list.length - 1]
                              .rbl_B != null &&
                            row.q62_spm_list[row.q62_spm_list.length - 1]
                              .rbl_B !== 1 && (
                              <div className="sub-question-bot-sapce-ul mt-2">
                                <div
                                  className="answer-list-text"
                                  onClick={() =>
                                    AddQ62Row(idx, row.cohortTreatmentId)
                                  }
                                >
                                  <a>
                                    <img
                                      width="18px"
                                      src="../Assets/images/plus.png"
                                      alt=""
                                    />
                                  </a>
                                  <a className="radio-text-padding">
                                    Click here to add another episode
                                  </a>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  )}

                  {/* Q63. if A slected */}
                  {row.q63_neurotoxicity_list &&
                  row.q63_neurotoxicity_list.length > 0 &&
                  isNewEcrfA ? (
                    <>
                      <div className="question question-weight">
                        <span>Q63.</span>
                        <span className="quest-text-pad">Neurologic event</span>
                      </div>

                      <div>
                        <b>If ICANS reported above:</b> for any ICANS events
                        reported in Q54, we have auto-populated information to
                        allow for providing additional details on the management
                        setting, interventions received, and dates of earliest
                        improvement.
                      </div>

                      <div>
                        <b>Note:</b> in addition to any ICANS events, if a
                        patient experienced multiple other neurologic event
                        subtypes, please enter one row per event for each
                        subtype that occurred. Multiple rows of the same subtype
                        are permitted for unique AE event episodes.{" "}
                      </div>
                      <div>
                        {" "}
                        <div className="dependent-section">
                          {row.q63_neurotoxicity_list.map(
                            (childRow, childIdx) => (
                              <div className="loop-section-ul" key={childIdx}>
                                <div className="loop-head">
                                  <span className="question-weight">
                                    {GetOrdinal(childIdx + 1)} Episode
                                    {childRow.isAutoPopulated && (
                                      <span
                                        style={{
                                          fontWeight: "normal",
                                          color: "#1890ff",
                                        }}
                                      >
                                        {" - populated from Q54 response"}
                                      </span>
                                    )}
                                  </span>
                                  {childIdx != 0 &&
                                    childRow.isAutoPopulated == false && (
                                      <div className="delete-btn-div">
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          onClick={() =>
                                            DeleteQ63Row(idx, childIdx)
                                          }
                                        />
                                      </div>
                                    )}
                                </div>

                                <div className="">
                                  {/* question-bot-sapce */}
                                  <div
                                    className="sub-question grid-overflow"
                                    style={{ overflowX: "auto" }}
                                  >
                                    <table
                                      style={{
                                        border: "1px solid black",
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Treatment
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Date of onset
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Date of resolution
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Subtype of neurologic event
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Severity
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Management setting of neurologic
                                            event
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Interventions for managing
                                            neurologic event
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Earliest date of improvement
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <span>
                                              {getCohortTreatmentDisplayName(
                                                row.cohortTreatmentId,
                                              )}
                                            </span>
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div className="">
                                              {/* double-dig-answer */}

                                              {childIdx === 0 && (
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q63_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        childRow.rbl_B === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                      disabled={
                                                        childRow.isAutoPopulated
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      No events occurred
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q63_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      childRow.rbl_B === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                    disabled={
                                                      childRow.isAutoPopulated
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event occurred on:{" "}
                                                    <span
                                                      style={{
                                                        pointerEvents:
                                                          childRow.isAutoPopulated
                                                            ? "none"
                                                            : "auto",
                                                        opacity:
                                                          childRow.isAutoPopulated
                                                            ? 0.6
                                                            : 1,
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "q63_date_B" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={childIdx}
                                                        date={childRow.date_B}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                      />
                                                    </span>
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q63_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      childRow.rbl_B === 99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                    disabled={
                                                      childRow.isAutoPopulated
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event occurred but onset
                                                    unknown
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                            <ErrorField
                                              show={childRow.B_empty_err}
                                              message={
                                                AdverseEvents_Msgs.RadioNoSelection
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={childRow.B_date_empty_err}
                                              message={
                                                AdverseEvents_Msgs.OnsetDtEmpty
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={childRow.B_date_before_err}
                                              message={
                                                AdverseEvents_Msgs.OnsetDtBeforeIndex
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={childRow.B_date_after_err}
                                              message={
                                                AdverseEvents_Msgs.DtAfterAEEnd
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.B_date_equal_prev_ep_err
                                              }
                                              message={
                                                AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={childRow.B_date_invalid}
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={childRow.B_date_after_eof}
                                              message={
                                                TTCharacteristics_MSGS.DateBeforeEOF
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </td>

                                          {childRow.rbl_B != null &&
                                          childRow.rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div className="">
                                                  {/* double-dig-answer */}
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.rbl_C === 1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Event did not resolve
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          childRow.rbl_C === 2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Event resolved on:{" "}
                                                        <span
                                                          style={{
                                                            pointerEvents:
                                                              childRow.isAutoPopulated
                                                                ? "none"
                                                                : "auto",
                                                            opacity:
                                                              childRow.isAutoPopulated
                                                                ? 0.6
                                                                : 1,
                                                          }}
                                                        >
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "q63_date_C" +
                                                              childIdx +
                                                              "_" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            optionId={childIdx}
                                                            date={
                                                              childRow.date_C
                                                            }
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en"
                                                          />
                                                        </span>
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          childRow.rbl_C === 3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Event resolved but date
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          childRow.rbl_C === 99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown whether event
                                                        resolved or not
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={childRow.C_empty_err}
                                                  message={
                                                    AdverseEvents_Msgs.RadioNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.C_date_empty_err
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.ResolutionDtEmpty
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.C_date_before_index_err
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.DateBeforeIndex
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.C_date_before_onset_err
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.NeuroResolutionBeforeOnset
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.C_date_after_err
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.DtAfterAEEnd
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={childRow.C_date_invalid}
                                                  message={
                                                    CommonError_Msgs.InvalidDate
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.C_date_before_eof
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.DateBeforeEOF
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                // alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}

                                          {childRow.rbl_B != null &&
                                          childRow.rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div className="">
                                                  {/* double-dig-answer */}
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.rbl_D === 1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Peripheral neuropathy
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          childRow.rbl_D === 2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Immune effector
                                                        cell-associated
                                                        neurotoxicity syndrome
                                                        (ICANS)
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          childRow.rbl_D === 3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Fever
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          childRow.rbl_D === 4
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Delayed neurotoxicity
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={8}
                                                        checked={
                                                          childRow.rbl_D === 8
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Guillain-Barre Syndrome
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={5}
                                                        checked={
                                                          childRow.rbl_D === 5
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Parkinsonism
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={6}
                                                        checked={
                                                          childRow.rbl_D === 6
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Cranial nerve palsy
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={7}
                                                        checked={
                                                          childRow.rbl_D === 7
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Other, please specify:
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div
                                                    style={{
                                                      marginLeft: "30px",
                                                      marginTop: "5px",
                                                    }}
                                                  >
                                                    <textarea
                                                      id={childIdx}
                                                      name={
                                                        "q63_txt_D_oth" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      type="text"
                                                      value={childRow.txt_D_oth}
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                      maxLength={300}
                                                      className="input-dash"
                                                      style={{
                                                        width: "200px",
                                                      }}
                                                      disabled={
                                                        childRow.isAutoPopulated
                                                      }
                                                    />

                                                    <ErrorField
                                                      show={
                                                        childRow.D_txt_empty_err
                                                      }
                                                      message="Please specify the other neurologic event"
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          childRow.rbl_D === 99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={childRow.D_empty_err}
                                                  message={
                                                    AdverseEvents_Msgs.RadioNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                // alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}

                                          {childRow.rbl_B != null &&
                                          childRow.rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div className="">
                                                  {/* double-dig-answer */}
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_E" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.rbl_E === 1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Grade 1
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_E" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          childRow.rbl_E === 2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Grade 2
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_E" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          childRow.rbl_E === 3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Grade 3
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_E" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          childRow.rbl_E === 4
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Grade 4
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_E" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={5}
                                                        checked={
                                                          childRow.rbl_E === 5
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Grade 5
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rbl_E" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          childRow.rbl_E === 99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                        disabled={
                                                          childRow.isAutoPopulated
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={childRow.E_empty_err}
                                                  message={
                                                    AdverseEvents_Msgs.RadioNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                // alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}

                                          {childRow.rbl_B != null &&
                                          childRow.rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div className="">
                                                  {/* double-dig-answer */}

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63chkFInpatient_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chkFInpatient
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Inpatient
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63chkFEmergencyRoom_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chkFEmergencyRoom
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Emergency Room
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63chkFIntensiveCareUnit_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chkFIntensiveCareUnit
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Intensive Care Unit
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63_chk_F_1_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_F_1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Outpatient
                                                      </span>
                                                    </label>
                                                  </div>
                                                  {/* <div>
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={childIdx}
                                                                  name={
                                                                    "q63_chk_F_2_" +
                                                                    childIdx +
                                                                    "_" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    childRow.chk_F_2
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Hospital
                                                                </span>
                                                              </label>
                                                            </div> */}

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63chkFUrgentCareVisit_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chkFUrgentCareVisit
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Urgent Care Visit
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63chkFOther_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chkFOther
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Other
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rb_F" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={childRow.rb_F}
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={childRow.F_empty_err}
                                                  message={
                                                    AdverseEvents_Msgs.ChkBoxRadNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                // alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}

                                          {childRow.rbl_B != null &&
                                          childRow.rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div className="">
                                                  {/* double-dig-answer */}
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63_chk_G_1_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_G_1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Corticosteroids
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63_chk_G_2_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_G_2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Anakinra
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63_chk_G_3_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_G_3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Tocilizumab
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63_chk_G_4_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_G_4
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Siltuximab
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q63_chk_G_5_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.chk_G_5
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Other
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q63_rb_G" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={childRow.rb_G}
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={childRow.G_empty_err}
                                                  message={
                                                    AdverseEvents_Msgs.ChkBoxRadNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                // alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}

                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "start",
                                            }}
                                          >
                                            {childRow.rbl_B !== null &&
                                            childRow.rbl_B !== 1 ? (
                                              <>
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={`q63rblH_${childIdx}_${idx}`}
                                                      value="1"
                                                      checked={
                                                        childRow.rblH === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      The patient did not
                                                      experience improvement
                                                    </span>
                                                  </label>
                                                </div>

                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={`q63rblH_${childIdx}_${idx}`}
                                                      value="2"
                                                      checked={
                                                        childRow.rblH === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Earliest improvement
                                                      occurred on:
                                                    </span>
                                                  </label>
                                                  <span className="radio-text-padding">
                                                    <DatePickerComponent
                                                      ctrlId={`q63dateH_${childIdx}_${idx}`}
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      optionId={childIdx}
                                                      date={childRow.dateH}
                                                    />
                                                  </span>
                                                </div>

                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={`q63rblH_${childIdx}_${idx}`}
                                                      value="3"
                                                      checked={
                                                        childRow.rblH === 3
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Improvement occurred but
                                                      date unknown
                                                    </span>
                                                  </label>
                                                </div>

                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={`q63rblH_${childIdx}_${idx}`}
                                                      value="99"
                                                      checked={
                                                        childRow.rblH === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Unknown whether the
                                                      patient experienced
                                                      improvement or not
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={childRow.Hemptyerr}
                                                  message={
                                                    AdverseEvents_Msgs.RadioNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />

                                                <ErrorField
                                                  show={childRow.Hdateemptyerr}
                                                  message={
                                                    "Please enter the earliest date of improvement"
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={childRow.Hdateinvalid}
                                                  message={
                                                    CommonError_Msgs.InvalidDate
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.Hdatebeforeindexerr
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.DateBeforeIndex
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.Hdatebeforeonseterr
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.NeuroResolutionBeforeOnset
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.Hdatebeforereserr
                                                  }
                                                  message={`Date should be on or before the ${DateDisplayFormat(
                                                    childRow.date_C,
                                                  )} (Date of resolution)`}
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={childRow.Hdateaftererr}
                                                  message={
                                                    AdverseEvents_Msgs.DtAfterAEEnd
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={childRow.Hdatebeforeeof}
                                                  message={
                                                    TTCharacteristics_MSGS.DateBeforeEOF
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            ) : (
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            )}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ),
                          )}

                          {row.q63_neurotoxicity_list.length < 500 &&
                            row.q63_neurotoxicity_list[
                              row.q63_neurotoxicity_list.length - 1
                            ].rbl_B != null &&
                            row.q63_neurotoxicity_list[
                              row.q63_neurotoxicity_list.length - 1
                            ].rbl_B !== 1 && (
                              <div className="sub-question-bot-sapce-ul mt-2">
                                <div
                                  className="answer-list-text"
                                  onClick={() => AddQ63Row(idx)}
                                >
                                  <a>
                                    <img
                                      width="18px"
                                      src="../Assets/images/plus.png"
                                      alt=""
                                    />
                                  </a>
                                  <a className="radio-text-padding">
                                    Click here to add another episode
                                  </a>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {" "}
                      {/* Q63. */}
                      {row.q63_neurotoxicity_list &&
                        row.q63_neurotoxicity_list.length > 0 &&
                        !isNewEcrfA && (
                          <>
                            <div className="question question-weight">
                              <span>Q63.</span>
                              <span className="quest-text-pad">
                                Neurotoxicity
                              </span>
                            </div>
                            <div>
                              <b>If ICANS reported above:</b> for any ICANS
                              events reported in Q54, we have auto-populated
                              information to allow for providing additional
                              details on the management setting, interventions
                              received, and dates of earliest improvement.
                            </div>

                            <div>
                              <b>Note:</b> in addition to any ICANS events, if a
                              patient experienced multiple other neurotoxity
                              subtypes, please enter one row per event for each
                              subtype that occurred. Multiple rows of the same
                              subtype are permitted for unique AE event
                              episodes.{" "}
                            </div>
                            <div>
                              {" "}
                              <div className="dependent-section">
                                {row.q63_neurotoxicity_list.map(
                                  (childRow, childIdx) => (
                                    <div
                                      className="loop-section-ul"
                                      key={childIdx}
                                    >
                                      <div className="loop-head">
                                        <span className="question-weight">
                                          {GetOrdinal(childIdx + 1)} Episode
                                          {childRow.isAutoPopulated && (
                                            <span
                                              style={{
                                                fontWeight: "normal",
                                                color: "#1890ff",
                                              }}
                                            >
                                              {" - populated from Q54 response"}
                                            </span>
                                          )}
                                        </span>
                                        {childIdx != 0 &&
                                          childRow.isAutoPopulated == false && (
                                            <div className="delete-btn-div">
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                onClick={() =>
                                                  DeleteQ63Row(idx, childIdx)
                                                }
                                              />
                                            </div>
                                          )}
                                      </div>

                                      <div className="">
                                        {/* question-bot-sapce */}
                                        <div
                                          className="sub-question"
                                          style={{ overflowX: "auto" }}
                                        >
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Date of neurotoxicity onset
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Date of neurotoxicity
                                                  resolution
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Subtype of neurotoxicity
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Severity
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Management setting of
                                                  neurotoxicity
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Interventions for managing
                                                  neurotoxicity
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span>
                                                    {getCohortTreatmentDisplayName(
                                                      row.cohortTreatmentId,
                                                    )}
                                                  </span>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div className="">
                                                    {/* double-dig-answer */}
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q63_rbl_B" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            childRow.rbl_B === 1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          disabled={
                                                            childRow.isAutoPopulated
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          The patient did not
                                                          experience
                                                          neurotoxicity
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q63_rbl_B" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            childRow.rbl_B === 2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          disabled={
                                                            childRow.isAutoPopulated
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Neurotoxicity onset
                                                          occurred on:{" "}
                                                          <span
                                                            style={{
                                                              pointerEvents:
                                                                childRow.isAutoPopulated
                                                                  ? "none"
                                                                  : "auto",
                                                              opacity:
                                                                childRow.isAutoPopulated
                                                                  ? 0.6
                                                                  : 1,
                                                            }}
                                                          >
                                                            <DatePickerComponent
                                                              ctrlId={
                                                                "q63_date_B" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              HandleDateChange={
                                                                HandleRepeaterDateChange
                                                              }
                                                              optionId={
                                                                childIdx
                                                              }
                                                              date={
                                                                childRow.date_B
                                                              }
                                                              minDate={dayjs(
                                                                "01-01-1920",
                                                              )}
                                                              maxDate={dayjs()}
                                                              locale="en"
                                                            />
                                                          </span>
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          id={childIdx}
                                                          name={
                                                            "q63_rbl_B" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            childRow.rbl_B ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          disabled={
                                                            childRow.isAutoPopulated
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Neurotoxicity occurred
                                                          but date of onset
                                                          unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={childRow.B_empty_err}
                                                    message={
                                                      AdverseEvents_Msgs.RadioNoSelection
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.B_date_empty_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.OnsetDtEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.B_date_before_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.OnsetDtBeforeIndex
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.B_date_after_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DtAfterAEEnd
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.B_date_equal_prev_ep_err
                                                    }
                                                    message={
                                                      AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.B_date_invalid
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      childRow.B_date_after_eof
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.DateBeforeEOF
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </td>

                                                {childRow.rbl_B != null &&
                                                childRow.rbl_B !== 1 ? (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <>
                                                      <div className="">
                                                        {/* double-dig-answer */}
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_C" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={1}
                                                              checked={
                                                                childRow.rbl_C ===
                                                                1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              The patient’s
                                                              neurotoxicity did
                                                              not resolve
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_C" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={2}
                                                              checked={
                                                                childRow.rbl_C ===
                                                                2
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Resolution
                                                              occurred on:{" "}
                                                              <span
                                                                style={{
                                                                  pointerEvents:
                                                                    childRow.isAutoPopulated
                                                                      ? "none"
                                                                      : "auto",
                                                                  opacity:
                                                                    childRow.isAutoPopulated
                                                                      ? 0.6
                                                                      : 1,
                                                                }}
                                                              >
                                                                <DatePickerComponent
                                                                  ctrlId={
                                                                    "q63_date_C" +
                                                                    childIdx +
                                                                    "_" +
                                                                    idx
                                                                  }
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  optionId={
                                                                    childIdx
                                                                  }
                                                                  date={
                                                                    childRow.date_C
                                                                  }
                                                                  minDate={dayjs(
                                                                    "01-01-1920",
                                                                  )}
                                                                  maxDate={dayjs()}
                                                                  locale="en"
                                                                />
                                                              </span>
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_C" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={3}
                                                              checked={
                                                                childRow.rbl_C ===
                                                                3
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Resolution
                                                              occurred but date
                                                              unknown
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_C" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={99}
                                                              checked={
                                                                childRow.rbl_C ===
                                                                99
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Unknown whether
                                                              the neurotoxicity
                                                              event resolved or
                                                              not
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          childRow.C_empty_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.RadioNoSelection
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          childRow.C_date_empty_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.ResolutionDtEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          childRow.C_date_before_index_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.DateBeforeIndex
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          childRow.C_date_before_onset_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.NeuroResolutionBeforeOnset
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          childRow.C_date_after_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.DtAfterAEEnd
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          childRow.C_date_invalid
                                                        }
                                                        message={
                                                          CommonError_Msgs.InvalidDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          childRow.C_date_before_eof
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.DateBeforeEOF
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </>
                                                  </td>
                                                ) : (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      // alignContent: "flex-start",
                                                      textAlign: "center",
                                                      padding: "8px",
                                                      //textAlign: 'start'
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not applicable</b>
                                                    </span>
                                                  </td>
                                                )}

                                                {childRow.rbl_B != null &&
                                                childRow.rbl_B !== 1 ? (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <>
                                                      <div className="">
                                                        {/* double-dig-answer */}
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_D" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={1}
                                                              checked={
                                                                childRow.rbl_D ===
                                                                1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Peripheral
                                                              neuropathy
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_D" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={2}
                                                              checked={
                                                                childRow.rbl_D ===
                                                                2
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Immune effector
                                                              cell-associated
                                                              neurotoxicity
                                                              syndrome (ICANS)
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_D" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={3}
                                                              checked={
                                                                childRow.rbl_D ===
                                                                3
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Fever
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_D" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={4}
                                                              checked={
                                                                childRow.rbl_D ===
                                                                4
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Delayed
                                                              neurotoxicity
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_D" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={5}
                                                              checked={
                                                                childRow.rbl_D ===
                                                                5
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Parkinsonism
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_D" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={6}
                                                              checked={
                                                                childRow.rbl_D ===
                                                                6
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Cranial nerve
                                                              palsy
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_D" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={7}
                                                              checked={
                                                                childRow.rbl_D ===
                                                                7
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Other
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_D" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={99}
                                                              checked={
                                                                childRow.rbl_D ===
                                                                99
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Unknown
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          childRow.D_empty_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.RadioNoSelection
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </>
                                                  </td>
                                                ) : (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      // alignContent: "flex-start",
                                                      textAlign: "center",
                                                      padding: "8px",
                                                      //textAlign: 'start'
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not applicable</b>
                                                    </span>
                                                  </td>
                                                )}

                                                {childRow.rbl_B != null &&
                                                childRow.rbl_B !== 1 ? (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <>
                                                      <div className="">
                                                        {/* double-dig-answer */}
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_E" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={1}
                                                              checked={
                                                                childRow.rbl_E ===
                                                                1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Grade 1
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_E" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={2}
                                                              checked={
                                                                childRow.rbl_E ===
                                                                2
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Grade 2
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_E" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={3}
                                                              checked={
                                                                childRow.rbl_E ===
                                                                3
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Grade 3
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_E" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={4}
                                                              checked={
                                                                childRow.rbl_E ===
                                                                4
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Grade 4
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_E" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={5}
                                                              checked={
                                                                childRow.rbl_E ===
                                                                5
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Grade 5
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rbl_E" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              value={99}
                                                              checked={
                                                                childRow.rbl_E ===
                                                                99
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              disabled={
                                                                childRow.isAutoPopulated
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Unknown
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          childRow.E_empty_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.RadioNoSelection
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </>
                                                  </td>
                                                ) : (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      // alignContent: "flex-start",
                                                      textAlign: "center",
                                                      padding: "8px",
                                                      //textAlign: 'start'
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not applicable</b>
                                                    </span>
                                                  </td>
                                                )}

                                                {childRow.rbl_B != null &&
                                                childRow.rbl_B !== 1 ? (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <>
                                                      <div className="">
                                                        {/* double-dig-answer */}
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q63_chk_F_1_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_F_1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Outpatient
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q63_chk_F_2_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_F_2
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Hospital
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rb_F" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.rb_F
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Unknown
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          childRow.F_empty_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.ChkBoxRadNoSelection
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </>
                                                  </td>
                                                ) : (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      // alignContent: "flex-start",
                                                      textAlign: "center",
                                                      padding: "8px",
                                                      //textAlign: 'start'
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not applicable</b>
                                                    </span>
                                                  </td>
                                                )}

                                                {childRow.rbl_B != null &&
                                                childRow.rbl_B !== 1 ? (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <>
                                                      <div className="">
                                                        {/* double-dig-answer */}
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q63_chk_G_1_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_G_1
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Corticosteroids
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q63_chk_G_2_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_G_2
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Anakinra
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q63_chk_G_3_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_G_3
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Tocilizumab
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q63_chk_G_4_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_G_4
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Siltuximab
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              id={childIdx}
                                                              name={
                                                                "q63_chk_G_5_" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.chk_G_5
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Other
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div>
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={childIdx}
                                                              name={
                                                                "q63_rb_G" +
                                                                childIdx +
                                                                "_" +
                                                                idx
                                                              }
                                                              checked={
                                                                childRow.rb_G
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Unknown
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          childRow.G_empty_err
                                                        }
                                                        message={
                                                          AdverseEvents_Msgs.ChkBoxRadNoSelection
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </>
                                                  </td>
                                                ) : (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      // alignContent: "flex-start",
                                                      textAlign: "center",
                                                      padding: "8px",
                                                      //textAlign: 'start'
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not applicable</b>
                                                    </span>
                                                  </td>
                                                )}
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  ),
                                )}

                                {row.q63_neurotoxicity_list.length < 500 &&
                                  row.q63_neurotoxicity_list[
                                    row.q63_neurotoxicity_list.length - 1
                                  ].rbl_B != null &&
                                  row.q63_neurotoxicity_list[
                                    row.q63_neurotoxicity_list.length - 1
                                  ].rbl_B !== 1 && (
                                    <div className="sub-question-bot-sapce-ul mt-2">
                                      <div
                                        className="answer-list-text"
                                        onClick={() => AddQ63Row(idx)}
                                      >
                                        <a>
                                          <img
                                            width="18px"
                                            src="../Assets/images/plus.png"
                                            alt=""
                                          />
                                        </a>
                                        <a className="radio-text-padding">
                                          Click here to add another episode
                                        </a>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </>
                        )}
                    </>
                  )}

                  {/* Q64. */}
                  {row.q64_enterocolitis_list?.length > 0 && isNewEcrfA && (
                    <>
                      <div className="question question-weight">
                        <span>Q64.</span>
                        <span className="quest-text-pad">Enterocolitis</span>
                      </div>
                      <div>
                        <div className="dependent-section">
                          {row.q64_enterocolitis_list.map(
                            (childRow, childIdx) => (
                              <div className="loop-section-ul" key={childIdx}>
                                <div className="loop-head">
                                  <span className="question-weight">
                                    {GetOrdinal(childIdx + 1)} Episode
                                  </span>
                                  {childIdx !== 0 && (
                                    <div className="delete-btn-div">
                                      <img
                                        width="16px"
                                        src="../Assets/images/Icon-material-delete.png"
                                        alt=""
                                        onClick={() =>
                                          DeleteQ64Row(idx, childIdx)
                                        }
                                      />
                                    </div>
                                  )}
                                </div>

                                <div className="">
                                  <div
                                    className="sub-question grid-overflow"
                                    style={{ overflowX: "auto" }}
                                  >
                                    <table
                                      style={{
                                        border: "1px solid black",
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Treatment
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Date of onset
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Earliest date of improvement
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Date of resolution
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Interventions received
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Severity
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <span>
                                              {getCohortTreatmentDisplayName(
                                                row.cohortTreatmentId,
                                              )}
                                            </span>
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div className="">
                                              {childIdx === 0 && (
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={childIdx}
                                                      name={
                                                        "q64_rbl_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        childRow.q64_rbl_B === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      No events occurred
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q64_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      childRow.q64_rbl_B === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event occurred on:{" "}
                                                    <DatePickerComponent
                                                      ctrlId={
                                                        "q64_date_B" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      optionId={childIdx}
                                                      date={childRow.q64_date_B}
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en"
                                                    />
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q64_rbl_B" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      childRow.q64_rbl_B === 99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event occurred but onset
                                                    unknown
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                            <ErrorField
                                              show={childRow.q64BEmptyError}
                                              message={
                                                AdverseEvents_Msgs.RadioNoSelection
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={childRow.q64BDateEmptyError}
                                              message={
                                                AdverseEvents_Msgs.OnsetDtEmpty
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q64BDateEqualPrevError
                                              }
                                              message={
                                                AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q64BDateInvalidError
                                              }
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q64BDateBeforeIndexDateError
                                              }
                                              message={
                                                AdverseEvents_Msgs.DateBeforeIndex
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q64BDateAfterCDateError
                                              }
                                              message={
                                                AdverseEvents_Msgs.EnterocolitiesDateAfterEarlyImp
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q64BDateAfterResolutionDateError
                                              }
                                              message={
                                                AdverseEvents_Msgs.EntOnsetAfterResolution
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q64BDateAfterAEDateError
                                              }
                                              message={
                                                AdverseEvents_Msgs.EntOnsetAfterAEEndDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </td>

                                          {childRow.q64_rbl_B != null &&
                                          childRow.q64_rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div className="">
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.q64_rbl_C ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        The patient did not
                                                        experience improvement
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          childRow.q64_rbl_C ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Earliest improvement
                                                        occurred on:{" "}
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "q64_date_C" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          optionId={childIdx}
                                                          date={
                                                            childRow.q64_date_C
                                                          }
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en"
                                                        />
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          childRow.q64_rbl_C ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Improvement occurred but
                                                        date unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_rbl_C" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          childRow.q64_rbl_C ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown whether the
                                                        patient experienced
                                                        improvement or not
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={childRow.q64CEmptyError}
                                                  message={
                                                    AdverseEvents_Msgs.RadioNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q64CDateEmptyError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.EarlyImpDtEmpty
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q64CDateInvalidError
                                                  }
                                                  message={
                                                    CommonError_Msgs.InvalidDate
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q64CDateBeforeError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.EntImpDateAfterOnsetAndIndex
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q64CDateAfterResolutionDateError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.EntOnsetAfterResolution
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q64CDateAfterAEDateError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.EntOnsetAfterAEEndDate
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                textAlign: "center",
                                                padding: "8px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}
                                          {childRow.q64_rbl_B != null &&
                                          childRow.q64_rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div className="">
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.q64_rbl_D ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Event did not resolve
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          childRow.q64_rbl_D ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Event resolved on:{" "}
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "q64_date_D" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          optionId={childIdx}
                                                          date={
                                                            childRow.q64_date_D
                                                          }
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en"
                                                        />
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          childRow.q64_rbl_D ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Event resolved but date
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_rbl_D" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          childRow.q64_rbl_D ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown whether event
                                                        resolved or not
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={childRow.q64DEmptyError}
                                                  message={
                                                    AdverseEvents_Msgs.RadioNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q64DDateEmptyError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.ResolutionDtEmpty
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q64DDateInvalidError
                                                  }
                                                  message={
                                                    CommonError_Msgs.InvalidDate
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q64DDateBeforeError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.EntResDateAfterOnsetIndexImp
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    childRow.q64DDateAfterAEDateError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.EntOnsetAfterAEEndDate
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                textAlign: "center",
                                                padding: "8px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}

                                          {childRow.q64_rbl_B != null &&
                                          childRow.q64_rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div className="">
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q64_chk_E_1" +
                                                          "_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.q64_chk_E_1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Supportive care
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q64_chk_E_2" +
                                                          "_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.q64_chk_E_2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Antibiotics
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q64_chk_E_3" +
                                                          "_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.q64_chk_E_3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Surgery
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q64_chk_E_4" +
                                                          "_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.q64_chk_E_4
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        G-CSF
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="checkbox"
                                                        id={childIdx}
                                                        name={
                                                          "q64_chk_E_5" +
                                                          "_" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.q64_chk_E_5
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Other, please specify:
                                                        <textarea
                                                          id={childIdx}
                                                          name={
                                                            "q64_chk_E_othTxt" +
                                                            childIdx +
                                                            "_" +
                                                            idx
                                                          }
                                                          type="text"
                                                          value={
                                                            childRow.q64_chk_E_othTxt
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          maxLength={300}
                                                          className="input-dash"
                                                          style={{
                                                            width: "200px",
                                                          }}
                                                        />
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_E_unk" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        checked={
                                                          childRow.q64_E_unk
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={childRow.q64EEmptyError}
                                                  message={
                                                    AdverseEvents_Msgs.ChkBoxRadNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />

                                                <ErrorField
                                                  show={
                                                    childRow.q64EOtherTxtEmptyError
                                                  }
                                                  message={
                                                    AdverseEvents_Msgs.q59CheckedNoText
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                textAlign: "center",
                                                padding: "8px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}

                                          {childRow.q64_rbl_B != null &&
                                          childRow.q64_rbl_B !== 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <>
                                                <div className="">
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_severity" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          childRow.q64_severity ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Grade 1
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_severity" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          childRow.q64_severity ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Grade 2
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_severity" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          childRow.q64_severity ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Grade 3
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_severity" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          childRow.q64_severity ===
                                                          4
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Grade 4
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_severity" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={5}
                                                        checked={
                                                          childRow.q64_severity ===
                                                          5
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Grade 5
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        id={childIdx}
                                                        name={
                                                          "q64_severity" +
                                                          childIdx +
                                                          "_" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          childRow.q64_severity ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={childRow.q64FEmptyError}
                                                  message={
                                                    AdverseEvents_Msgs.RadioNoSelection
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                // alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ),
                          )}

                          {row.q64_enterocolitis_list.length < 500 &&
                            row.q64_enterocolitis_list[
                              row.q64_enterocolitis_list.length - 1
                            ].q64_rbl_B != null &&
                            row.q64_enterocolitis_list[
                              row.q64_enterocolitis_list.length - 1
                            ].q64_rbl_B !== 1 && (
                              <div className="sub-question-bot-sapce-ul mt-2">
                                <div
                                  className="answer-list-text"
                                  onClick={() =>
                                    AddQ64Row(idx, row.cohortTreatmentId)
                                  }
                                >
                                  <a>
                                    <img
                                      width="18px"
                                      src="../Assets/images/plus.png"
                                      alt=""
                                    />
                                  </a>
                                  <a className="radio-text-padding">
                                    Click here to add another episode
                                  </a>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  )}

                  {/* Q65. */}
                  {row.q65_lymphopenia_list?.length > 0 && isNewEcrfB && (
                    <>
                      <div className="question question-weight">
                        <span>Q65.</span>
                        <span className="quest-text-pad">Lymphopenia</span>
                      </div>
                      <div className="dependent-section">
                        {(() => {
                          const warnings =
                            q65Warnings?.[row.cohortTreatmentId] || {};

                          return (
                            <>
                              <ErrorField
                                show={warnings?.q26Discontinuation}
                                message={
                                  AdverseEvents_Msgs.LymQ26WarningMessage
                                }
                                style={{ padding: "0 0 10px" }}
                              />

                              <ErrorField
                                show={warnings?.q38DoseChange}
                                message={
                                  AdverseEvents_Msgs.LymQ381AWarningMessage
                                }
                                style={{ padding: "0 0 10px" }}
                              />

                              <ErrorField
                                show={warnings?.q43SteroidUse}
                                message={
                                  AdverseEvents_Msgs.LymQ432AWarningMessage
                                }
                                style={{ padding: "0 0 10px" }}
                              />
                            </>
                          );
                        })()}
                        {row.q65_lymphopenia_list.map((childRow, childIdx) => (
                          <div className="loop-section-ul" key={childIdx}>
                            <div className="loop-head">
                              <span className="question-weight">
                                {GetOrdinal(childIdx + 1)} Episode
                              </span>
                              {childIdx !== 0 && (
                                <div className="delete-btn-div">
                                  <img
                                    width="16px"
                                    src="../Assets/images/Icon-material-delete.png"
                                    alt=""
                                    onClick={() => DeleteQ65Row(idx, childIdx)}
                                  />
                                </div>
                              )}
                            </div>

                            <div className="">
                              <div
                                className="sub-question grid-overflow"
                                style={{ overflowX: "auto" }}
                              >
                                <table
                                  style={{
                                    border: "1px solid black",
                                    borderCollapse: "collapse",
                                    width: "100%",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        Treatment
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        Date of onset
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        Date of resolution
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        Severity
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <span>
                                          {getCohortTreatmentDisplayName(
                                            row.cohortTreatmentId,
                                          )}
                                        </span>
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <div className="">
                                          {childIdx === 0 && (
                                            <div>
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={childIdx}
                                                  name={
                                                    "q65_rbl_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    childRow.q65_rbl_B === 1
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  No events occurred
                                                </span>
                                              </label>
                                            </div>
                                          )}
                                          <div>
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                id={childIdx}
                                                name={
                                                  "q65_rbl_B" +
                                                  childIdx +
                                                  "_" +
                                                  idx
                                                }
                                                value={2}
                                                checked={
                                                  childRow.q65_rbl_B === 2
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />
                                              <span className="radio-text-padding">
                                                Event occurred on:{" "}
                                                <DatePickerComponent
                                                  ctrlId={
                                                    "q65_date_B" +
                                                    childIdx +
                                                    "_" +
                                                    idx
                                                  }
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  optionId={childIdx}
                                                  date={childRow.q65_date_B}
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en"
                                                />
                                              </span>
                                            </label>
                                          </div>
                                          <div>
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                id={childIdx}
                                                name={
                                                  "q65_rbl_B" +
                                                  childIdx +
                                                  "_" +
                                                  idx
                                                }
                                                value={99}
                                                checked={
                                                  childRow.q65_rbl_B === 99
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />
                                              <span className="radio-text-padding">
                                                Event occurred but onset unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                        <ErrorField
                                          show={childRow.q65BEmptyError}
                                          message={
                                            AdverseEvents_Msgs.RadioNoSelection
                                          }
                                          style={{
                                            paddingLeft: "0px",
                                          }}
                                        />
                                        <ErrorField
                                          show={childRow.q65BDateEmptyError}
                                          message={
                                            AdverseEvents_Msgs.OnsetDtEmpty
                                          }
                                          style={{
                                            paddingLeft: "0px",
                                          }}
                                        />
                                        <ErrorField
                                          show={childRow.q65BDateEqualPrevError}
                                          message={
                                            AdverseEvents_Msgs.DtSameAsPrevEpisodes
                                          }
                                          style={{
                                            paddingLeft: "0px",
                                          }}
                                        />
                                        <ErrorField
                                          show={childRow.q65BDateInvalidError}
                                          message={CommonError_Msgs.InvalidDate}
                                          style={{
                                            paddingLeft: "0px",
                                          }}
                                        />
                                        <ErrorField
                                          show={
                                            childRow.q65BDateBeforeIndexDateError
                                          }
                                          message={
                                            AdverseEvents_Msgs.DateBeforeIndex
                                          }
                                          style={{
                                            paddingLeft: "0px",
                                          }}
                                        />
                                        <ErrorField
                                          show={
                                            childRow.q65BDateAfterAEDateError
                                          }
                                          message={
                                            AdverseEvents_Msgs.LymOnsetAfterAEEndDate
                                          }
                                          style={{
                                            paddingLeft: "0px",
                                          }}
                                        />
                                      </td>

                                      {childRow.q65_rbl_B != null &&
                                      childRow.q65_rbl_B !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <>
                                            <div className="">
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q65_rbl_C" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      childRow.q65_rbl_C === 1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event did not resolve
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q65_rbl_C" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      childRow.q65_rbl_C === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event resolved on:{" "}
                                                    <DatePickerComponent
                                                      ctrlId={
                                                        "q65_date_C" +
                                                        childIdx +
                                                        "_" +
                                                        idx
                                                      }
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      optionId={childIdx}
                                                      date={childRow.q65_date_C}
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en"
                                                    />
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q65_rbl_C" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={3}
                                                    checked={
                                                      childRow.q65_rbl_C === 3
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Event resolved but date
                                                    unknown
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q65_rbl_C" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      childRow.q65_rbl_C === 99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Unknown whether event
                                                    resolved or not
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                            <ErrorField
                                              show={childRow.q65CEmptyError}
                                              message={
                                                AdverseEvents_Msgs.RadioNoSelection
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={childRow.q65CDateEmptyError}
                                              message={
                                                AdverseEvents_Msgs.ResolutionDtEmpty
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q65CDateInvalidError
                                              }
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q65CDateBeforeError
                                              }
                                              message={
                                                AdverseEvents_Msgs.LymResDateAfterOnsetIndexImp
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                childRow.q65CDateAfterAEDateError
                                              }
                                              message={
                                                AdverseEvents_Msgs.LymOnsetAfterAEEndDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            textAlign: "center",
                                            padding: "8px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}

                                      {childRow.q65_rbl_B != null &&
                                      childRow.q65_rbl_B !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <>
                                            <div className="">
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q65_severity" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      childRow.q65_severity ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Grade 1
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q65_severity" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      childRow.q65_severity ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Grade 2
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q65_severity" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={3}
                                                    checked={
                                                      childRow.q65_severity ===
                                                      3
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Grade 3
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q65_severity" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={4}
                                                    checked={
                                                      childRow.q65_severity ===
                                                      4
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Grade 4
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q65_severity" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={5}
                                                    checked={
                                                      childRow.q65_severity ===
                                                      5
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Grade 5
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={childIdx}
                                                    name={
                                                      "q65_severity" +
                                                      childIdx +
                                                      "_" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      childRow.q65_severity ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                            <ErrorField
                                              show={childRow.q65DEmptyError}
                                              message={
                                                AdverseEvents_Msgs.RadioNoSelection
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            textAlign: "center",
                                            padding: "8px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ))}

                        {row.q65_lymphopenia_list.length < 500 &&
                          row.q65_lymphopenia_list[
                            row.q65_lymphopenia_list.length - 1
                          ].q65_rbl_B != null &&
                          row.q65_lymphopenia_list[
                            row.q65_lymphopenia_list.length - 1
                          ].q65_rbl_B !== 1 && (
                            <div className="sub-question-bot-sapce-ul mt-2">
                              <div
                                className="answer-list-text"
                                onClick={() =>
                                  AddQ65Row(idx, row.cohortTreatmentId)
                                }
                              >
                                <a>
                                  <img
                                    width="18px"
                                    src="../Assets/images/plus.png"
                                    alt=""
                                  />
                                </a>
                                <a className="radio-text-padding">
                                  Click here to add another episode
                                </a>
                              </div>
                            </div>
                          )}
                      </div>
                    </>
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="survey-section-content-foot">
        <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
      </div>
    </div>
  );
};

export default AdverseEvents;

const Q59ProphylacticTherapeutic = ({
  parentIndex,
  childIdx,
  name,
  pChecked,
  sChecked,
  HandleRepeaterFieldChange,
  error,
}) => {
  return (
    <div className="radio-text-padding marginLeft15">
      <label className="long-text-option">
        <input
          type="checkbox"
          id={childIdx}
          name={name + "P_" + childIdx + "_" + parentIndex}
          checked={pChecked}
          onChange={HandleRepeaterFieldChange}
        />
        <span className="radio-text-padding">Prophylactic</span>
      </label>
      <label className="long-text-option">
        <input
          type="checkbox"
          id={childIdx}
          name={name + "T_" + childIdx + "_" + parentIndex}
          checked={sChecked}
          onChange={HandleRepeaterFieldChange}
        />
        <span className="radio-text-padding">Therapeutic</span>
      </label>
      <ErrorField
        show={error}
        message={AdverseEvents_Msgs.ChkBoxRadNoSelection}
        style={{ paddingLeft: "0px" }}
      />
    </div>
  );
};
